webpackJsonp([1],Array(31).concat([
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clientesurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return comprasurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return detallecomprastemporalesurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facturaurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cotizacionurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return devolucionesurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return kilometrajeurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return kilometrajevendedorurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return productourl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return urlpresentaciones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return lineafacturaurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return lineacotizacion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return rutas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return usuarios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return proveedoresurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ubicacionrutas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return vehiculos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return extracciones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return caja; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tipoextracciones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return lineanotacreditourl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return cuadrarrepartourl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ubicacioncuadreurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return notacreditourl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return cuadrarcajareparto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return reporte; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return bancos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return revisionurl; });
var baseurl = 'https://a.distribuidoraemanuel.com.gt';

var clientesurl = baseurl + '/apiventas/clientes/';
var comprasurl = baseurl + '/apicompras/comprastemporales/';
var detallecomprastemporalesurl = baseurl + '/apicompras/detallecomprastemporales/';
var facturaurl = baseurl + '/apiventas/factura/';
var cuadrarcajareparto = baseurl + '/apiventas/cuadrarreporte/';
var cotizacionurl = baseurl + '/apiventas/cotizacion/';
var cuadrarrepartourl = baseurl + '/apiventas/cuadrarreparto/';
var ubicacioncuadreurl = baseurl + '/apiventas/ubicacioncuadre/';
var reporte = baseurl + '/apireportes/';
var devolucionesurl = baseurl + '/apiventas/reportedevolucion/';
var kilometrajeurl = baseurl + '/apivehiculos/kilometraje/';
var revisionurl = baseurl + '/apivehiculos/revision/';
var kilometrajevendedorurl = baseurl + '/apivehiculos/kilometrajevendedor/';
var productourl = baseurl + '/apicatalogos/producto/';
var urlpresentaciones = baseurl + '/apicatalogos/presentacion/?limit=300';
var lineafacturaurl = baseurl + '/apiventas/lineafactura/';
var lineacotizacion = baseurl + '/apiventas/lineacotizacion/';
var rutas = baseurl + '/apicatalogos/rutas/';
var bancos = baseurl + '/apicatalogos/bancos/';
var usuarios = baseurl + '/apicatalogos/usuarios/';
var proveedoresurl = baseurl + '/apicompras/proveedor/';
var ubicacionrutas = baseurl + '/apicatalogos/ubicacionruta/';
var vehiculos = baseurl + '/apivehiculos/vehiculos/';
var extracciones = baseurl + '/apicaja/extraercaja/';
var caja = baseurl + '/apicaja/caja/';
var tipoextracciones = baseurl + '/apicaja/tipoextraccion/';
var lineanotacreditourl = baseurl + '/apiventas/lineanotacredito/';
var notacreditourl = baseurl + '/apiventas/notacredito/';



/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  Unidades: function Unidades(num) {
    switch (num) {
      case 1:
        return 'UN';
      case 2:
        return 'DOS';
      case 3:
        return 'TRES';
      case 4:
        return 'CUATRO';
      case 5:
        return 'CINCO';
      case 6:
        return 'SEIS';
      case 7:
        return 'SIETE';
      case 8:
        return 'OCHO';
      case 9:
        return 'NUEVE';
    }

    return '';
  },
  Decenas: function Decenas(num) {
    var decena = Math.floor(num / 10);
    var unidad = num - decena * 10;
    switch (decena) {
      case 1:
        switch (unidad) {
          case 0:
            return 'DIEZ';
          case 1:
            return 'ONCE';
          case 2:
            return 'DOCE';
          case 3:
            return 'TRECE';
          case 4:
            return 'CATORCE';
          case 5:
            return 'QUINCE';
          default:
            return 'DIECI' + this.Unidades(unidad);
        }
      case 2:
        switch (unidad) {
          case 0:
            return 'VEINTE';
          default:
            return 'VEINTI' + this.Unidades(unidad);
        }
      case 3:
        return this.DecenasY('TREINTA', unidad);
      case 4:
        return this.DecenasY('CUARENTA', unidad);
      case 5:
        return this.DecenasY('CINCUENTA', unidad);
      case 6:
        return this.DecenasY('SESENTA', unidad);
      case 7:
        return this.DecenasY('SETENTA', unidad);
      case 8:
        return this.DecenasY('OCHENTA', unidad);
      case 9:
        return this.DecenasY('NOVENTA', unidad);
      case 0:
        return this.Unidades(unidad);
    }
  },
  DecenasY: function DecenasY(strSin, numUnidades) {
    if (numUnidades > 0) {
      return strSin + ' Y ' + this.Unidades(numUnidades);
    }

    return strSin;
  },
  Centenas: function Centenas(num) {
    var centenas = Math.floor(num / 100);
    var decenas = num - centenas * 100;

    switch (centenas) {
      case 1:
        if (decenas > 0) {
          return 'CIENTO ' + this.Decenas(decenas);
        }
        return 'CIEN';
      case 2:
        return 'DOSCIENTOS ' + this.Decenas(decenas);
      case 3:
        return 'TRESCIENTOS ' + this.Decenas(decenas);
      case 4:
        return 'CUATROCIENTOS ' + this.Decenas(decenas);
      case 5:
        return 'QUINIENTOS ' + this.Decenas(decenas);
      case 6:
        return 'SEISCIENTOS ' + this.Decenas(decenas);
      case 7:
        return 'SETECIENTOS ' + this.Decenas(decenas);
      case 8:
        return 'OCHOCIENTOS ' + this.Decenas(decenas);
      case 9:
        return 'NOVECIENTOS ' + this.Decenas(decenas);
    }

    return this.Decenas(decenas);
  },
  Seccion: function Seccion(num, divisor, strSingular, strPlural) {
    var cientos = Math.floor(num / divisor);
    var resto = num - cientos * divisor;

    var letras = '';

    if (cientos > 0) {
      if (cientos > 1) {
        letras = this.Centenas(cientos) + ' ' + strPlural;
      } else {
        letras = strSingular;
      }
    }

    if (resto > 0) {
      letras += '';
    }

    return letras;
  },
  Miles: function Miles(num) {
    var divisor = 1000;
    var cientos = Math.floor(num / divisor);
    var resto = num - cientos * divisor;

    var strMiles = this.Seccion(num, divisor, 'UN MIL', 'MIL');
    var strCentenas = this.Centenas(resto);

    if (strMiles === '') {
      return strCentenas;
    }

    return strMiles + ' ' + strCentenas;
  },
  Millones: function Millones(num) {
    var divisor = 1000000;
    var cientos = Math.floor(num / divisor);
    var resto = num - cientos * divisor;

    var strMillones = this.Seccion(num, divisor, 'UN MILLON DE', 'MILLONES DE');
    var strMiles = this.Miles(resto);

    if (strMillones === '') {
      return strMiles;
    }

    return strMillones + ' ' + strMiles;
  },
  NumeroALetras: function NumeroALetras(num, currency) {
    currency = currency || {};
    var data = {
      numero: num,
      enteros: Math.floor(num),
      centavos: Math.round(num * 100) - Math.floor(num) * 100,
      letrasCentavos: '',
      letrasMonedaPlural: currency.plural || 'PESOS CHILENOS',
      letrasMonedaSingular: currency.singular || 'PESO CHILENO',
      letrasMonedaCentavoPlural: currency.centPlural || 'CHIQUI PESOS CHILENOS',
      letrasMonedaCentavoSingular: currency.centSingular || 'CHIQUI PESO CHILENO'
    };

    if (data.centavos > 0) {
      data.letrasCentavos = 'CON ' + this.centavos(data);
    }
    if (data.enteros === 0) {
      return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
    }
    if (data.enteros === 1) {
      return this.Millones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
    } else {
      return this.Millones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
    }
  },
  centavos: function centavos(data) {
    if (data.centavos === 1) {
      return this.Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
    } else {
      return this.Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
    }
  }
});

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Factura__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Factura___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Factura__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Facturaadd__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Facturaadd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Facturaadd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cliente__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cliente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Cliente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Reporte__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Reporte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Reporte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReporteVentas__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReporteVentas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ReporteVentas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Kilometraje__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Kilometraje___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Kilometraje__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_KilometrajeVendedor__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_KilometrajeVendedor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_KilometrajeVendedor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AnularFacturas__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AnularFacturas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AnularFacturas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Cotizacion__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Cotizacion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Cotizacion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Cotizacionadd__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Cotizacionadd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Cotizacionadd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Buscador__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Buscador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Buscador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Extraccion__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Extraccion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Extraccion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_extraccionadd__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_extraccionadd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_extraccionadd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Cuadrar__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Cuadrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Cuadrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AnularFactura__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AnularFactura___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_AnularFactura__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CompraTemporal__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CompraTemporal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_CompraTemporal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ComprasAdd__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ComprasAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_ComprasAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ReporteDevolucion__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ReporteDevolucion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_ReporteDevolucion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ActualizaUbicacionCliente__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ActualizaUbicacionCliente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_ActualizaUbicacionCliente__);
























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a,
    props: {
      numero: {
        type: Number
      },
      serie: {
        type: String
      }
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a
  }, {
    path: '/comprasadd',
    name: 'CompraAdd',
    component: __WEBPACK_IMPORTED_MODULE_20__components_ComprasAdd___default.a
  }, {
    path: '/compratemporal',
    name: 'CompraTemporal',
    component: __WEBPACK_IMPORTED_MODULE_19__components_CompraTemporal___default.a
  }, {
    path: '/factura',
    name: 'Factura',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Factura___default.a
  }, {
    path: '/facturaadd',
    name: 'Facturaadd',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Facturaadd___default.a
  }, {
    path: '/cotizacionadd',
    name: 'Cotizacionadd',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Cotizacionadd___default.a
  }, {
    path: '/clientes',
    name: 'Clientes',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Cliente___default.a
  }, {
    path: '/buscador',
    name: 'Buscador',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Buscador___default.a
  }, {
    path: '/reportes',
    name: 'Reportes',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Reporte___default.a
  }, {
    path: '/reporteventas',
    name: 'ReporteVentas',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ReporteVentas___default.a
  }, {
    path: '/kilometraje',
    name: 'Kilometraje',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Kilometraje___default.a
  }, {
    path: '/kilometrajevendedor',
    name: 'Kilometraje Vendedor',
    component: __WEBPACK_IMPORTED_MODULE_10__components_KilometrajeVendedor___default.a
  }, {
    path: '/anularfacturas',
    name: 'AnularFacturas',
    component: __WEBPACK_IMPORTED_MODULE_11__components_AnularFacturas___default.a
  }, {
    path: '/cotizacion',
    name: 'Cotizacion',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Cotizacion___default.a
  }, {
    path: '/extraccion',
    name: 'Extraccion',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Extraccion___default.a
  }, {
    path: '/extraccionadd',
    name: 'Extraccionadd',
    component: __WEBPACK_IMPORTED_MODULE_16__components_extraccionadd___default.a
  }, {
    path: '/cuadrar',
    name: 'cuadrar',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Cuadrar___default.a
  }, {
    path: '/anularfactura',
    name: 'anularfactura',
    component: __WEBPACK_IMPORTED_MODULE_18__components_AnularFactura___default.a
  }, {
    path: '/devoluciones',
    name: 'reporte devolucion',
    component: __WEBPACK_IMPORTED_MODULE_21__components_ReporteDevolucion___default.a
  }, {
    path: '/clientes/ubicacion/:id',
    name: 'Actualiza Cliente Ubicacion',
    component: __WEBPACK_IMPORTED_MODULE_22__components_ActualizaUbicacionCliente___default.a
  }],
  mode: 'history'
}));

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_getters__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actions__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations_mutations__ = __webpack_require__(303);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    is_authenticated: false,
    error_authenticate: false,
    messageerror: '',
    messageactual: '',
    messagesuccess: '',
    error: false,
    success: false,
    editcompra: false,
    eliminando: false,
    compras: [],
    compra: {
      fecha_facturacion: '',
      fecha_ingreso: '',
      numerodocumento: null,
      credito: 'false',
      pagada: 'true',
      proveedor: '',
      serie: '',
      cantidad: '',
      totalc: 0
    },
    lineacompra: {
      compra: { detallescompratemporal: [] },
      producto: '',
      cantidad: '',
      precio: '',
      precio_compra: '',
      presentacion: 7 },

    dialog: false,
    vehiculo: '',
    error_cliente: false,
    has_factura: false,
    has_cotizacion: false,
    fcantidad: 1,
    producto: { presentacion: '', barra: '', producto: 'producto' },
    facturas: [],
    cotizaciones: [],
    clientes: [],
    rutas: [],
    bancos: [],
    usuarios: [],
    proveedores: [],
    vehiculos: [],
    lineas: [],
    lineascotizacion: [],
    listado: { lista: {} },
    factura: { usuario: { username: '' }, credito: false, id: 1 },
    kilometrajes: [],
    kilometrajesvendedor: [],
    akilometraje: { 'fecha': '', 'kilometraje': '', 'vehiculo': {}, 'kilometraje_inicial': '', 'total_facturas': 0, 'comentario': '' },
    akilometrajevendedor: { 'kilometraje_inicial': '', 'kilometraje_final': '', 'usuario': '' },
    list_headers: [],
    cliente: { nit: null,
      nombre: null,
      direccion: null,
      referencia: null,
      municipio: null,
      departamento: null,
      correo: null,
      telefono: null,
      orden: 0,
      dia: 1,
      semana: 1,
      latitud: '',
      longitud: '',
      avenida: '',
      calle: '',
      zona: '',
      barrio_aldea: '',
      colonia_caserio: ''
    },
    clientecotizacion: { cliente: '' },
    presentaciones: [],
    listadopresentacion: [],
    idsfacturas: [],
    devoluciones: { productos: [] },
    lineanota: {},
    guardando: false,
    presentacion: {},
    productos: [],
    dia: null,
    ruta: { nombre: null },
    usuario: { username: null },
    semana: null,
    desde: null,
    hasta: null,
    tipo: '',
    vender_bodega: false,
    extracciones: [],
    tiposextracciones: [],
    activadorcliente: true,
    caja: {}
  },
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations_mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions_actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters_getters__["a" /* default */]
}));

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);










__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (localStorage.getItem('token') || to.name.toLowerCase() === 'login') {
    next();
  } else {
    next({ path: '/login' });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
  load: {
    key: 'AIzaSyCCBtsl0lxjLoyBrPATwjJjWat-zwpfsQ0',
    libraries: 'places'
  }
});

var formatDate = function formatDate(value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_5_moment___default()(String(value)).format('DD/MM/YYYY hh:mm');
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDate', formatDate);
var formatDate2 = function formatDate2(value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_5_moment___default()(String(value)).format('DD/MM/YYYY');
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDate2', formatDate2);

var formatFechaVencimiento = function formatFechaVencimiento(value) {
  if (!value || value === 'SIN/F') return 'SIN/F';
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(String(value)).format('DD/MM/YYYY');
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatFechaVencimiento', formatFechaVencimiento);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_index__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pusher_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pusher_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pusher_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__ = __webpack_require__(31);








var socket = new __WEBPACK_IMPORTED_MODULE_6_pusher_js___default.a('0f66b39deba2f0946ccb', {
  cluster: 'us2',
  encrypted: true,
  enabledTransports: ['ws']
});



__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/api-token-auth/', { username: payload.username, password: payload.password
    }).then(function (response) {
      console.log(response.body);
      localStorage.setItem('usuario', payload.username);
      localStorage.setItem('tipo', response.body.tipo);
      localStorage.setItem('puede_vender_bodega', response.body.puede_vender_bodega);
      commit('actualizartipo', response.body.tipo);
      commit('actualizarbodega', response.body.puede_vender_bodega);
      commit('redirect', response.body.token);
      socket.connect();
      var channel = socket.subscribe('my-channel');
      channel.bind('my-event', function (data) {
        alert(data.message);
      });
    }, function (response) {
      commit('error_login');
    });
  },
  logout: function logout(_ref2) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/base/logout', { params: { token: localStorage.getItem('token') } }).then(function (response) {
      commit('resetfactura');
      commit('redirectlogout');
      socket.disconnect();
    }, function (response) {
      localStorage.removeItem('usuario');
      commit('resetfactura');
      commit('redirectlogout');
    });
  },
  getfacturas: function getfacturas(_ref3) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('acturalizarfacturas', response.body);
    }, function (response) {
      console.log('');
    });
  },
  getCompras: function getCompras(_ref4) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["c" /* comprasurl */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarcompras', response.body);
      console.log(response.body);
    }, function (response) {
      console.log('');
    });
  },
  getkilometraje: function getkilometraje(_ref5) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["d" /* kilometrajeurl */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarkilometraje', response.body);
    }, function (response) {
      console.log('');
    });
  },
  getkilometrajevendedor: function getkilometrajevendedor(_ref6) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["e" /* kilometrajevendedorurl */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarkilometrajevendedor', response.body);
    }, function (response) {
      console.log('');
    });
  },
  getpresentaciones: function getpresentaciones(_ref7) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["f" /* urlpresentaciones */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('setPresentaciones', response.body.results);
    }, function (response) {
      console.log('');
    });
  },
  buscarclientes: function buscarclientes(_ref8, nit) {
    var commit = _ref8.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */], { params: { search: nit }, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      if (response.body.count === 0) {
        commit('error_searchcliente', true);
        commit('actualizarcliente', { nombre: '', direccion: '' });
      }
      var data = response.body.results[0];
      data['cliente'] = response.url;
      commit('actualizarcliente', data);
      commit('error_searchcliente', false);
    }, function (response) {
      console.log('');
    });
  },
  crearcliente: function crearcliente(_ref9, payload) {
    var _this = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                alert('se guardo existosamente');
                commit('actualizarcliente', response.body);
                commit('actualizardialog', false);
                commit('error_searchcliente', false);
                commit('setactivadorcliente', false);
              }, function (response) {
                alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.bodyText));
                commit('setactivadorcliente', false);
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  crearclientecotizacion: function crearclientecotizacion(_ref10, payload) {
    var _this2 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["h" /* cotizacionurl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('actualizarclientecotizacion', response.body);
                commit('actualizarestadocotizacion', true);
              }, function (response) {
                console.log(response);
                alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.body));
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  crearfactura: function crearfactura(_ref11, payload) {
    var _this3 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var permissionStatus;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return navigator.permissions.query({ name: 'geolocation' });

            case 2:
              permissionStatus = _context3.sent;

              if (!(permissionStatus.state === 'denied')) {
                _context3.next = 8;
                break;
              }

              alert('Debes otorgar permiso de ubicación para continuar.');
              return _context3.abrupt('return');

            case 8:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */], { 'cliente': payload }, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('actualizarfactura', response.body);
                commit('actualizarestadofactura', true);
                __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/facturaadd');
                if (navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition(function (position) {
                    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["i" /* ubicacionrutas */], {
                      'fecha': new Date(response.body.fecha).toISOString().substring(0, 10),
                      'vendedor': response.body.usuario.id,
                      'hora_factura': new Date(response.body.fecha).toTimeString(),
                      'hora_localizacion': new Date(response.body.fecha).toTimeString(),
                      'lugar': response.body.cliente_name,
                      'cliente': response.body.cliente,
                      'coordenadas': position.coords.latitude + ',' + position.coords.longitude
                    }, { headers: {
                        'Authorization': 'Token ' + localStorage.getItem('token')
                      } }).then(function (response) {
                      console.log('');
                    });
                  });
                } else {
                  alert('Geolocation is not supported by this browser.');
                }
              }, function (response) {
                alert(response.body['non_field_errors']);
                commit('error_searchcliente', true);
              });

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  crearkilometraje: function crearkilometraje(_ref12, payload) {
    var _this4 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["d" /* kilometrajeurl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('agregarkilometraje', response.body);
                window.location.reload();
                commit('actualizarakilometraje', { fecha: '', vehiculo: '', kilometraje: '' });
              }, function (response) {
                alert(response.body['non_field_errors']);
                commit('error_searchcliente', true);
              });

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  crearkilometrajevendedor: function crearkilometrajevendedor(_ref13, payload) {
    var _this5 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              console.log(payload);
              if (payload.id) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["e" /* kilometrajevendedorurl */] + payload.id + '/', payload, { headers: {
                    'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                  commit('actualizarkilometrajevendedoretit', response.body);
                  commit('actualizarakilometrajevendedor', { kilometraje_inicial: '', kilometraje_final: '', usuario: '' });
                }, function (response) {
                  alert(response.body['non_field_errors']);
                  commit('error_searchcliente', true);
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["e" /* kilometrajevendedorurl */], payload, { headers: {
                    'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                  commit('agregarkilometrajevendedor', response.body);
                  commit('actualizarakilometrajevendedor', { fecha: '', kilometraje_inicial: '', kilometraje_final: '', usuario: '' });
                }, function (response) {
                  alert(response.body['non_field_errors']);
                  commit('error_searchcliente', true);
                });
              }

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  crearCompra: function crearCompra(_ref14, payload) {
    var _this6 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["c" /* comprasurl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('setcompra', response.body);
                commit('seteditcompra', true);
                commit('setcompralinea', response.body.id);
                alert('guardado exitosamente');
              }, function (response) {
                alert(response.bodyText);
              });

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  crearLineaCompra: function crearLineaCompra(_ref15, payload) {
    var _this7 = this;

    var commit = _ref15.commit,
        state = _ref15.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              payload['compra'] = state.compra.id;
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["j" /* detallecomprastemporalesurl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('setaddlineacompra', response.body);
                commit('limpiarlineacompra', {});
                commit('actualizardialog', false);
                commit('aumentartotalc', payload);
                alert('guardado exitosamente');
              }, function (response) {
                alert(response.bodyText);
              });

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  crearfactura2: function crearfactura2(_ref16, payload) {
    var _this8 = this;

    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */], { 'cliente': payload }, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('resetfactura');
                commit('actualizarfactura', response.body);
                commit('actualizarestadofactura', true);
                dispatch('getcliente', response.body.cliente);
              }, function (response) {
                commit('error_searchcliente', true);
              });

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  buscarproducto: function buscarproducto(_ref17, params) {
    var commit = _ref17.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["k" /* productourl */], { params: { search: params.producto, bodega: params.bodega }, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      if (response.body.count === 0) {
        commit('actualizarproducto', { producto: '', listaprecios: [], precio_costo: '', barra: '' });
      }
      var producto = response.body.results[0];
      commit('actualizarproducto', producto);
      commit('actualizarpresentaciones', []);
      commit('actualizarpresentaciones', { 'presentacion': 'unidad', 'unidades': 1 });
      commit('actualizarpresentaciones', producto.presentacion);
      commit('actualizarpresentacion', { 'presentacion': 'unidad', 'unidades': 1 });
      var lista = producto.listaprecios.find(function (dato) {
        return dato.lista.nombre.toLowerCase() === 'detalle' || dato.lista.nombre.toLowerCase() === 'l6' || dato.lista.nombre.toLowerCase() === 'l8';
      });
      commit('updateselect', lista);
    }, function (response) {
      commit('actualizarproducto', { producto: '', listaprecios: [], precio_costo: '', codigo: '', barra: '' });
    });
  },
  insertarlinea: function insertarlinea(_ref18, payload) {
    var _this9 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["l" /* lineafacturaurl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('actualizarlinea', response.body);
                commit('actualizarpresentacion', {});
                commit('actualizarpresentaciones', []);
                commit('actualizarproducto', { producto: '', listaprecios: [], precio_costo: '', codigo: ' ', barra: ' ' });
                commit('limpiarbarra', '');
                commit('setguardando', false);
                commit('actualizarerror', false);
                commit('actualizarmessage_error', '');
              }, function (response) {
                console.log(response);
                commit('setguardando', false);
                commit('actualizarerror', true);
                if (response.body['non_field_errors']) {
                  commit('actualizarmessage_error', response.body['non_field_errors'][0]);
                } else {
                  commit('actualizarmessage_error', response.bodyText);
                }
              });

            case 2:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  insertarlineanotacredito: function insertarlineanotacredito(_ref19, payload) {
    var _this10 = this;

    var commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              payload['nota_credito'] = 100;
              return _context10.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["m" /* lineanotacreditourl */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('setLineaNota', response.body.nota_credito);
                if (response.body.nota_credito.motivo_anulacion) {
                  'pass';
                } else {
                  commit('actualizardialog', true);
                }
              }, function (response) {
                console.log(response);
                commit('actualizarerror', true);
                if (response.body['non_field_errors']) {
                  commit('actualizarmessage_error', response.body['non_field_errors'][0]);
                } else {
                  commit('actualizarmessage_error', response.bodyText);
                }
              }));

            case 2:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  insertarlineacotizacion: function insertarlineacotizacion(_ref20, payload) {
    var _this11 = this;

    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["n" /* lineacotizacion */], payload, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('actualizarlineacotizacion', response.body);
                commit('actualizarpresentacion', {});
                commit('actualizarpresentaciones', []);
                commit('actualizarproducto', { producto: '', listaprecios: [], precio_costo: '', codigo: '', barra: '' });
                commit('actualizarerror', false);
                commit('actualizarmessage_error', '');
              }, function (response) {
                console.log(response);
                commit('actualizarerror', true);
                commit('actualizarmessage_error', response.body['non_field_errors'][0]);
              });

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  actualizartipofactura: function actualizartipofactura(_ref21, payload) {
    var commit = _ref21.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.factura.id + '/', { credito: payload.factura.credito, cliente: payload.factura.cliente }, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarfactura', response.body);
      if (response.body.message.length > 0) {
        alert(response.body.message);
      }
    }, function (response) {
      payload.factura.credito = false;
      commit('actualizarfactura', payload);
      alert(response.bodyText);
    });
  },
  actualizarcomentario: function actualizarcomentario(_ref22, payload) {
    var commit = _ref22.commit,
        state = _ref22.state;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.factura.id + '/', { observaciones: payload.factura.observaciones,
      cliente: payload.factura.cliente,
      observacionesmotivo: payload.factura.observacionesmotivo }, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarfactura', response.body);
    }, function (response) {
      alert(response.body.non_field_errors);
      payload.factura.observaciones = state.messageactual;
      commit('actualizarfactura', payload);
    });
  },
  actualizarnotacredito: function actualizarnotacredito(_ref23, payload) {
    var commit = _ref23.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["o" /* notacreditourl */] + payload.id + '/', { motivo_anulacion: payload.motivo }, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizardialog', false);
    }, function (response) {});
  },
  actualizarenvio: function actualizarenvio(_ref24, payload) {
    var commit = _ref24.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.factura.id + '/', { envio: payload.factura.envio, cliente: payload.factura.cliente }, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarfactura', response.body);
    }, function (response) {
      payload.envio = false;
      commit('actualizarfactura', payload);
    });
  },
  actualizaranulado: function actualizaranulado(_ref25, payload) {
    var _this12 = this;

    var commit = _ref25.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.factura.id + '/', { rechazado: payload.factura.anulado, motivo_anulacion: payload.factura.motivo_anulacion, cliente: payload.factura.cliente }, { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('actualizarfactura', response.body);
              }, function (response) {
                payload.anulado = false;
                commit('actualizarfactura', payload);
              });

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  actualizarbodega: function actualizarbodega(_ref26, payload) {
    var commit = _ref26.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.factura.id + '/', { bodega: payload.factura.bodega, cliente: payload.factura.cliente }, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarfactura', response.body);
    }, function (response) {
      commit('actualizarfactura', payload);
    });
  },
  eliminarlineafactura: function eliminarlineafactura(_ref27, payload) {
    var _this13 = this;

    var commit = _ref27.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["l" /* lineafacturaurl */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('eliminarlinea', payload);
                commit('setEliminando', false);
              }, function (response) {
                alert(response.body.non_field_errors);
              });

            case 2:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  eliminarlineacompra: function eliminarlineacompra(_ref28, payload) {
    var _this14 = this;

    var commit = _ref28.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["j" /* detallecomprastemporalesurl */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('disminuirtotalc', payload);
                commit('eliminarlineacompra', payload);
              }, function (response) {
                alert(response.body.non_field_errors);
              });

            case 1:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  eliminarlineacotizacion: function eliminarlineacotizacion(_ref29, payload) {
    var _this15 = this;

    var commit = _ref29.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["n" /* lineacotizacion */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('eliminarlineacotizacion', payload);
              });

            case 1:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  actualizarnumerofactura: function actualizarnumerofactura(_ref30, payload) {
    var _this16 = this;

    var commit = _ref30.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdfgenerationindividual', { params: {
                  id: payload.factura.id
                },
                headers: { 'Authorization': 'Token ' + localStorage.getItem('token') },
                responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.body], { type: 'application/pdf' });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var imprimir = window.open(link.href);
                imprimir.print();
                commit('actualizardialog', false);
                commit('resetfactura');
                __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/facturaadd');
              }, function (response) {
                var string = JSON.parse(new TextDecoder().decode(response.body));
                commit('actualizarerror', true);
                commit('actualizarmessage_error', string.reason);
              });

            case 1:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  imprimirfacturaelectronica: function imprimirfacturaelectronica(_ref31, payload) {
    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;

    console.log(payload);
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdfgenerationindividualelectronica', { params: {
        id: payload.factura.id
      },
      headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      dispatch('checkstatustask', { 'task_id': response.data.data.task_id, 'facturas': response.data.data.facturas });
    }, function (response) {
      var string = JSON.parse(new TextDecoder().decode(response.body));
      commit('actualizarerror', true);
      commit('actualizarmessage_error', string.reason);
    });
  },
  checkstatustask: function checkstatustask(_ref32, payload) {
    var commit = _ref32.commit,
        dispatch = _ref32.dispatch,
        getters = _ref32.getters;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/estadotarea', { params: {
        id: payload.task_id,
        facturas: payload.facturas
      },
      headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      console.log(response);
      if (response.data.data.state === 'PROGRESS') {
        console.log('se ejecuto bien');
      } else if (response.data.data.state === 'PENDING') {
        console.log('por favor espere');
        setTimeout(function () {
          dispatch('checkstatustask', response.data.data);
        }, 1000);
      } else if (response.data.data.state === 'SUCCESS') {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post('http://127.0.0.1:5000/', response.data).then(function (response) {
          var ids = getters.getidfactura;
          dispatch('imprimirfacturaelectronica2', { factura: { id: ids.pop() } });
          commit('setidsfactura', ids);
          commit('actualizardialog', false);
          commit('resetfactura');
          __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/facturaadd');
        }, function (response) {
          alert('ocurrio un error la impresora no está conectada');
        });
      } else if (response.data.data.state === 'FAILURE') {
        console.log('paso algún error');
      } else {
        console.log('no es igual');
        setTimeout(function () {
          dispatch('checkstatustask', response.data.data);
        }, 100);
      }
    }, function (response) {
      alert('ocurrio un erro inesperado ');
    });
  },
  imprimirfacturaelectronica2: function imprimirfacturaelectronica2(_ref33, payload) {
    var commit = _ref33.commit,
        dispatch = _ref33.dispatch;

    console.log(payload);
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdfgenerationindividualelectronica', { params: {
        id: payload.factura.id
      },
      headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      dispatch('checkstatustask', { 'task_id': response.data.data.task_id, 'facturas': response.data.data.facturas });
    }, function (response) {
      var string = JSON.parse(new TextDecoder().decode(response.body));
      commit('actualizarerror', true);
      commit('actualizarmessage_error', string.reason);
    });
  },
  checkstatustask2: function checkstatustask2(_ref34, payload) {
    var commit = _ref34.commit,
        dispatch = _ref34.dispatch;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/estadotarea', { params: {
        id: payload.task_id,
        facturas: payload.facturas
      },
      headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      console.log(response);
      if (response.data.data.state === 'PROGRESS') {
        console.log('se ejecuto bien');
      } else if (response.data.data.state === 'PENDING') {
        console.log('por favor espere');
        setTimeout(function () {
          dispatch('checkstatustask', response.data.data);
        }, 100);
      } else if (response.data.data.state === 'SUCCESS') {
        setTimeout(__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post('http://127.0.0.1:5000/', response.data).then(function (response) {
          alert('finalizado con éxito');
        }, function (response) {
          alert('ocurrio un error la impresora no está conectada');
        }), 500);
      } else if (response.data.data.state === 'FAILURE') {
        console.log('paso algún error');
      } else {
        console.log('no es igual');
        setTimeout(function () {
          dispatch('checkstatustask', response.data.data);
        }, 100);
      }
    }, function (response) {
      alert('ocurrio un erro inesperado ');
    });
  },
  imprimircotizacion: function imprimircotizacion(_ref35, payload) {
    var commit = _ref35.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdfgenerationcotizacion', { params: {
        id: payload.cotizacion.id
      },
      headers: { 'Authorization': 'Token ' + localStorage.getItem('token') },
      responseType: 'arraybuffer' }).then(function (response) {
      var blob = new Blob([response.body], { type: 'application/pdf' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var imprimir = window.open(link.href);
      imprimir.print();
      commit('actualizardialog', false);
      commit('resetcotizacion');
      __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/cotizacionadd');
    }, function (response) {
      var string = JSON.parse(new TextDecoder().decode(response.body));
      commit('actualizarerror', true);
      commit('actualizarmessage_error', string.reason);
    });
  },
  guardarfactura: function guardarfactura(_ref36, payload) {
    var commit = _ref36.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.factura.id + '/', { estado: true }, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('resetfactura');
      __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/facturaadd');
    }, function (response) {
      commit('actualizarerror', true);
      commit('actualizarmessage_error', response.body['non_field_errors'][0]);
    });
  },
  actualizarcompra: function actualizarcompra(_ref37, payload) {
    var commit = _ref37.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["c" /* comprasurl */] + payload.id + '/', payload, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('seteditcompra', true);
      alert('actualizada exitosamente');
    }, function (response) {
      commit('actualizarerror', true);
      commit('actualizarmessage_error', response.body['non_field_errors'][0]);
    });
  },
  guardarcotizacion: function guardarcotizacion(_ref38, payload) {
    var commit = _ref38.commit;

    commit('resetcotizacion');
    __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/cotizacionadd');
  },
  actualizarfacturas: function actualizarfacturas(_ref39, payload) {
    var commit = _ref39.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */], { params: payload, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarlistadofacturas', response.body);
    });
  },
  actualizardevoluciones: function actualizardevoluciones(_ref40, payload) {
    var commit = _ref40.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["p" /* devolucionesurl */], { params: payload, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('setdevoluciones', response.body);
    });
  },
  actualizarcotizaciones: function actualizarcotizaciones(_ref41, payload) {
    var commit = _ref41.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["h" /* cotizacionurl */], { params: payload, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarlistadocotizaciones', response.body);
    });
  },
  actualizarfacturas2: function actualizarfacturas2(_ref42, url) {
    var commit = _ref42.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(url, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarlistadofacturas', response.body);
    });
  },
  eliminarfactura: function eliminarfactura(_ref43, payload) {
    var _this17 = this;

    var commit = _ref43.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["b" /* facturaurl */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('eliminarfactura', payload);
                commit('actualizarestadofactura', false);
                commit('resetfactura');
              }, function (response) {
                alert(response.body.non_field_errors);
              });

            case 1:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  eliminarcompra: function eliminarcompra(_ref44, payload) {
    var _this18 = this;

    var commit = _ref44.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["c" /* comprasurl */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('eliminarcompra', payload);
              }, function (response) {
                alert(response.body.non_field_errors);
              });

            case 1:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  },
  eliminarcotizacion: function eliminarcotizacion(_ref45, payload) {
    var _this19 = this;

    var commit = _ref45.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["h" /* cotizacionurl */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('eliminarcotizacion', payload);
                commit('actualizarestadocotizacion', false);
              });

            case 1:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19);
    }))();
  },
  eliminarextraccion: function eliminarextraccion(_ref46, payload) {
    var _this20 = this;

    var commit = _ref46.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["q" /* extracciones */] + payload.id + '/', { headers: {
                  'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
                commit('eliminarextraccion', payload);
              });

            case 1:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20);
    }))();
  },
  getcliente: function getcliente(_ref47, url) {
    var commit = _ref47.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */] + url + '/', { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      var data = response.body;
      data['cliente'] = response.url;
      commit('actualizarcliente', data);
      commit('error_searchcliente', false);
    }, function (response) {
      commit('error_searchcliente', true);
      commit('actualizarcliente', { nombre: '', direccion: '' });
    });
  },
  getclientes: function getclientes(_ref48) {
    var commit = _ref48.commit,
        state = _ref48.state;
    var clientes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */];

    if (state.dia !== null || state.semana !== null || state.ruta !== null) {
      var payload = { 'dia': state.dia, 'semana': state.semana, ruta: state.ruta.nombre };
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(clientes, { params: payload, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
        var data = response.body;
        data['cliente'] = response.url;
        commit('actualizarclientes', data);
      }, function (response) {
        console.log('');
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(clientes, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
        var data = response.body;
        data['cliente'] = response.url;
        commit('actualizarclientes', data);
      }, function (response) {
        console.log('');
      });
    }
  },
  eliminarcliente: function eliminarcliente(_ref49, payload) {
    var commit = _ref49.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.patch(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */] + payload.id + '/', { eliminado: 'True' }, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('eliminarcliente', payload);
    }, function (response) {
      alert(response.bodyText);
    });
  },
  eliminarkilometraje: function eliminarkilometraje(_ref50, payload) {
    var commit = _ref50.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["d" /* kilometrajeurl */] + payload.id + '/', { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('eliminarkilometraje', payload);
    });
  },
  eliminarkilometrajevendedor: function eliminarkilometrajevendedor(_ref51, payload) {
    var commit = _ref51.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["e" /* kilometrajevendedorurl */] + payload.id + '/', { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('eliminarkilometrajevendedor', payload);
    });
  },
  editarcliente: function editarcliente(_ref52, payload, notify) {
    var commit = _ref52.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */] + payload.id + '/', payload, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      console.log(response);
      commit('actualizardialog', false);
      commit('setactivadorcliente', false);
      commit('limpiarcliente');
      commit('actualizarclientesedit', payload);
      if (notify) {
        alert('Modificado Exitosamente');
      }
    }, function (response) {
      console.log(response);
    });
  },
  editarclientefactura: function editarclientefactura(_ref53, payload) {
    var commit = _ref53.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */] + payload.id + '/', payload, { headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarcliente', response.body);
      alert('Modificado Exitosamente');
    }, function (response) {
      alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.bodyText));
    });
  },
  filter: function filter(_ref54, payload) {
    var commit = _ref54.commit;

    console.log(payload);
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["g" /* clientesurl */], { params: payload, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      var data = response.body;
      console.log(response.url);
      data['cliente'] = response.url;
      commit('actualizarclientes', data);
    }, function (response) {
      console.log('error');
    });
  },
  getrutas: function getrutas(_ref55) {
    var commit = _ref55.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["r" /* rutas */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarrutas', response.body.results);
    });
  },
  getbancos: function getbancos(_ref56) {
    var commit = _ref56.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["s" /* bancos */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarbancos', response.body.results);
    });
  },
  getusuarios: function getusuarios(_ref57) {
    var commit = _ref57.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["t" /* usuarios */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarusuarios', response.body.results);
    });
  },
  getproveedores: function getproveedores(_ref58) {
    var commit = _ref58.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["u" /* proveedoresurl */] + '?limit=1000', { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarproveedores', response.body.results);
    });
  },
  buscarproductos: function buscarproductos(_ref59, params) {
    var commit = _ref59.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["k" /* productourl */], { params: { search: params.producto, bodega: params.bodega }, headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      var producto = response.body.results;
      commit('actualizarproductos', producto);
    }, function (response) {
      commit('actualizarproducto', { producto: '', listaprecios: [], precio_costo: '', codigo: '', barra: '' });
    });
  },
  getvehiculos: function getvehiculos(_ref60) {
    var commit = _ref60.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["v" /* vehiculos */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('actualizarvehiculos', response.body.results);
    });
  },
  requestextracciones: function requestextracciones(_ref61) {
    var commit = _ref61.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["q" /* extracciones */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('setextracciones', response.body.results);
    });
  },
  requesttipoextracciones: function requesttipoextracciones(_ref62) {
    var commit = _ref62.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["w" /* tipoextracciones */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('settipoextracciones', response.body.results);
    });
  },
  requestcaja: function requestcaja(_ref63) {
    var commit = _ref63.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["x" /* caja */], { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('setcaja', response.body.results);
    });
  },
  guardarextraccion: function guardarextraccion(_ref64, payload) {
    var commit = _ref64.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["q" /* extracciones */], payload, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/extraccion');
    }, function (response) {
      alert(response.bodyText);
    });
  },
  guardardevolucion: function guardardevolucion(_ref65, payload) {
    var commit = _ref65.commit;

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_8__plugins_urlsbackend__["p" /* devolucionesurl */], payload, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
      commit('setdevoluciones', {});
      alert(response.bodyText);
    }, function (response) {
      alert(response.bodyText);
    });
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  is_authenticated: function is_authenticated(state) {
    return state.is_authenticated;
  },
  error_authenticated: function error_authenticated(state) {
    return state.error_authenticate || false;
  },
  error: function error(state) {
    return state.error_authenticate || false;
  },
  list_facturas_headers: function list_facturas_headers(state) {
    return state.list_headers;
  },
  cliente: function cliente(state) {
    console.log(state.cliente);
    return state.cliente;
  },
  getguardando: function getguardando(state) {
    return state.guardando;
  },
  getmessageactual: function getmessageactual(state) {
    return state.messageactual;
  },
  getidfactura: function getidfactura(state) {
    return state.idsfacturas;
  },
  listadodevoluciones: function listadodevoluciones(state) {
    return state.devoluciones;
  },
  get_vender_bodega: function get_vender_bodega(state) {
    return state.vender_bodega;
  },
  get_error_searchcliente: function get_error_searchcliente(state) {
    return state.error_cliente;
  },
  factura: function factura(state) {
    return state.factura;
  },
  hasfactura: function hasfactura(state) {
    return state.has_factura;
  },
  hascotizacion: function hascotizacion(state) {
    return state.has_cotizacion;
  },
  producto: function producto(state) {
    return state.producto;
  },
  listado: function listado(state) {
    return state.listado;
  },
  getlineanota: function getlineanota(state) {
    return state.lineanota;
  },
  lineasfactura: function lineasfactura(state) {
    return state.lineas;
  },
  lineascotizacion: function lineascotizacion(state) {
    return state.lineascotizacion;
  },
  cantidad: function cantidad(state) {
    return state.fcantidad;
  },
  presentaciones: function presentaciones(state) {
    return state.presentaciones;
  },
  presentacion: function presentacion(state) {
    return state.presentacion;
  },
  default: function _default(state) {
    return state.producto.listaprecios.find(function (data) {
      return data.lista.nombre.toLowerCase() === 'detalle';
    });
  },
  dialogo: function dialogo(state) {
    return state.dialog;
  },
  vehiculo: function vehiculo(state) {
    return state.vehiculo;
  },
  message_error: function message_error(state) {
    return state.messageerror;
  },
  message_success: function message_success(state) {
    return state.messagesuccess;
  },
  error_numero: function error_numero(state) {
    return state.error;
  },
  success: function success(state) {
    return state.success;
  },
  listadofacturas: function listadofacturas(state) {
    return state.facturas;
  },
  listadocotizaciones: function listadocotizaciones(state) {
    return state.cotizaciones;
  },
  clientes: function clientes(state) {
    return state.clientes;
  },
  clientescotizacion: function clientescotizacion(state) {
    return state.clientecotizacion;
  },
  rutas: function rutas(state) {
    return state.rutas;
  },
  bancos: function bancos(state) {
    return state.bancos;
  },
  usuarios: function usuarios(state) {
    return state.usuarios;
  },
  productos: function productos(state) {
    return state.productos;
  },
  getdia: function getdia(state) {
    return state.dia;
  },
  getruta: function getruta(state) {
    return state.ruta;
  },
  getusuario: function getusuario(state) {
    return state.usuario;
  },
  getBanco: function getBanco(state) {
    return state.banco;
  },
  getBanco2: function getBanco2(state) {
    return state.banco2;
  },
  getBanco3: function getBanco3(state) {
    return state.banco3;
  },
  getsemana: function getsemana(state) {
    return state.semana;
  },
  getdesde: function getdesde(state) {
    return state.desde;
  },
  gethasta: function gethasta(state) {
    return state.hasta;
  },
  gettipo: function gettipo(state) {
    return state.tipo;
  },
  kilometraje: function kilometraje(state) {
    return state.kilometrajes;
  },
  akilometraje: function akilometraje(state) {
    return state.akilometraje;
  },
  kilometrajevendedor: function kilometrajevendedor(state) {
    return state.kilometrajesvendedor;
  },
  akilometrajevendedor: function akilometrajevendedor(state) {
    return state.akilometrajevendedor;
  },
  vehiculos: function vehiculos(state) {
    return state.vehiculos;
  },
  getextracciones: function getextracciones(state) {
    return state.extracciones;
  },
  gettipoextracciones: function gettipoextracciones(state) {
    return state.tiposextracciones;
  },
  getactivadorcliente: function getactivadorcliente(state) {
    return state.activadorcliente;
  },
  getCaja: function getCaja(state) {
    return state.caja;
  },
  getcompras: function getcompras(state) {
    return state.compras;
  },
  getCompra: function getCompra(state) {
    return state.compra;
  },
  getProveedores: function getProveedores(state) {
    return state.proveedores;
  },
  getEditCompra: function getEditCompra(state) {
    return state.editcompra;
  },
  getLineaCompra: function getLineaCompra(state) {
    return state.lineacompra;
  },
  getListadoPresentaciones: function getListadoPresentaciones(state) {
    return state.listadopresentacion;
  },
  getEliminando: function getEliminando(state) {
    return state.eliminando;
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(49);




/* harmony default export */ __webpack_exports__["a"] = ({
  redirect: function redirect(state, payload) {
    if (payload) {
      state.is_authenticated = true;
      window.localStorage.setItem('token', payload);
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/');
    }
  },
  redirectlogout: function redirectlogout(state) {
    state.is_authenticated = false;
    localStorage.removeItem('token');
    state.producto = {};
    state.banco = {};
    state.banco2 = {};
    state.banco3 = {};
    state.lineas = [];
    state.has_factura = [];
    state.factura = { usuario: { username: '' }, credito: false, id: 1 };
    state.compras = [];
    state.cliente = { nit: '' };
    state.clientecotizacion = { nombre: '' };
    state.is_authenticated = false;
    state.error_authenticate = false;
    state.error_cliente = false;
    state.has_factura = false;
    state.vender_bodega = false;
    localStorage.removeItem('puede_vender_bodega');
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
  },
  error_login: function error_login(state) {
    state.error_authenticate = true;
  },
  acturalizarfacturas: function acturalizarfacturas(state, payload) {
    state.facturas.push(payload);
  },
  actualizarcliente: function actualizarcliente(state, payload) {
    var dato = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.cliente, payload);
    state.cliente = dato;
  },
  actualizarclientecotizacion: function actualizarclientecotizacion(state, payload) {
    var dato = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.clientecotizacion, payload);
    state.clientecotizacion = dato;
  },
  actualizarfactura: function actualizarfactura(state, payload) {
    var dato = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.factura, payload);
    state.factura = dato;
  },
  actualizarcompras: function actualizarcompras(state, payload) {
    state.compras = payload;
  },
  actualizarmessageactual: function actualizarmessageactual(state, payload) {
    state.messageactual = payload;
  },
  actualizarkilometraje: function actualizarkilometraje(state, payload) {
    state.kilometrajes = payload;
  },
  actualizarkilometrajevendedor: function actualizarkilometrajevendedor(state, payload) {
    state.kilometrajesvendedor = payload;
  },
  agregarkilometraje: function agregarkilometraje(state, payload) {
    state.kilometrajes.results.push(payload);
  },
  actualizarkilometrajevendedoretit: function actualizarkilometrajevendedoretit(state, payload) {
    var datos = [];
    state.kilometrajesvendedor.results.find(function (dato) {
      if (dato.id === payload.id) {
        datos.push(payload);
      } else {
        datos.push(dato);
      }
    });
  },
  agregarkilometrajevendedor: function agregarkilometrajevendedor(state, payload) {
    state.kilometrajesvendedor.results.push(payload);
  },
  setidsfactura: function setidsfactura(state, payload) {
    state.idsfacturas = payload;
  },
  error_searchcliente: function error_searchcliente(state, error) {
    state.error_cliente = error;
  },
  actualizarestadofactura: function actualizarestadofactura(state, payload) {
    state.has_factura = payload;
  },
  actualizarestadocotizacion: function actualizarestadocotizacion(state, payload) {
    state.has_cotizacion = payload;
  },
  actualizarproducto: function actualizarproducto(state, payload) {
    state.producto = payload;
  },
  limpiarbarra: function limpiarbarra(state, payload) {
    state.producto.barra = payload;
  },
  actualizarbarra: function actualizarbarra(state, payload) {
    state.producto.barra = payload;
  },
  updateselect: function updateselect(state, payload) {
    state.listado = payload;
  },
  actualizarlinea: function actualizarlinea(state, payload) {
    state.lineas.push(payload);
  },
  limpiarlinea: function limpiarlinea(state) {
    state.lineas = [];
  },
  actualizarlineacotizacion: function actualizarlineacotizacion(state, payload) {
    state.lineascotizacion.push(payload);
  },
  limpiarlineacotizacion: function limpiarlineacotizacion(state) {
    state.lineascotizacion = [];
  },
  actualizarpresentaciones: function actualizarpresentaciones(state, payload) {
    if (payload.length === 0) {
      state.presentaciones = [];
    } else {
      state.presentaciones.push(payload);
    }
  },
  actualizarpresentacion: function actualizarpresentacion(state, payload) {
    state.presentacion = payload;
  },
  eliminarlinea: function eliminarlinea(state, payload) {
    var index = state.lineas.indexOf(payload);
    state.lineas.splice(index, 1);
  },
  eliminarlineacotizacion: function eliminarlineacotizacion(state, payload) {
    var index = state.lineascotizacion.indexOf(payload);
    state.lineascotizacion.splice(index, 1);
  },
  actualizardialog: function actualizardialog(state, payload) {
    console.log(payload);
    state.dialog = payload;
  },
  actualizarerror: function actualizarerror(state, payload) {
    state.error = payload;
  },
  actualizarmessage_error: function actualizarmessage_error(state, payload) {
    state.messageerror = payload;
  },
  actualizar_success: function actualizar_success(state, payload) {
    state.success = payload;
  },
  actualizarmessage_success: function actualizarmessage_success(state, payload) {
    state.messagesuccess = payload;
  },
  setdevoluciones: function setdevoluciones(state, payload) {
    state.devoluciones = payload;
  },
  resetfactura: function resetfactura(state) {
    state.dialog = false;
    state.factura = { usuario: { username: '' }, credito: false, id: 1 };
    state.productos = [];
    state.has_factura = false;
    state.cliente = { nit: '' };
    state.messageerror = '';
    state.messagesuccess = '';
    state.lineas = [];
    state.error = false;
  },
  resetcotizacion: function resetcotizacion(state) {
    state.dialog = false;
    state.clientecotizacion = { cliente: '' };
    state.productos = [];
    state.has_cotizacion = false;
    state.lineascotizacion = [];
    state.error = false;
  },
  actualizarlistadofacturas: function actualizarlistadofacturas(state, payload) {
    state.facturas = payload;
  },
  actualizarlistadocotizaciones: function actualizarlistadocotizaciones(state, payload) {
    state.cotizaciones = payload;
  },
  eliminarfactura: function eliminarfactura(state, payload) {
    var index = state.facturas.results.indexOf(payload);
    state.facturas.results.splice(index, 1);
  },
  eliminardevolucion: function eliminardevolucion(state, payload) {
    var index = state.devoluciones.productos.indexOf(payload);
    state.devoluciones.productos.splice(index, 1);
  },
  agregardevolucion: function agregardevolucion(state, payload) {
    state.devoluciones.productos.push(payload);
  },
  setLineaNota: function setLineaNota(state, payload) {
    state.lineanota = payload;
  },
  eliminarcompra: function eliminarcompra(state, payload) {
    var index = state.compras.results.indexOf(payload);
    state.compras.results.splice(index, 1);
  },
  eliminarcotizacion: function eliminarcotizacion(state, payload) {
    var index = state.cotizaciones.results.indexOf(payload);
    state.cotizaciones.results.splice(index, 1);
  },
  eliminarextraccion: function eliminarextraccion(state, payload) {
    var index = state.extracciones.indexOf(payload);
    state.extracciones.splice(index, 1);
  },
  eliminarkilometraje: function eliminarkilometraje(state, payload) {
    var index = state.kilometrajes.results.indexOf(payload);
    state.kilometrajes.results.splice(index, 1);
  },
  setguardando: function setguardando(state, payload) {
    state.guardando = payload;
  },
  eliminarkilometrajevendedor: function eliminarkilometrajevendedor(state, payload) {
    var index = state.kilometrajesvendedor.results.indexOf(payload);
    state.kilometrajesvendedor.results.splice(index, 1);
  },
  actualizarclientes: function actualizarclientes(state, payload) {
    state.clientes = payload;
    var ordenados = state.clientes.results.sort(function (dato1, dato2) {
      return dato1.orden - dato2.orden;
    });
    state.clientes.results = ordenados;
  },
  eliminarcliente: function eliminarcliente(state, payload) {
    var index = state.clientes.results.indexOf(payload);
    state.clientes.results.splice(index, 1);
  },
  limpiarcliente: function limpiarcliente(state) {
    state.cliente = { nit: '' };
  },
  actualizarclientesedit: function actualizarclientesedit(state, payload) {
    var datos = [];
    state.clientes.results.find(function (dato) {
      if (dato.id === payload.id) {
        datos.push(payload);
      } else {
        datos.push(dato);
      }
    });
    var ordenado = datos.sort(function (dato1, dato2) {
      return dato1.orden - dato2.orden;
    });
    state.clientes.results = ordenado;
  },
  actualizarrutas: function actualizarrutas(state, payload) {
    state.rutas = payload;
  },
  actualizarbancos: function actualizarbancos(state, payload) {
    state.bancos = payload;
  },
  actualizarusuarios: function actualizarusuarios(state, payload) {
    state.usuarios = payload;
  },
  actualizarproveedores: function actualizarproveedores(state, payload) {
    state.proveedores = payload;
  },
  actualizarvehiculos: function actualizarvehiculos(state, payload) {
    state.vehiculos = payload;
  },
  actualizarvehiculo: function actualizarvehiculo(state, payload) {
    state.vehiculo = payload;
  },
  actualizarproductos: function actualizarproductos(state, payload) {
    state.productos = payload;
  },

  actualizardia: function actualizardia(state, payload) {
    state.dia = payload;
  },
  actualizarruta: function actualizarruta(state, payload) {
    state.ruta = payload;
  },
  actualizarusuario: function actualizarusuario(state, payload) {
    state.usuario = payload;
  },
  actualizarbanco: function actualizarbanco(state, payload) {
    state.banco = payload;
  },
  actualizarbanco2: function actualizarbanco2(state, payload) {
    state.banco2 = payload;
  },
  actualizardesde: function actualizardesde(state, payload) {
    state.desde = payload;
  },
  actualizarhasta: function actualizarhasta(state, payload) {
    state.hasta = payload;
  },
  actualizarsemana: function actualizarsemana(state, payload) {
    state.semana = payload;
  },
  actualizartipo: function actualizartipo(state, payload) {
    state.tipo = payload;
  },
  actualizarakilometraje: function actualizarakilometraje(state, payload) {
    state.akilometraje = payload;
  },
  actualizarakilometrajevendedor: function actualizarakilometrajevendedor(state, payload) {
    state.akilometrajevendedor = payload;
  },
  actualizarbodega: function actualizarbodega(state, payload) {
    state.vender_bodega = payload;
  },
  setextracciones: function setextracciones(state, payload) {
    state.extracciones = payload;
  },
  settipoextracciones: function settipoextracciones(state, payload) {
    state.tiposextracciones = payload;
  },
  setactivadorcliente: function setactivadorcliente(state, payload) {
    state.tiposextracciones = payload;
  },
  setcaja: function setcaja(state, payload) {
    state.caja = payload;
  },
  setcompra: function setcompra(state, payload) {
    state.compra = payload;
  },
  seteditcompra: function seteditcompra(state, payload) {
    state.editcompra = payload;
  },
  setcompralinea: function setcompralinea(state, payload) {
    state.lineacompra.compra = payload;
  },
  setPagada: function setPagada(state, payload) {
    state.compra.pagada = payload;
  },
  setcredito: function setcredito(state, payload) {
    state.compra.credito = payload;
  },
  setSerie: function setSerie(state, payload) {
    state.compra.serie = payload;
  },
  setPresentaciones: function setPresentaciones(state, payload) {
    state.listadopresentacion = payload;
  },
  eliminarlineacompra: function eliminarlineacompra(state, payload) {
    var index = state.compra.detallescompratemporal.indexOf(payload);
    console.log(index);
    state.compra.detallescompratemporal.splice(index, 1);
  },
  setaddlineacompra: function setaddlineacompra(state, payload) {
    state.compra.detallescompratemporal.push(payload);
  },
  limpiarlineacompra: function limpiarlineacompra(state, payload) {
    state.lineacompra = payload;
  },
  setpreciocompra: function setpreciocompra(state, payload) {
    state.lineacompra.precio_compra = payload.precio_compra;
    state.lineacompra.precio = payload.precio_compra;
    state.lineacompra.presentacion = 7;
  },
  aumentartotalc: function aumentartotalc(state, payload) {
    console.log(payload);
    state.compra.totalc = state.compra.totalc + payload.cantidad * payload.precio;
  },
  disminuirtotalc: function disminuirtotalc(state, payload) {
    console.log(payload);
    state.compra.totalc = state.compra.totalc - payload.cantidad * payload.precio;
  },
  setEliminando: function setEliminando(state, payload) {
    state.eliminando = payload;
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zxing_library__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "image-barcode-reader",

    data: function data() {
        return {
            codeReader: new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["BrowserMultiFormatReader"]()
        };
    },


    methods: {
        onChangeInput: function onChangeInput(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            var reader = new FileReader();
            reader.onload = this.processFile;
            reader.readAsDataURL(files[0]);
        },
        processFile: function processFile(e) {
            var _this = this;

            this.$el.innerHTML += "<img id=\"image\" src=\"" + e.target.result + "\"/>";

            this.codeReader.decodeFromImage("image").then(function (result) {
                return _this.$emit("decode", result.text);
            }).catch(function (error) {
                return _this.$emit("error", error);
            });
        }
    }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zxing_library__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "stream-barcode-reader",

    data: function data() {
        return {
            isLoading: true,
            codeReader: new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["BrowserMultiFormatReader"](),
            isMediaStreamAPISupported: navigator && navigator.mediaDevices && "enumerateDevices" in navigator.mediaDevices
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (!this.isMediaStreamAPISupported) {
            throw new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["Exception"]("Media Stream API is not supported");
            return;
        }

        this.start();
        this.$refs.scanner.oncanplay = function (event) {
            _this.isLoading = false;
            _this.$emit("loaded");
        };
    },
    beforeDestroy: function beforeDestroy() {
        this.codeReader.reset();
    },


    methods: {
        start: function start() {
            var _this2 = this;

            this.codeReader.decodeFromVideoDevice(undefined, this.$refs.scanner, function (result, err) {
                if (result) {
                    _this2.$emit("decode", result.text);
                }
            });
        }
    }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(457)));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(459)));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(460)));

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(465)));

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.commit('actualizartipo', localStorage.getItem('tipo'));
  },
  data: function data() {
    return {
      drawer: null,
      mini: false,
      right: true
    };
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
    }
  },
  computed: {
    islogin: function islogin() {
      return this.$store.getters.is_authenticated || localStorage.getItem('token');
    },
    usuario: function usuario() {
      return localStorage.getItem('usuario');
    },
    tipo: function tipo() {
      return this.$store.getters.gettipo;
    },
    items: function items() {
      if (this.$store.getters.gettipo === 'admin' || this.$store.getters.gettipo === 'secretaria') {
        return [{ title: 'Factura', icon: 'add_shopping_cart', url: 'factura' }, { title: 'Clientes', icon: 'account_circle', url: 'clientes' }, { title: 'Reportes', icon: 'file', url: 'reportes' }, { title: 'Reportes de Ventas', icon: 'file', url: 'reporteventas' }, { title: 'Kilometraje', icon: 'add_shopping_cart', url: 'kilometraje' }, { title: 'Anular Factura', icon: 'add_shopping_cart', url: 'anularfacturas' }, { title: 'Cotizacion', icon: 'add_shopping_cart', url: 'cotizacion' }, { title: 'Buscador', icon: 'search', url: 'buscador' }, { title: 'Extraer', icon: 'money', url: 'extraccion' }, { title: 'Cuadrar', icon: 'money', url: 'cuadrar' }, { title: 'Compra', icon: 'money', url: 'compratemporal' }, { title: 'Devoluciones', icon: 'money', url: 'devoluciones' }];
      } else if (this.$store.getters.gettipo === 'gerente' || this.$store.getters.gettipo === 'bodeguero') {
        return [{ title: 'Factura', icon: 'add_shopping_cart', url: 'factura' }, { title: 'Buscador', icon: 'search', url: 'buscador' }, { title: 'Compra', icon: 'money', url: 'compratemporal' }, { title: 'Devoluciones', icon: 'money', url: 'devoluciones' }];
      } else if (this.$store.getters.gettipo === 'vendedor') {
        return [{ title: 'Factura', icon: 'add_shopping_cart', url: 'factura' }, { title: 'Clientes', icon: 'account_circle', url: 'clientes' }, { title: 'Reportes de Ventas', icon: 'file', url: 'reporteventas' }, { title: 'Buscador', icon: 'search', url: 'buscador' }, { title: 'Extraer', icon: 'money', url: 'extraccion' }, { title: 'Kilometraje Vendedor', icon: 'add_shopping_cart', url: 'kilometrajevendedor' }];
      } else if (this.$store.getters.gettipo === 'chofer') {
        return [{ title: 'Kilometraje', icon: 'add_shopping_cart', url: 'kilometraje' }, { title: 'Anular Factura', icon: 'add_shopping_cart', url: 'anularfacturas' }, { title: 'Devoluciones', icon: 'money', url: 'devoluciones' }];
      }
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActualizaUbicacionCliente',
  created: function created() {
    this.url = this.$route.params.id;
    this.$store.dispatch('getcliente', this.url);
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.cliente = _this.$store.getters.cliente;
      if (_this.cliente.latitud !== null) {
        _this.center = { lat: parseFloat(_this.cliente.latitud), lng: parseFloat(_this.cliente.longitud) };
        _this.markers = [{ position: { lat: parseFloat(_this.cliente.latitud), lng: parseFloat(_this.cliente.longitud) } }];
      } else {
        _this.ubicacionactual();
      }
    }, 1000);
  },
  data: function data() {
    return {
      markers: [{ position: { lat: 15.590615, lng: -90.102964 } }],
      center: { lat: 15.590615, lng: -90.102964 },
      latitud: '',
      cliente: {},
      url: ''
    };
  },

  methods: {
    marcar: function marcar(position) {
      this.$store.dispatch('getcliente', this.url);
      this.center = position.latLng;
      this.markers = [{ position: position.latLng }];
      this.latitud = this.center.lng();
    },
    actualizarcliente: function actualizarcliente() {
      this.cliente = this.$store.getters.cliente;
      if (typeof this.center.lat === 'function') {
        this.cliente.latitud = this.center.lat();
        this.cliente.longitud = this.center.lng();
      } else {
        this.cliente.latitud = this.center.lat;
        this.cliente.longitud = this.center.lng;
      }
      console.log(this.cliente);
      this.$store.dispatch('editarcliente', this.cliente, true);
    },
    error: function error(dato) {
      console.log(dato);
    },
    success: function success(dato) {
      console.log(dato);
    },
    ubicacionactual: function ubicacionactual() {
      if (navigator.geolocation) {
        var v = this;
        navigator.geolocation.getCurrentPosition(function (coor) {
          v.center = { lat: coor.coords.latitude, lng: coor.coords.longitude };
          v.markers = [{ position: { lat: coor.coords.latitude, lng: coor.coords.longitude } }];
        });
      } else {
        alert('Geolocation is not supported by this browser.');
      }
    },
    regresar: function regresar() {
      this.$router.push('/clientes');
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fcliente_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fcliente_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Fcliente_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__librerias_numerosaletras__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'cliente-factura': __WEBPACK_IMPORTED_MODULE_0__Fcliente_vue___default.a },
  created: function created() {
    this.href.search.focus();
  },
  data: function data() {
    return {
      cantidad: 1,
      iscredito: false,
      grabando: false,
      prueba: true,
      foco: false,
      nombreproducto: '',
      motivonota: '',
      dialogbusqueda: false,
      escambio: false,
      efectivo: '',
      message: false,
      messagemotivo: false,
      motivos: ['Cerrado', 'Ausente', 'Compra Barato', 'Tiene Producto'],
      headers: [{ text: 'Cantidad' }, { text: ' Presentación' }, { text: 'Descripción' }, { text: 'Precio' }, { text: 'Subtotal' }]
    };
  },

  methods: {
    impresion: function impresion() {
      this.dialog = true;
    },
    searchproducto: function searchproducto() {
      this.$store.dispatch('buscarproducto', { producto: this.producto.barra, bodega: this.factura.bodega });
      this.$refs.cantidad.focus();
    },
    searchproductodialog: function searchproductodialog(event) {
      if (event.barra) {
        this.$store.dispatch('buscarproducto', { producto: event.barra, bodega: this.factura.bodega });
      } else {
        this.$store.dispatch('buscarproducto', { producto: event.codigo, bodega: this.factura.bodega });
      }
      this.$refs.cantidad.focus();
    },
    searchproductos: function searchproductos() {
      this.$store.dispatch('buscarproductos', { producto: this.nombreproducto, bodega: this.factura.bodega });
    },
    checklista: function checklista() {
      var _this = this;

      if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
        var listadoordenado = this.producto.listaprecios.sort(function (dato1, dato2) {
          return dato1.minimo - dato2.minimo;
        });
        var listas = [];
        var lista = [];
        listadoordenado.map(function (dato) {
          if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <= _this.cantidad * _this.presentacion.unidades) {
            listas.push(dato);
          }
        });
        if (listas.length > 0) {
          lista = listas.reverse();
          this.$store.commit('updateselect', lista[0]);
        } else {
          listas = listadoordenado.map(function (dato) {
            if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
              lista.push(dato);
            }
          });
          this.$store.commit('updateselect', lista[0]);
        }
      }
    },
    redondear: function redondear(cantidad) {
      var exponente = 100;
      var prueba = cantidad.toFixed(2);
      var reciduo = parseInt((prueba * exponente).toFixed() % 5);
      if (reciduo !== 0) {
        return (parseInt((cantidad.toFixed(2) * exponente).toFixed()) + 5 - reciduo) / exponente;
      } else {
        return cantidad.toFixed(2) * exponente / exponente;
      }
    },
    guardarventa: function guardarventa() {
      var precio = 0;
      var cantidad = 0;
      this.grabando = true;
      if (this.escambio) {
        precio = 0;
      } else {
        precio = this.precio;
      }
      this.escambio = false;
      if (this.cantidad < 0) {
        cantidad = this.cantidad * -1;
      } else {
        cantidad = this.cantidad;
      }
      if (this.$store.getters.lineasfactura.length <= 12 && localStorage.getItem('usuario') !== '1' && localStorage.getItem('usuario') !== 'L2') {
        this.$store.dispatch('insertarlinea', { producto: this.producto.id,
          factura: this.factura.id,
          precio: precio,
          cantidad: cantidad,
          presentacion: this.presentacion.presentacion,
          listaprecio: this.listado.id
        });
      }
      this.cantidad = 1;
      this.$refs.search.focus();
      this.grabando = false;
    },
    nuevafactura: function nuevafactura() {
      var id = this.cliente.id;
      this.$store.dispatch('crearfactura2', id);
      this.cantidad = 1;
      this.$refs.search.focus();
    },
    cambiarcredito: function cambiarcredito() {
      this.$store.dispatch('actualizartipofactura', { factura: this.factura });
    },
    anularfactura: function anularfactura() {
      if (this.factura.motivo_anulacion) {
        this.$store.dispatch('actualizaranulado', { factura: this.factura });
        this.message = false;
      } else {
        if (this.factura.anulado) {
          this.message = true;
        }
      }
    },
    cambiarcomentario: function cambiarcomentario() {
      this.$store.dispatch('actualizarcomentario', { factura: this.factura });
    },
    cambiarcomentariomotivo: function cambiarcomentariomotivo() {
      this.$store.dispatch('actualizarcomentario', { factura: this.factura });
    },
    eliminar: function eliminar(linea) {
      var _this2 = this;

      if (this.grabando) {
        return;
      }
      var a = confirm('desea anular ' + linea.producto_name);
      if (a) {
        this.grabando = true;
        this.$store.dispatch('insertarlineanotacredito', linea).then(function () {
          _this2.grabando = false;
        }, function () {
          _this2.grabando = false;
        });
      }
    },
    guardardatosfactura: function guardardatosfactura() {
      if (this.lineas.length === 0) {
        this.$store.commit('actualizarerror', true);
        this.$store.commit('actualizarmessage_error', 'por favor ingrese productos');
      } else {
        this.$store.dispatch('actualizarnumerofactura', { factura: this.factura });
      }
    },
    guardarfactura: function guardarfactura() {
      this.$store.dispatch('guardarfactura', { factura: this.factura });
    },
    resetbusqueda: function resetbusqueda() {
      this.nombreproducto = '';
      this.$store.commit('actualizarproductos', []);
    },
    focusbusqueda: function focusbusqueda() {
      var vm = this;
      setTimeout(function () {
        vm.$refs.searchprodi.focus();
      }, 100);
    },
    actualizarnota: function actualizarnota() {
      var nota = this.$store.getters.getlineanota;
      this.$store.dispatch('actualizarnotacredito', { id: nota.id, motivo: this.motivonota });
      this.motivonota = '';
    }
  },
  computed: {
    productos: function productos() {
      return this.$store.getters.productos;
    },
    tipo: function tipo() {
      return this.$store.getters.gettipo;
    },
    vender_bodega: function vender_bodega() {
      console.log(localStorage.getItem('puede_vender_bodega'));
      console.log(this.$store.getters.get_vender_bodega);
      if (this.$store.getters.get_vender_bodega) {
        return this.$store.getters.get_vender_bodega;
      } else {
        return localStorage.getItem('puede_vender_bodega') === 'true';
      }
    },
    haslineas: function haslineas() {
      if (this.lineas.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hasfactura: function hasfactura() {
      return this.$store.getters.hasfactura;
    },
    factura: function factura() {
      return this.$store.getters.factura;
    },
    lineas: function lineas() {
      return this.$store.getters.lineasfactura;
    },
    total: function total() {
      var temptotal = 0;
      this.lineas.map(function (dato) {
        temptotal += dato.cantidad * dato.precio;
      });
      return this.redondear(temptotal).toFixed(2) || 0;
    },
    cliente: function cliente() {
      return this.$store.getters.cliente;
    },
    producto: function producto() {
      return this.$store.getters.producto;
    },
    fecha: function fecha() {
      var fecha = new Date(this.$store.getters.factura.fecha);
      return fecha.toLocaleDateString('es-gt');
    },
    hora: function hora() {
      var fecha = new Date(this.$store.getters.factura.fecha);
      return fecha.toLocaleTimeString('es-gt');
    },
    listado: {
      get: function get() {
        return this.$store.getters.listado || '';
      },
      set: function set(dato) {
        this.$store.commit('updateselect', dato);
      }
    },
    dialog: {
      get: function get() {
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    },
    precio: {
      get: function get() {
        if (this.presentacion.presentacion === 'unidad') {
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100)) * this.presentacion.unidades;
        }
        if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades);
        }
        return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades);
      }
    },
    presentaciones: function presentaciones() {
      return this.$store.getters.presentaciones;
    },
    presentacion: {
      get: function get() {
        if (this.$store.getters.presentacion) {
          return this.$store.getters.presentacion;
        } else {
          return '';
        }
      },
      set: function set(dato) {
        this.$store.commit('actualizarpresentacion', dato);
      }
    },
    error: function error() {
      return this.$store.getters.error_numero;
    },
    cambio: function cambio() {
      return (this.total - this.efectivo).toFixed(2);
    },
    message_error: function message_error() {
      return this.$store.getters.message_error;
    },
    numerosaletras: function numerosaletras() {
      return __WEBPACK_IMPORTED_MODULE_1__librerias_numerosaletras__["a" /* default */].NumeroALetras(this.total, {
        plural: 'QUETZALES',
        singular: 'QUETZAL',
        centPlural: 'CENTAVOS',
        centSingular: 'CENTAVOS'
      });
    },
    validatefactura: function validatefactura() {
      if (this.lineas.length === 13 && localStorage.getItem('usuario') !== '1' && localStorage.getItem('usuario') !== 'L2') {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode_reader__ = __webpack_require__(394);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { StreamBarcodeReader: __WEBPACK_IMPORTED_MODULE_0_vue_barcode_reader__["a" /* StreamBarcodeReader */] },
  created: function created() {
    this.$store.dispatch('actualizarfacturas', { search: 'jkdfjkajflkajfklajklfdajfklajf' });
  },
  data: function data() {
    return {
      auto_name: '',
      buscador: '',
      activo: '',
      codigotabulacion: ''
    };
  },

  methods: {
    onDecode: function onDecode(result) {
      this.codigotabulacion = result;
      this.$store.dispatch('actualizarfacturas', { search: result, ordering: '-fecha' });
      this.activo = false;
    },
    onLoaded: function onLoaded(result) {},
    buscar: function buscar() {
      this.$store.dispatch('actualizarfacturas', { ordering: '-fecha', search: this.codigotabulacion });
    },
    next: function next(dato) {
      this.$store.dispatch('actualizarfacturas2', dato);
    },
    prev: function prev(dato) {
      this.$store.dispatch('actualizarfacturas2', dato);
    },
    editarfactura: function editarfactura(factura) {
      var _this = this;

      this.$store.commit('resetfactura');
      this.$store.commit('actualizarfactura', factura);
      this.$store.commit('actualizarestadofactura', true);
      this.$store.dispatch('getcliente', factura.cliente);
      factura.lineas.map(function (linea) {
        _this.$store.commit('actualizarlinea', linea);
      });
      this.$router.push('anularfactura');
    }
  },
  computed: {
    facturas: function facturas() {
      return this.$store.getters.listadofacturas;
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fcliente_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fcliente_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Fcliente_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__librerias_numerosaletras__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'cliente-factura': __WEBPACK_IMPORTED_MODULE_0__Fcliente_vue___default.a },
  created: function created() {
    this.href.search.focus();
  },
  data: function data() {
    return {
      cantidad: 1,
      iscredito: false,
      prueba: true,
      foco: false,
      nombreproducto: '',
      dialogbusqueda: false,
      escambio: false,
      efectivo: '',
      message: false,
      messagemotivo: false,
      motivos: ['Cerrado', 'Ausente', 'Compra Barato', 'Tiene Producto'],
      headers: [{ text: 'Cantidad' }, { text: ' Presentación' }, { text: 'Descripción' }, { text: 'Precio' }, { text: 'Subtotal' }]
    };
  },

  methods: {
    searchproducto: function searchproducto() {
      this.$store.dispatch('buscarproducto', { producto: this.producto.barra });
      this.$refs.cantidad.focus();
    },
    searchproductodialog: function searchproductodialog(event) {
      if (event.barra) {
        this.$store.dispatch('buscarproducto', { producto: event.barra });
      } else {
        this.$store.dispatch('buscarproducto', { producto: event.codigo });
      }
      this.$refs.cantidad.focus();
    },
    searchproductos: function searchproductos() {
      this.$store.dispatch('buscarproductos', { producto: this.nombreproducto });
    },
    checklista: function checklista() {
      var _this = this;

      if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
        var listadoordenado = this.producto.listaprecios.sort(function (dato1, dato2) {
          return dato1.minimo - dato2.minimo;
        });
        var listas = [];
        var lista = [];
        listadoordenado.map(function (dato) {
          if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <= _this.cantidad * _this.presentacion.unidades) {
            listas.push(dato);
          }
        });
        if (listas.length > 0) {
          lista = listas.reverse();
          this.$store.commit('updateselect', lista[0]);
        } else {
          listas = listadoordenado.map(function (dato) {
            if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
              lista.push(dato);
            }
          });
          this.$store.commit('updateselect', lista[0]);
        }
      }
    },
    resetbusqueda: function resetbusqueda() {
      this.nombreproducto = '';
      this.$store.commit('actualizarproductos', []);
    },
    redondear: function redondear(cantidad) {
      var exponente = 100;
      var prueba = cantidad.toFixed(2);
      var reciduo = parseInt((prueba * exponente).toFixed() % 5);
      if (reciduo !== 0) {
        return (parseInt((cantidad.toFixed(2) * exponente).toFixed()) + 5 - reciduo) / exponente;
      } else {
        return cantidad.toFixed(2) * exponente / exponente;
      }
    },
    focusbusqueda: function focusbusqueda() {
      var vm = this;
      setTimeout(function () {
        vm.$refs.searchprodi.focus();
      }, 100);
    }
  },
  computed: {
    productos: function productos() {
      return this.$store.getters.productos;
    },
    haslineas: function haslineas() {
      if (this.lineas.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hasfactura: function hasfactura() {
      return false;
    },
    factura: function factura() {
      return this.$store.getters.factura;
    },
    lineas: function lineas() {
      return this.$store.getters.lineasfactura;
    },
    total: function total() {
      var temptotal = 0;
      this.lineas.map(function (dato) {
        temptotal += dato.cantidad * dato.precio;
      });
      return temptotal.toFixed(2) || 0;
    },
    cliente: function cliente() {
      return this.$store.getters.cliente;
    },
    producto: function producto() {
      return this.$store.getters.producto;
    },
    fecha: function fecha() {
      var fecha = new Date(this.$store.getters.factura.fecha);
      return fecha.toLocaleDateString('es-gt');
    },
    hora: function hora() {
      var fecha = new Date(this.$store.getters.factura.fecha);
      return fecha.toLocaleTimeString('es-gt');
    },
    listado: {
      get: function get() {
        return this.$store.getters.listado || '';
      },
      set: function set(dato) {
        this.$store.commit('updateselect', dato);
      }
    },
    dialog: {
      get: function get() {
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    },
    precio: {
      get: function get() {
        if (this.presentacion.presentacion === 'unidad') {
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100)) * this.presentacion.unidades;
        }
        if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades);
        }
        return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades);
      }
    },
    presentaciones: function presentaciones() {
      return this.$store.getters.presentaciones;
    },
    presentacion: {
      get: function get() {
        return this.$store.getters.presentacion;
      },
      set: function set(dato) {
        this.$store.commit('actualizarpresentacion', dato);
      }
    },
    error: function error() {
      return this.$store.getters.error_numero;
    },
    cambio: function cambio() {
      return (this.total - this.efectivo).toFixed(2);
    },
    message_error: function message_error() {
      return this.$store.getters.message_error;
    },
    numerosaletras: function numerosaletras() {
      return __WEBPACK_IMPORTED_MODULE_1__librerias_numerosaletras__["a" /* default */].NumeroALetras(this.total, {
        plural: 'QUETZALES',
        singular: 'QUETZAL',
        centPlural: 'CENTAVOS',
        centSingular: 'CENTAVOS'
      });
    },
    validatefactura: function validatefactura() {
      if (this.lineas.length === 13) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dia: '',
      semana: '',
      esruta: false
    };
  },

  methods: {
    buscarcliente: function buscarcliente() {
      console.log(this.cliente);
      this.$store.dispatch('crearclientecotizacion', this.cliente);
    }
  },
  computed: {
    cliente: function cliente() {
      return this.$store.getters.clientescotizacion;
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getclientes');
    this.$store.dispatch('getrutas');
  },
  data: function data() {
    return {
      depatamentos: [{
        'title': 'Alta Verapaz',
        'mun': ['Chahal', 'Chisec', 'Cobán', 'Fray Bartolomé de las Casas', 'Lanquín', 'Panzós', 'Raxruha', 'San Cristóbal Verapaz', 'San Juan Chamelco', 'San Pedro Carchá', 'Santa Cruz Verapaz', 'Senahú', 'Tactic', 'Tamahú', 'Tucurú', 'Santa María Cahabón', 'Santa Catarina La Tinta'] }, {
        'title': 'Baja Verapaz',
        'mun': ['Cubulco', 'Granados', 'Purulhá', 'Rabinal', 'Salamá', 'San Jerónimo', 'San Miguel Chicaj', 'Santa Cruz El Chol'] }, {
        'title': 'Chimaltenango',
        'mun': ['Acatenango', 'Chimaltenango', 'El Tejar', 'Parramos', 'Patzicía', 'Patzún', 'Pochuta', 'San Andrés Itzapa', 'San José Poaquil', 'San Juan Comalapa', 'San Martín Jilotepeque', 'Santa Apolonia', 'Santa Cruz Balanyá', 'Tecpán Guatemala', 'Yepocapa', 'Zaragoza'] }, {
        'title': 'Chiquimula',
        'mun': ['Camotán', 'Chiquimula', 'Concepción Las Minas', 'Esquipulas', 'Ipala', 'Jocotán', 'Olopa', 'Quezaltepeque', 'San Jacinto', 'San José La Arada', 'San Juan Ermita'] }, {
        'title': 'El Progreso',
        'mun': ['El Jícaro', 'Guastatoya', 'Morazán', 'San Agustín Acasaguastlán', 'San Antonio La Paz', 'San Cristóbal Acasaguastlán', 'Sanarate'] }, {
        'title': 'Escuintla',
        'mun': ['Escuintla', 'Guanagazapa', 'Iztapa', 'La Democracia', 'La Gomera', 'Masagua', 'Nueva Concepción', 'Palín', 'San José', 'San Vicente Pacaya', 'Santa Lucía Cotzumalguapa', 'Siquinalá', 'Tiquisate'] }, {
        'title': 'Guatemala',
        'mun': ['Amatitlán', 'Chinautla', 'Chuarrancho', 'Fraijanes', 'Guatemala City', 'Mixco', 'Palencia', 'Petapa', 'San José del Golfo', 'San José Pinula', 'San Juan Sacatepéquez', 'San Pedro Ayampuc', 'San Pedro Sacatepéquez', 'San Raymundo', 'Santa Catarina Pinula', 'Villa Canales'] }, {
        'title': 'Huehuetenango',
        'mun': ['Aguacatán', 'Chiantla', 'Colotenango', 'Concepción Huista', 'Cuilco', 'Huehuetenango', 'Ixtahuacán', 'Jacaltenango', 'La Democracia', 'La Libertad', 'Malacatancito', 'Nentón', 'San Antonio Huista', 'San Gaspar Ixchil', 'San Juan Atitán', 'San Juan Ixcoy', 'San Mateo Ixtatán', 'San Miguel Acatán', 'San Pedro Necta', 'San Rafael La Independencia', 'San Rafael Petzal', 'San Sebastián Coatán', 'San Sebastián Huehuetenango', 'Santa Ana Huista', 'Santa Bárbara', 'Santa Cruz Barillas', 'Santa Eulalia', 'Santiago Chimaltenango', 'Soloma', 'Tectitán', 'Todos Santos Cuchumatan'] }, {
        'title': 'Izabal',
        'mun': ['El Estor', 'Livingston', 'Los Amates', 'Morales', 'Puerto Barrios'] }, {
        'title': 'Jalapa',
        'mun': ['Jalapa', 'Mataquescuintla', 'Monjas', 'San Carlos Alzatate', 'San Luis Jilotepeque', 'San Manuel Chaparrón', 'San Pedro Pinula'] }, {
        'title': 'Jutiapa',
        'mun': ['Agua Blanca', 'Asunción Mita', 'Atescatempa', 'Comapa', 'Conguaco', 'El Adelanto', 'El Progreso', 'Jalpatagua', 'Jerez', 'Jutiapa', 'Moyuta', 'Pasaco', 'Quezada', 'San José Acatempa', 'Santa Catarina Mita', 'Yupiltepeque', 'Zapotitlán'] }, {
        'title': 'Petén',
        'mun': ['Dolores', 'Flores', 'La Libertad', 'Melchor de Mencos', 'Poptún', 'San Andrés', 'San Benito', 'San Francisco', 'San José', 'San Luis', 'Santa Ana', 'Sayaxché', 'Las Cruces'] }, {
        'title': 'Quetzaltenango',
        'mun': ['Almolonga', 'Cabricán', 'Cajolá', 'Cantel', 'Coatepeque', 'Colomba', 'Concepción Chiquirichapa', 'El Palmar', 'Flores Costa Cuca', 'Génova', 'Huitán', 'La Esperanza', 'Olintepeque', 'Ostuncalco', 'Palestina de Los Altos', 'Quetzaltenango', 'Salcajá', 'San Carlos Sija', 'San Francisco La Unión', 'San Martín Sacatepéquez', 'San Mateo', 'San Miguel Sigüilá', 'Sibilia', 'Zunil'] }, {
        'title': 'Quiché',
        'mun': ['Canillá', 'Chajul', 'Chicamán', 'Chiché', 'Chichicastenango', 'Chinique', 'Cunén', 'Ixcán', 'Joyabaj', 'Nebaj', 'Pachalum', 'Patzité', 'Sacapulas', 'San Andrés Sajcabajá', 'San Antonio Ilotenango', 'San Bartolomé Jocotenango', 'San Juan Cotzal', 'San Pedro Jocopilas', 'Santa Cruz del Quiché', 'Uspantán', 'Zacualpa'] }, {
        'title': 'Retalhuleu',
        'mun': ['Champerico', 'El Asintal', 'Nuevo San Carlos', 'Retalhuleu', 'San Andrés Villa Seca', 'San Felipe', 'San Martín Zapotitlán', 'San Sebastián', 'Santa Cruz Muluá'] }, {
        'title': 'Sacatepéquez',
        'mun': ['Alotenango', 'Antigua', 'Ciudad Vieja', 'Jocotenango', 'Magdalena Milpas Altas', 'Pastores', 'San Antonio Aguas Calientes', 'San Bartolomé Milpas Altas', 'San Lucas Sacatepéquez', 'San Miguel Dueñas', 'Santa Catarina Barahona', 'Santa Lucía Milpas Altas', 'Santa María de Jesús', 'Santiago Sacatepéquez', 'Santo Domingo Xenacoj', 'Sumpango'] }, {
        'title': 'San Marcos',
        'mun': ['Ayutla', 'Catarina', 'Comitancillo', 'Concepción Tutuapa', 'El Quetzal', 'El Rodeo', 'El Tumbador', 'Esquipulas Palo Gordo', 'Ixchiguan', 'La Reforma', 'Malacatán', 'Nuevo Progreso', 'Ocos', 'Pajapita', 'Río Blanco', 'San Antonio Sacatepéquez', 'San Cristóbal Cucho', 'San José Ojetenam', 'San Lorenzo', 'San Marcos', 'San Miguel Ixtahuacán', 'San Pablo', 'San Pedro Sacatepéquez', 'San Rafael Pie de La Cuesta', 'San Sibinal', 'Sipacapa', 'Tacaná', 'Tajumulco', 'Tejutla'] }, {
        'title': 'Santa Rosa',
        'mun': ['Barberena', 'Casillas', 'Chiquimulilla', 'Cuilapa', 'Guazacapán', 'Nueva Santa Rosa', 'Oratorio', 'Pueblo Nuevo Viñas', 'San Juan Tecuaco', 'San Rafael Las Flores', 'Santa Cruz Naranjo', 'Santa María Ixhuatán', 'Santa Rosa de Lima', 'Taxisco'] }, {
        'title': 'Sololá',
        'mun': ['Concepción', 'Nahualá', 'Panajachel', 'San Andrés Semetabaj', 'San Antonio Palopó', 'San José Chacaya', 'San Juan La Laguna', 'San Lucas Tolimán', 'San Marcos La Laguna', 'San Pablo La Laguna', 'San Pedro La Laguna', 'Santa Catarina Ixtahuacan', 'Santa Catarina Palopó', 'Santa Clara La Laguna', 'Santa Cruz La Laguna', 'Santa Lucía Utatlán', 'Santa María Visitación', 'Santiago Atitlán', 'Sololá'] }, {
        'title': 'Suchitepéquez',
        'mun': ['Chicacao', 'Cuyotenango', 'Mazatenango', 'Patulul', 'Pueblo Nuevo', 'Río Bravo', 'Samayac', 'San Antonio Suchitepéquez', 'San Bernardino', 'San Francisco Zapotitlán', 'San Gabriel', 'San José El Idolo', 'San Juan Bautista', 'San Lorenzo', 'San Miguel Panán', 'San Pablo Jocopilas', 'Santa Bárbara', 'Santo Domingo Suchitepequez', 'Santo Tomas La Unión', 'Zunilito'] }, {
        'title': 'Totonicapán',
        'mun': ['Momostenango', 'San Andrés Xecul', 'San Bartolo', 'San Cristóbal Totonicapán', 'San Francisco El Alto', 'Santa Lucía La Reforma', 'Santa María Chiquimula', 'Totonicapán'] }, {
        'title': 'Zacapa',
        'mun': ['Cabañas', 'Estanzuela', 'Gualán', 'Huité', 'La Unión', 'Río Hondo', 'San Diego', 'Teculután', 'Usumatlán', 'Zacapa']
      }],
      ordenes: [],
      editarorden: false,
      dias: [{ text: 'Todos', value: '' }, { text: '1', value: 1 }, { text: '2', value: 2 }, { text: '3', value: 3 }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '6', value: 6 }],
      semanas: [{ text: 'Todos', value: '' }, { text: 'Semana1', value: 1 }, { text: 'Semana2', value: 2 }, { text: 'Semana3', value: 3 }, { text: 'Semana4', value: 4 }],
      busqueda: '',
      errorClass: 'text-danger'
    };
  },
  methods: {
    actualizarubicacion: function actualizarubicacion(id) {
      this.$router.push('/clientes/ubicacion/' + id);
    },
    guardarorden: function guardarorden(envent, cliente) {
      var index = this.ordenes.indexOf(cliente);
      if (index === -1) {
        this.ordenes.push(cliente);
      } else {
        this.ordenes[index] = cliente;
      }
    },
    guardartodo: function guardartodo() {
      var _this = this;

      this.ordenes.forEach(function (dato) {
        _this.$store.dispatch('editarcliente', dato, false);
      });
      alert('Modificado Exitosamente');
    },
    eliminar: function eliminar(dato) {
      var a = confirm('Desea eliminar a  ' + dato.nombre);
      if (a) {
        this.$store.dispatch('eliminarcliente', dato);
      }
    },
    crearfactura: function crearfactura(cliente) {
      this.$store.commit('actualizarcliente', cliente);
      this.$store.dispatch('crearfactura', cliente.id);
    },
    filtrardia: function filtrardia(event) {
      this.$store.commit('actualizardia', event);
      this.$store.dispatch('filter', { 'dia': this.dia, 'semana': this.semana, ruta: this.ruta.nombre });
    },
    filtrarsemana: function filtrarsemana(event) {
      this.$store.commit('actualizarsemana', event);
      this.$store.dispatch('filter', { 'dia': this.dia, 'semana': event, ruta: this.ruta.nombre });
    },
    filtrarruta: function filtrarruta(event) {
      this.$store.commit('actualizarruta', event);
      this.$store.dispatch('filter', { 'dia': this.dia, 'semana': this.semana, ruta: this.ruta.nombre });
    },
    buscar: function buscar() {
      this.$store.dispatch('filter', { search: this.busqueda });
    },
    editar: function editar(dato) {
      this.$store.commit('actualizarcliente', dato);
      this.$store.commit('actualizardialog', true);
    },
    next: function next(dato) {
      this.$store.dispatch('getclientes', dato);
    },
    prev: function prev(dato) {
      this.$store.dispatch('getclientes', dato);
    },
    editarcliente: function editarcliente() {
      if (!this.$store.getters.cliente.municipio || !this.$store.getters.cliente.departamento) {
        alert('El departamento y el municipio es obligatorio');
      } else {
        this.$store.commit('setactivadorcliente', true);
        if (this.$store.getters.cliente.id) {
          this.$store.dispatch('editarcliente', this.$store.getters.cliente, true);
        } else {
          var dato = this.$store.getters.cliente;
          if (this.ruta) {
            dato['ruta'] = this.ruta.id;
          }
          this.$store.dispatch('crearcliente', dato);
        }
      }
    },
    cerrar: function cerrar() {
      this.$store.commit('actualizardialog', false);
      this.$store.commit('limpiarcliente');
    }
  },
  computed: {
    rutas: function rutas() {
      return this.$store.getters.rutas;
    },
    ruta: {
      get: function get() {
        return this.$store.getters.getruta;
      },
      set: function set(dato) {
        this.$store.commit('actualizarruta', dato);
      }
    },
    clientes: function clientes() {
      return this.$store.getters.clientes;
    },
    cliente: function cliente() {
      return this.$store.getters.cliente;
    },
    dialog: {
      get: function get() {
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    },
    dia: function dia() {
      return this.$store.getters.getdia;
    },
    semana: function semana() {
      return this.$store.getters.getsemana;
    },
    activadorcliente: function activadorcliente() {
      return this.$store.getters.getactivadorcliente;
    },
    municipios: function municipios() {
      var _this2 = this;

      var departamento = this.depatamentos.find(function (d) {
        return d.title === _this2.cliente.departamento;
      });
      if (!departamento) return [];
      return departamento.mun.map(function (m) {
        return { text: m, value: m };
      });
    },
    listaDepartamentos: function listaDepartamentos() {
      return this.depatamentos.map(function (dep) {
        return { text: dep.title, value: dep.title };
      });
    },
    zonas: function zonas() {
      var lista = [];
      for (var i = 1; i <= 30; i++) {
        lista.push({
          text: 'Zona ' + i,
          value: 'zona ' + i });
      }
      return lista;
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(48);




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getCompras');
  },
  data: function data() {
    return {
      menu: false,
      menu2: false,
      fechainicio: '',
      fechafin: '',
      search: '',
      desde: '',
      hasta: ''
    };
  },

  methods: {
    redireccion: function redireccion() {
      this.$router.push('/comprasadd');
    },
    editarcompra: function editarcompra(compra) {
      this.$store.commit('setcompra', compra);
      this.$router.push('/comprasadd');
    },
    eliminar: function eliminar(compra) {
      var r = confirm(' esta seguro que desea eliminar ' + compra.proveedor_name);
      if (r === true) {
        this.$store.dispatch('eliminarcompra', compra);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getcompras']))
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(48);




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getproveedores');
    this.$store.dispatch('getpresentaciones');
    if (this.compra.id) {
      this.$store.commit('seteditcompra', true);
      this.$store.commit('setcompralinea', this.compra.id);
    }
  },
  data: function data() {
    return {
      fecha: null,
      fechaingreso: null,
      serietemp: '',
      sproducto: '',
      headers: [{ text: '', value: '' }, { text: 'Producto:', value: 'producto_name' }, { text: 'Cantidad:', value: 'cantidad' }, { text: 'Precio:', value: 'precio' }, { text: 'Sub Total:', value: 'subtotal' }, { text: 'Presentacion:', value: 'presentacion' }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    cambiaredit: function cambiaredit() {
      this.$store.commit('seteditcompra', !this.edit);
    },
    filtrar: function filtrar(item, queryText, itemText) {
      return item;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['crearCompra', 'actualizarcompra', 'crearLineaCompra']), {
    regresar: function regresar() {
      this.$store.commit('setcompra', []);
      this.$store.commit('seteditcompra', false);
      this.$router.push('/compratemporal');
    },
    cambio: function cambio(dato) {
      if (dato) {
        this.$store.commit('setcredito', false);
      } else {
        this.$store.commit('setcredito', true);
      }
    },
    cambio2: function cambio2(dato) {
      if (dato) {
        this.$store.commit('setPagada', false);
      } else {
        this.$store.commit('setPagada', true);
      }
    },
    cambiarprecio: function cambiarprecio(store) {
      var producto = this.productos.find(function (producto) {
        return producto.id === store;
      });
      this.$store.commit('setpreciocompra', producto);
    },
    searchproductos: function searchproductos() {
      this.$store.dispatch('buscarproductos', { producto: this.sproducto });
    },
    eliminar: function eliminar(linea) {
      var r = confirm(' esta seguro que desea eliminar ' + linea.producto_name);
      if (r === true) {
        this.$store.dispatch('eliminarlineacompra', linea);
      }
    },
    actualizardialog: function actualizardialog(payload) {
      this.$store.commit('actualizardialog', payload);
      if (!payload) {
        this.$store.commit('limpiarlineacompra', { presentacion: 7 });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    compra: 'getCompra',
    proveedores: 'getProveedores',
    edit: 'getEditCompra',
    productos: 'productos',
    lineacompra: 'getLineaCompra',
    presentaciones: 'getListadoPresentaciones',
    dialogo: 'dialogo'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['setSerie', 'seteditcompra']), {
    serie: {
      set: function set(e) {
        this.$store.commit('setSerie', e);
      },
      get: function get() {
        return this.compra.serie;
      }
    }
  }),
  watch: {
    sproducto: function sproducto(dato) {
      this.$store.dispatch('buscarproductos', { producto: dato });
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getrutas');
    if (this.$store.getters.getdesde || this.$store.getters.gethasta) {
      this.$store.dispatch('actualizarcotizaciones', {
        fecha_minima: this.$store.getters.getdesde,
        fecha_maxima: this.$store.getters.gethasta });
    } else {
      this.$store.dispatch('actualizarcotizaciones');
    }
  },
  data: function data() {
    return {
      menu: false,
      menu2: false,
      fechainicio: '',
      fechafin: '',
      search: '',
      cliente: ''
    };
  },

  methods: {
    redireccion: function redireccion() {
      this.$router.push('/cotizacionadd');
    },
    eliminar: function eliminar(cotizacion) {
      var r = confirm(' esta seguro que desea eliminar ' + cotizacion.cliente);
      if (r === true) {
        this.$store.dispatch('eliminarcotizacion', cotizacion);
      }
    },

    editarcotizacion: function editarcotizacion(cotizacion) {
      var _this = this;

      this.$store.commit('resetcotizacion');
      this.$store.commit('actualizarclientecotizacion', cotizacion);
      this.$store.commit('actualizarestadocotizacion', true);
      cotizacion.detalles.map(function (linea) {
        _this.$store.commit('actualizarlineacotizacion', linea);
      });
      this.$router.push('cotizacionadd');
    },
    filtrarfechafin: function filtrarfechafin() {
      this.$store.dispatch('actualizarcotizaciones', { fecha_maxima: this.$store.getters.gethasta,
        fecha_minima: this.$store.getters.getdesde });
    },
    filtrarfechainicio: function filtrarfechainicio() {
      this.$store.dispatch('actualizarcotizaciones', { fecha_maxima: this.$store.getters.gethasta,
        fecha_minima: this.$store.getters.getdesde });
    },
    buscarcotizacion: function buscarcotizacion() {
      this.$store.dispatch('actualizarcotizaciones', { search: this.search });
    },
    next: function next(dato) {
      this.$store.dispatch('actualizarcotizaciones', dato);
    },
    prev: function prev(dato) {
      this.$store.dispatch('actualizarcotizaciones', dato);
    }
  },
  computed: {
    cotizaciones: function cotizaciones() {
      return this.$store.getters.listadocotizaciones;
    },
    rutas: function rutas() {
      return this.$store.getters.rutas;
    },
    ruta: {
      get: function get() {
        return this.$store.getters.getruta;
      },
      set: function set(dato) {
        this.$store.commit('actualizarruta', dato);
      }
    },
    desde: {
      get: function get() {
        return this.$store.getters.getdesde;
      },
      set: function set(dato) {
        this.$store.commit('actualizardesde', dato);
      }
    },
    hasta: {
      get: function get() {
        return this.$store.getters.gethasta;
      },
      set: function set(dato) {
        this.$store.commit('actualizarhasta', dato);
      }
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ccliente_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ccliente_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Ccliente_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__librerias_numerosaletras__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'cliente-cotizacion': __WEBPACK_IMPORTED_MODULE_0__Ccliente_vue___default.a },
  created: function created() {
    this.href.search.focus();
  },
  data: function data() {
    return {
      cantidad: 1,
      iscredito: false,
      prueba: true,
      foco: false,
      nombreproducto: '',
      dialogbusqueda: false,
      escambio: false,
      efectivo: '',
      message: false,
      headers: [{ text: 'Cantidad' }, { text: ' Presentación' }, { text: 'Descripción' }, { text: 'Precio' }, { text: 'Subtotal' }]
    };
  },

  methods: {
    impresion: function impresion() {
      this.dialog = true;
    },
    searchproducto: function searchproducto() {
      this.$store.dispatch('buscarproducto', { producto: this.producto.barra, bodega: 1 });
      this.$refs.cantidad.focus();
    },
    searchproductodialog: function searchproductodialog(event) {
      if (event.barra) {
        this.$store.dispatch('buscarproducto', { producto: event.barra, bodega: 1 });
      } else {
        this.$store.dispatch('buscarproducto', { producto: event.codigo, bodega: 1 });
      }
      this.$refs.cantidad.focus();
    },
    searchproductos: function searchproductos() {
      this.$store.dispatch('buscarproductos', { producto: this.nombreproducto, bodega: 1 });
    },
    checklista: function checklista() {
      var _this = this;

      if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
        var listadoordenado = this.producto.listaprecios.sort(function (dato1, dato2) {
          return dato1.minimo - dato2.minimo;
        });
        var listas = [];
        var lista = [];
        listadoordenado.map(function (dato) {
          if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <= _this.cantidad * _this.presentacion.unidades) {
            listas.push(dato);
          }
        });
        if (listas.length > 0) {
          lista = listas.reverse();
          this.$store.commit('updateselect', lista[0]);
        } else {
          listas = listadoordenado.map(function (dato) {
            if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
              lista.push(dato);
            }
          });
          this.$store.commit('updateselect', lista[0]);
        }
      }
    },
    guardarventa: function guardarventa() {
      this.$store.dispatch('insertarlineacotizacion', { producto: this.producto.id,
        cotizacion: this.cliente.id,
        precio: this.precio,
        cantidad: this.cantidad,
        presentacion: this.presentacion.presentacion,
        lista: this.listado.id,
        subtotal: this.cantidad * this.precio
      });
      this.$refs.search.focus();
    },
    cambiarcomentario: function cambiarcomentario() {
      this.$store.dispatch('actualizarcomentario', { factura: this.factura });
    },
    eliminar: function eliminar(linea) {
      this.$store.dispatch('eliminarlineacotizacion', linea);
    },
    guardarcotizacion: function guardarcotizacion() {
      this.$store.dispatch('guardarcotizacion', { factura: this.factura });
    },
    imprimircotizacion: function imprimircotizacion() {
      this.$store.dispatch('imprimircotizacion', { cotizacion: this.cliente });
    },
    resetbusqueda: function resetbusqueda() {
      this.nombreproducto = '';
      this.$store.commit('actualizarproductos', []);
    },
    focusbusqueda: function focusbusqueda() {
      var vm = this;
      setTimeout(function () {
        vm.$refs.searchprodi.focus();
      }, 100);
    }
  },
  computed: {
    productos: function productos() {
      return this.$store.getters.productos;
    },
    haslineas: function haslineas() {
      if (this.lineas.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hascotizacion: function hascotizacion() {
      return this.$store.getters.hascotizacion;
    },
    lineas: function lineas() {
      return this.$store.getters.lineascotizacion;
    },
    total: function total() {
      var temptotal = 0;
      this.lineas.map(function (dato) {
        temptotal += dato.cantidad * dato.precio;
      });
      return temptotal.toFixed(2) || 0;
    },
    cliente: function cliente() {
      return this.$store.getters.clientescotizacion;
    },
    producto: function producto() {
      return this.$store.getters.producto;
    },
    fecha: function fecha() {
      var fecha = new Date(this.$store.getters.clientescotizacion.fecha);
      return fecha.toLocaleDateString('es-gt');
    },
    listado: {
      get: function get() {
        return this.$store.getters.listado || '';
      },
      set: function set(dato) {
        this.$store.commit('updateselect', dato);
      }
    },
    dialog: {
      get: function get() {
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    },
    precio: function precio() {
      var porcentaje = this.listado.porcentaje / 100;
      if (this.presentacion.presentacion === 'unidad') {
        return (this.producto.preciounidad * porcentaje + this.producto.preciounidad * 1).toFixed(2);
      }
      if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
        console.log('se ejecuto');
        return (this.presentacion.unidades * this.producto.precio_costo * this.listado.porcentaje / 100 + this.producto.precio_costo * this.presentacion.unidades).toFixed(2);
      }
      return (this.producto.preciounidad * porcentaje + this.producto.preciounidad * 1).toFixed(2) * this.presentacion.unidades;
    },
    presentaciones: function presentaciones() {
      return this.$store.getters.presentaciones;
    },
    presentacion: {
      get: function get() {
        return this.$store.getters.presentacion;
      },
      set: function set(dato) {
        this.$store.commit('actualizarpresentacion', dato);
      }
    },
    error: function error() {
      return this.$store.getters.error_numero;
    },
    cambio: function cambio() {
      return (this.total - this.efectivo).toFixed(2);
    },
    message_error: function message_error() {
      return this.$store.getters.message_error;
    },
    numerosaletras: function numerosaletras() {
      return __WEBPACK_IMPORTED_MODULE_1__librerias_numerosaletras__["a" /* default */].NumeroALetras(this.total, {
        plural: 'QUETZALES',
        singular: 'QUETZAL',
        centPlural: 'CENTAVOS',
        centSingular: 'CENTAVOS'
      });
    },
    validatefactura: function validatefactura() {
      if (this.lineas.length === 13) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__ = __webpack_require__(31);



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getbancos');
    this.$store.dispatch('requestcaja');
  },
  data: function data() {
    return {
      vcheque: '',
      boleta1: 0,
      boleta2: 0,
      boleta3: 0,
      boleta_n1: '',
      boleta_n2: '',
      boleta_n3: '',
      v100: '',
      v200: '',
      v50: '',
      v20: '',
      v10: '',
      v5: '',
      v1: '',
      v050: '',
      v025: '',
      v010: '',
      v005: '',
      m1: '',
      recibo: '',
      banco: {},
      banco2: {},
      banco3: {}
    };
  },

  computed: {
    bancos: function bancos() {
      return this.$store.getters.bancos;
    },
    banco: {
      get: function get() {
        return this.$store.getters.getbanco;
      },
      set: function set(dato) {
        this.$store.commit('actualizarbanco', dato);
      }
    },
    banco2: {
      get: function get() {
        return this.$store.getters.getbanco2;
      },
      set: function set(dato) {
        this.$store.commit('actualizarbanco2', dato);
      }
    },
    banco3: {
      get: function get() {
        return this.$store.getters.getbanco3;
      },
      set: function set(dato) {
        this.$store.commit('actualizarbanco3', dato);
      }
    },
    total: function total() {
      var cheque = this.vcheque !== '' ? this.vcheque : 0;
      var boleta1 = this.boleta1 !== '' ? this.boleta1 : 0;
      var boleta2 = this.boleta2 !== '' ? this.boleta2 : 0;
      var boleta3 = this.boleta3 !== '' ? this.boleta3 : 0;
      var vd100 = this.v100 !== '' ? this.v100 : 0;
      var vd200 = this.v200 !== '' ? this.v200 : 0;
      var vd50 = this.v50 !== '' ? this.v50 : 0;
      var vd20 = this.v20 !== '' ? this.v20 : 0;
      var vd10 = this.v10 !== '' ? this.v10 : 0;
      var vd5 = this.v5 !== '' ? this.v5 : 0;
      var vd1 = this.v1 !== '' ? this.v1 : 0;
      var md1 = this.m1 !== '' ? this.m1 : 0;
      var vd050 = this.v050 !== '' ? this.v050 : 0;
      var vd025 = this.v025 !== '' ? this.v025 : 0;
      var vd010 = this.v010 !== '' ? this.v010 : 0;
      var vd005 = this.v005 !== '' ? this.v005 : 0;
      var recibo = this.recibo !== '' ? this.recibo : 0;
      return (parseInt(cheque) + parseFloat(boleta1) + parseFloat(boleta2) + parseFloat(recibo) + parseFloat(boleta3) + parseInt(vd100) * 100 + parseInt(vd200) * 200 + parseInt(vd50) * 50 + parseInt(vd20) * 20 + parseInt(vd10) * 10 + parseInt(vd5) * 5 + parseInt(vd1) * 1 + parseInt(md1) * 1 + parseFloat(vd050) * 0.50 + parseFloat(vd025) * 0.25 + parseFloat(vd010) * 0.10 + parseFloat(vd005) * 0.05).toFixed(2);
    },
    caja: function caja() {
      console.log(this.$store.getters.getCaja);
      return this.$store.getters.getCaja[0];
    },
    diferencia: function diferencia() {
      return (this.caja.total - this.total).toFixed(2);
    },
    cuadrado: function cuadrado() {
      if (this.diferencia > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    editarcaja: function editarcaja() {
      var sencillo = parseFloat(this.caja.sencillo);
      var cheque = this.vcheque !== '' ? this.vcheque : 0;
      var boleta1 = this.boleta1 !== '' ? this.boleta1 : 0;
      var boleta2 = this.boleta2 !== '' ? this.boleta2 : 0;
      var boleta3 = this.boleta3 !== '' ? this.boleta3 : 0;
      var vd100 = this.v100 !== '' ? this.v100 : 0;
      var vd200 = this.v200 !== '' ? this.v200 : 0;
      var vd50 = this.v50 !== '' ? this.v50 : 0;
      var vd20 = this.v20 !== '' ? this.v20 : 0;
      var vd10 = this.v10 !== '' ? this.v10 : 0;
      var vd5 = this.v5 !== '' ? this.v5 : 0;
      var vd1 = this.v1 !== '' ? this.v1 : 0;
      var md1 = this.m1 !== '' ? this.m1 : 0;
      var vd050 = this.v050 !== '' ? this.v050 : 0;
      var vd025 = this.v025 !== '' ? this.v025 : 0;
      var vd010 = this.v010 !== '' ? this.v010 : 0;
      var vd005 = this.v005 !== '' ? this.v005 : 0;
      var recibo = this.recibo !== '' ? this.recibo : 0;
      var data = {
        'boleta1': boleta1,
        'boleta2': boleta2,
        'boleta3': boleta3,
        'boleta_n1': this.boleta_n1,
        'boleta_n2': this.boleta_n2,
        'boleta_n3': this.boleta_n3,
        'cheque': cheque,
        'b200': vd200,
        'b100': vd100,
        'b50': vd50,
        'b20': vd20,
        'b10': vd10,
        'b5': vd5,
        'b1': vd1,
        'md1': md1,
        'm50': vd050,
        'm25': vd025,
        'm10': vd010,
        'm5': vd005,
        'recibo': recibo,
        'entrega': parseFloat(this.total + sencillo).toFixed(2),
        'banco_boleta1': this.banco.id,
        'banco_boleta2': this.banco2.id,
        'banco_boleta3': this.banco3.id
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["x" /* caja */] + this.caja.id + '/', data, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (data) {
        alert('Cuadrado exitosamente');
        window.reload();
      }, function (response) {
        alert('Ocurrio un erro no se pudo guardar');
      });
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('requestextracciones');
  },
  data: function data() {
    return {};
  },

  computed: {
    extracciones: function extracciones() {
      return this.$store.getters.getextracciones;
    }
  },
  methods: {
    redireccion: function redireccion() {
      this.$router.push('/extraccionadd');
    },
    eliminarextraccion: function eliminarextraccion(e) {
      var r = confirm(' esta seguro que desea eliminar ' + e.tipo_nombre);
      if (r === true) {
        this.$store.dispatch('eliminarextraccion', e);
      }
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getrutas');
    this.$store.dispatch('getusuarios');
    if (this.$store.state.ruta.nombre !== null || this.$store.state.usuario.username !== null || this.$store.getters.getdesde || this.$store.getters.gethasta) {
      this.$store.dispatch('actualizarfacturas', { ruta: this.$store.state.ruta.nombre,
        usuario: this.$store.state.usuario.username,
        fecha_minima: this.$store.getters.getdesde,
        fecha_maxima: this.$store.getters.gethasta });
    } else {
      this.$store.dispatch('actualizarfacturas');
    }
  },
  data: function data() {
    return {
      menu: false,
      menu2: false,
      fechainicio: '',
      fechafin: '',
      search: ''
    };
  },

  methods: {
    redireccion: function redireccion() {
      this.$store.commit('resetfactura');
      this.$router.push('/facturaadd');
    },
    eliminar: function eliminar(factura) {
      var r = confirm(' esta seguro que desea eliminar ' + factura.cliente_name);
      if (r === true) {
        this.$store.dispatch('eliminarfactura', factura);
      }
    },

    editarfactura: function editarfactura(factura) {
      var _this = this;

      this.$store.commit('resetfactura');
      this.$store.commit('actualizarfactura', factura);
      this.$store.commit('actualizarestadofactura', true);
      this.$store.dispatch('getcliente', factura.cliente);
      factura.lineas.map(function (linea) {
        _this.$store.commit('actualizarlinea', linea);
      });
      this.$router.push('facturaadd');
    },
    filtrarfechafin: function filtrarfechafin() {
      console.log(this.$store.getters.gethasta);
      console.log(this.$store.getters.getdesde);
      this.$store.dispatch('actualizarfacturas', { fecha_maxima: this.$store.getters.gethasta,
        ruta: this.$store.getters.getruta.nombre ? this.$store.getters.getruta.nombre : '',
        usuario: this.$store.getters.getusuario.username ? this.$store.getters.getusuario.username : '',
        fecha_minima: this.$store.getters.getdesde });
    },
    filtrarfechainicio: function filtrarfechainicio() {
      console.log(this.$store.getters.gethasta);
      console.log(this.$store.getters.getdesde);
      this.$store.dispatch('actualizarfacturas', { fecha_maxima: this.$store.getters.gethasta,
        ruta: this.$store.getters.getruta.nombre ? this.$store.getters.getruta.nombre : '',
        usuario: this.$store.getters.getusuario.username ? this.$store.getters.getusuario.username : '',
        fecha_minima: this.$store.getters.getdesde });
    },
    filtrarruta: function filtrarruta(ruta) {
      this.$store.dispatch('actualizarfacturas', { fecha_maxima: this.$store.getters.gethasta,
        ruta: ruta.nombre,
        usuario: this.$store.getters.getusuario.username ? this.$store.getters.getusuario.username : '',
        fecha_minima: this.$store.getters.getdesde });
    },
    filtrarusuario: function filtrarusuario(usuario) {
      this.$store.dispatch('actualizarfacturas', { fecha_maxima: this.$store.getters.gethasta,
        usuario: usuario.username,
        ruta: this.$store.getters.getruta.nombre ? this.$store.getters.getruta.nombre : '',
        fecha_minima: this.$store.getters.getdesde });
    },
    buscarfactura: function buscarfactura() {
      this.$store.dispatch('actualizarfacturas', { search: this.search });
    },
    next: function next(dato) {
      this.$store.dispatch('actualizarfacturas2', dato);
    },
    prev: function prev(dato) {
      this.$store.dispatch('actualizarfacturas2', dato);
    }
  },
  computed: {
    headers: function headers() {
      return this.$store.getters.list_facturas_headers;
    },
    facturas: function facturas() {
      return this.$store.getters.listadofacturas;
    },
    rutas: function rutas() {
      return this.$store.getters.rutas;
    },
    usuarios: function usuarios() {
      return this.$store.getters.usuarios;
    },
    ruta: {
      get: function get() {
        return this.$store.getters.getruta;
      },
      set: function set(dato) {
        this.$store.commit('actualizarruta', dato);
      }
    },
    usuario: {
      get: function get() {
        return this.$store.getters.getusuario;
      },
      set: function set(dato) {
        this.$store.commit('actualizarusuario', dato);
      }
    },
    desde: {
      get: function get() {
        return this.$store.getters.getdesde;
      },
      set: function set(dato) {
        this.$store.commit('actualizardesde', dato);
      }
    },
    hasta: {
      get: function get() {
        return this.$store.getters.gethasta;
      },
      set: function set(dato) {
        this.$store.commit('actualizarhasta', dato);
      }
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fcliente_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fcliente_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Fcliente_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__librerias_numerosaletras__ = __webpack_require__(41);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'cliente-factura': __WEBPACK_IMPORTED_MODULE_2__Fcliente_vue___default.a },
  created: function created() {
    this.$store.commit('actualizarmessageactual', this.factura.observaciones);
    this.$refs.cantidad.focus();
  },
  mounted: function mounted() {
    this.$refs.search.focus();
  },
  data: function data() {
    return {
      cantidad: 1,
      iscredito: false,
      prueba: true,
      foco: false,
      nombreproducto: '',
      dialogbusqueda: false,
      dialogEditarCliente: false,
      escambio: false,
      efectivo: '',
      message: false,
      messagemotivo: false,
      motivos: ['Cerrado', 'Ausente', 'Compra Barato', 'Tiene Producto'],
      headers: [{ text: 'Cantidad' }, { text: ' Presentación' }, { text: 'Descripción' }, { text: 'Precio' }, { text: 'Subtotal' }]
    };
  },

  methods: {
    impresion: function impresion() {
      this.dialog = true;
    },
    searchproducto: function searchproducto() {
      this.$store.dispatch('buscarproducto', { producto: this.producto.barra, bodega: this.factura.bodega });
      if (localStorage.getItem('usuario') === '1' || localStorage.getItem('usuario') === 'L2') {
        this.$refs.cantidad.focus();
      }
    },
    searchproductodialog: function searchproductodialog(event) {
      this.$store.commit('actualizar_success', event.has_bonificacion && event.existencia > 0);
      this.$store.commit('actualizarmessage_success', 'Este producto tiene bonificación');
      if (event.barra) {
        this.$store.dispatch('buscarproducto', { producto: event.barra, bodega: this.factura.bodega });
      } else {
        this.$store.dispatch('buscarproducto', { producto: event.codigo, bodega: this.factura.bodega });
      }
      if (localStorage.getItem('usuario') === '1' || localStorage.getItem('usuario') === 'L2') {
        this.$refs.cantidad.focus();
      }
    },
    searchproductos: function searchproductos() {
      this.$store.dispatch('buscarproductos', { producto: this.nombreproducto, bodega: this.factura.bodega });
    },
    checklista: function checklista() {
      var _this = this;

      if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
        var listadoordenado = this.producto.listaprecios.sort(function (dato1, dato2) {
          return dato1.minimo - dato2.minimo;
        });
        var listas = [];
        var lista = [];
        listadoordenado.map(function (dato) {
          if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <= _this.cantidad * _this.presentacion.unidades) {
            listas.push(dato);
          }
        });
        if (listas.length > 0) {
          lista = listas.reverse();
          this.$store.commit('updateselect', lista[0]);
        } else {
          listas = listadoordenado.map(function (dato) {
            if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
              lista.push(dato);
            }
          });
          this.$store.commit('updateselect', lista[0]);
        }
      }
    },
    redondear: function redondear(cantidad) {
      var exponente = 100;
      var prueba = cantidad.toFixed(2);
      var reciduo = parseInt((prueba * exponente).toFixed() % 5);
      if (reciduo !== 0) {
        return (parseInt((cantidad.toFixed(2) * exponente).toFixed()) + 5 - reciduo) / exponente;
      } else {
        return cantidad.toFixed(2) * exponente / exponente;
      }
    },
    guardarventa: function guardarventa() {
      var precio = 0;
      var cantidad = 0;
      this.$store.commit('setguardando', true);
      if (this.escambio) {
        precio = 0;
      } else {
        precio = this.precio;
      }
      this.escambio = false;
      if (this.cantidad < 0) {
        cantidad = this.cantidad * -1;
      } else {
        cantidad = this.cantidad;
      }
      if (this.$store.getters.lineasfactura.length <= 30 || localStorage.getItem('usuario') === '1' || localStorage.getItem('usuario') === 'L2') {
        this.$store.dispatch('insertarlinea', { producto: this.producto.id,
          factura: this.factura.id,
          precio: precio,
          cantidad: cantidad,
          presentacion: this.presentacion.presentacion,
          listaprecio: this.listado.id
        });
      }
      this.cantidad = 1;
      this.$refs.search.focus();
    },
    nuevafactura: function nuevafactura() {
      var id = this.cliente.id;
      this.$store.dispatch('crearfactura2', id);
      this.cantidad = 1;
      this.$refs.search.focus();
    },
    cambiarcredito: function cambiarcredito() {
      this.$store.dispatch('actualizartipofactura', { factura: this.factura });
    },
    cambiarenvio: function cambiarenvio() {
      this.$store.dispatch('actualizarenvio', { factura: this.factura });
    },
    cambiarcomentario: function cambiarcomentario() {
      this.$store.dispatch('actualizarcomentario', { factura: this.factura });
    },
    imprimirelectronica: function imprimirelectronica() {
      if (this.lineas.length === 0) {
        this.$store.commit('actualizarerror', true);
        this.$store.commit('actualizarmessage_error', 'por favor ingrese productos');
      } else {
        this.$store.dispatch('imprimirfacturaelectronica', { factura: this.factura });
      }
    },
    cambiarcomentariomotivo: function cambiarcomentariomotivo() {
      this.$store.dispatch('actualizarcomentario', { factura: this.factura });
    },
    eliminar: function eliminar(linea) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var a;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                a = confirm('desea eliminar ' + linea.producto_name);

                if (a) {
                  _this2.$store.commit('setEliminando', true);
                  _this2.$store.dispatch('eliminarlineafactura', linea);
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    guardardatosfactura: function guardardatosfactura() {
      if (this.lineas.length === 0) {
        this.$store.commit('actualizarerror', true);
        this.$store.commit('actualizarmessage_error', 'por favor ingrese productos');
      } else {
        this.$store.dispatch('actualizarnumerofactura', { factura: this.factura });
      }
    },
    guardarfactura: function guardarfactura() {
      this.$store.dispatch('guardarfactura', { factura: this.factura });
    },
    guardarcliente: function guardarcliente() {
      this.$store.dispatch('editarclientefactura', this.cliente);
    },
    resetbusqueda: function resetbusqueda() {
      this.nombreproducto = '';
      this.$store.commit('actualizarproductos', []);
    },
    focusbusqueda: function focusbusqueda() {
      var vm = this;
      setTimeout(function () {
        vm.$refs.searchprodi.focus();
      }, 100);
    },
    actualizarbodega: function actualizarbodega(event) {
      var _this3 = this;

      if (this.haslineas) {
        var a = confirm('al cambiar se eliminaran todos los productos de la factura');
        if (a) {
          if (this.haslineas) {
            this.lineas.forEach(function (dato) {
              _this3.$store.dispatch('eliminarlineafactura', dato);
              if (!_this3.haslineas) {
                _this3.$store.dispatch('actualizarbodega', { factura: _this3.factura });
              } else {
                _this3.factura.bodega = !event;
              }
            });
          }
        } else {
          this.factura.bodega = !event;
        }
      } else {
        this.$store.dispatch('actualizarbodega', { factura: this.factura });
      }
    }
  },
  computed: {
    eliminando: function eliminando() {
      return this.$store.getters.getEliminando;
    },
    usuario: function usuario() {
      return localStorage.getItem('usuario');
    },
    productos: function productos() {
      return this.$store.getters.productos;
    },
    grabando: function grabando() {
      return this.$store.getters.getguardando;
    },
    barra: {
      get: function get() {
        return this.$store.getters.producto.barra;
      },
      set: function set(event) {
        this.$store.commit('actualizarbarra', event);
      }
    },
    tipo: function tipo() {
      return this.$store.getters.gettipo;
    },
    vender_bodega: function vender_bodega() {
      console.log(localStorage.getItem('puede_vender_bodega'));
      console.log(this.$store.getters.get_vender_bodega);
      if (this.$store.getters.get_vender_bodega) {
        return this.$store.getters.get_vender_bodega;
      } else {
        return localStorage.getItem('puede_vender_bodega') === 'true';
      }
    },
    haslineas: function haslineas() {
      if (this.lineas.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hasfactura: function hasfactura() {
      return this.$store.getters.hasfactura;
    },
    factura: function factura() {
      return this.$store.getters.factura;
    },
    lineas: function lineas() {
      return this.$store.getters.lineasfactura;
    },
    total: function total() {
      var temptotal = 0;
      this.lineas.map(function (dato) {
        temptotal += dato.cantidad * dato.precio;
      });
      return this.redondear(temptotal).toFixed(2) || 0;
    },
    cliente: function cliente() {
      return this.$store.getters.cliente;
    },
    producto: function producto() {
      return this.$store.getters.producto;
    },
    fecha: function fecha() {
      var fecha = new Date(this.$store.getters.factura.fecha);
      return fecha.toLocaleDateString('es-gt');
    },
    hora: function hora() {
      var fecha = new Date(this.$store.getters.factura.fecha);
      return fecha.toLocaleTimeString('es-gt');
    },
    listado: {
      get: function get() {
        return this.$store.getters.listado || '';
      },
      set: function set(dato) {
        this.$store.commit('updateselect', dato);
      }
    },
    dialog: {
      get: function get() {
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    },
    precio: {
      get: function get() {
        if (this.presentacion.presentacion === 'unidad') {
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100)) * this.presentacion.unidades;
        }
        if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades);
        }
        return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades);
      }
    },
    presentaciones: function presentaciones() {
      return this.$store.getters.presentaciones;
    },
    presentacion: {
      get: function get() {
        if (this.$store.getters.presentacion) {
          return this.$store.getters.presentacion;
        } else {
          return '';
        }
      },
      set: function set(dato) {
        this.$store.commit('actualizarpresentacion', dato);
      }
    },
    error: function error() {
      return this.$store.getters.error_numero;
    },
    success: function success() {
      return this.$store.getters.success;
    },
    cambio: function cambio() {
      return (this.total - this.efectivo).toFixed(2);
    },
    message_error: function message_error() {
      return this.$store.getters.message_error;
    },
    message_success: function message_success() {
      return this.$store.getters.message_success;
    },
    numerosaletras: function numerosaletras() {
      return __WEBPACK_IMPORTED_MODULE_3__librerias_numerosaletras__["a" /* default */].NumeroALetras(this.total, {
        plural: 'QUETZALES',
        singular: 'QUETZAL',
        centPlural: 'CENTAVOS',
        centSingular: 'CENTAVOS'
      });
    },
    validatefactura: function validatefactura() {
      if (this.lineas.length === 30 && localStorage.getItem('usuario') !== '1' && localStorage.getItem('usuario') !== 'L2') {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      semanas: [{ text: 'Semana1', value: 1 }, { text: 'Semana2', value: 2 }, { text: 'Semana3', value: 3 }, { text: 'Semana4', value: 4 }],
      dias: [{ text: '1', value: 1 }, { text: '2', value: 2 }, { text: '3', value: 3 }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '6', value: 6 }],
      dia: '',
      semana: '',
      esruta: false
    };
  },

  methods: {
    buscarcliente: function buscarcliente() {
      if (this.cliente.nit || this.cliente.codigo) {
        if (this.cliente.nombre && this.cliente.direccion && this.searcherror === true) {
          var dato = this.cliente;
          if (this.ruta) {
            dato['ruta'] = this.ruta.id;
          }
          this.$store.dispatch('crearcliente', dato);
        } else if (this.cliente.nombre && this.cliente.direccion && this.searcherror === false) {
          this.$store.dispatch('crearfactura', this.cliente.id);
        } else {
          this.$store.dispatch('buscarclientes', this.cliente.nit || this.cliente.codigo);
        }
      } else if (this.cliente.nombre && this.cliente.direccion) {
        var _dato = this.cliente;
        if (this.ruta) {
          _dato['ruta'] = this.ruta.id;
        }
        this.$store.dispatch('crearcliente', _dato);
      } else {
        this.$store.commit('actualizarcliente', { 'nombre': '', 'direccion': '', 'ruta': '' });
      }
    }
  },
  computed: {
    cliente: function cliente() {
      return this.$store.getters.cliente;
    },
    searcherror: function searcherror() {
      return this.$store.getters.get_error_searchcliente;
    },
    factura: function factura() {
      return this.$store.getters.factura;
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  created: function created() {
    if (window.localStorage.getItem('token')) {
      this.$store.dispatch('getfacturas');
    }
    this.$router.push({ path: '/login' });
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getkilometraje');
  },
  data: function data() {
    return {
      auto_name: ''
    };
  },

  methods: {
    eliminar: function eliminar(dato) {
      this.$store.dispatch('eliminarkilometraje', dato);
    },
    filtrarfechainicio: function filtrarfechainicio() {
      console.log(this.fechainicio);
    },
    editarkilometraje: function editarkilometraje() {
      var dato = this.$store.getters.akilometraje;
      console.log(dato);
      var data = {
        'vehiculo': this.$store.getters.vehiculo.id,
        'fecha': dato.fecha,
        'kilometraje_inicial': dato.kilometraje_inicial,
        'total_facturas': dato.total_facturas,
        'kilometrage': dato.kilometraje,
        'comentario': dato.comentario
      };
      if (dato.kilometraje) {
        data.kilometraje = dato.kilometraje;
      }
      this.$store.dispatch('crearkilometraje', data);
      this.$store.commit('actualizardialog', false);
    },
    cerrar: function cerrar() {
      this.$store.commit('actualizardialog', false);
    }
  },
  computed: {
    kilometraje: function kilometraje() {
      return this.$store.getters.kilometraje;
    },
    akilometraje: function akilometraje() {
      return this.$store.getters.akilometraje;
    },

    dialog: {
      get: function get() {
        this.$store.dispatch('getvehiculos');
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    },
    vehiculo: {
      get: function get() {
        return this.$store.getters.vehiculo;
      },
      set: function set(dato) {
        this.$store.commit('actualizarvehiculo', dato);
      }
    },
    vehiculos: function vehiculos() {
      return this.$store.getters.vehiculos;
    },
    tipo: function tipo() {
      return this.$store.getters.gettipo;
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getkilometrajevendedor');
  },
  data: function data() {
    return {
      auto_name: '',
      fecha: ''
    };
  },

  methods: {
    eliminar: function eliminar(dato) {
      this.$store.dispatch('eliminarkilometrajevendedor', dato);
    },
    editarkilometraje: function editarkilometraje() {
      var dato = this.$store.getters.akilometrajevendedor;
      var data = dato;
      this.$store.dispatch('crearkilometrajevendedor', data);
      this.$store.commit('actualizardialog', false);
    },
    editar: function editar(dato) {
      this.$store.commit('actualizardialog', true);
      this.$store.commit('actualizarakilometrajevendedor', dato);
    },

    cerrar: function cerrar() {
      this.$store.commit('actualizardialog', false);
    }
  },
  computed: {
    kilometraje: function kilometraje() {
      return this.$store.getters.kilometrajevendedor;
    },
    akilometraje: function akilometraje() {
      return this.$store.getters.akilometrajevendedor;
    },

    dialog: {
      get: function get() {
        return this.$store.getters.dialogo;
      },
      set: function set(dato) {
        this.$store.commit('actualizardialog', dato);
      }
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (window.localStorage.getItem('token')) {
      this.$router.push({ path: 'home' });
    }
  },
  data: function data() {
    return {
      login: {
        username: '',
        password: ''
      }
    };
  },

  methods: {
    loguear: function loguear() {
      this.$store.dispatch('login', this.login);
    }
  },
  computed: {
    error_login: function error_login() {
      if (this.$store.getters.error_authenticated) {
        return ['usuario o contraseña incorrectas'];
      }
      return [!this.$store.getters.error_authenticate];
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__ = __webpack_require__(31);



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('getrutas');
    this.$store.dispatch('getusuarios');
  },
  data: function data() {
    return {
      menu: false,
      menu2: false,
      fechainicio: '',
      fechafin: '',
      ruta: '',
      usuario: [],
      extra: '',
      comentario: '',
      serie: '1',
      inicio: '1',
      dialogbusqueda: false,
      confirmacion: null,
      nombre_tabulacion: null,
      horainicio: '',
      horafin: '',
      disable: false
    };
  },

  methods: {
    filtrarusuario: function filtrarusuario(usuario) {
      console.log(this.usuario);
      this.ruta = '';
    },
    filtrarruta: function filtrarruta(ruta) {
      this.usuario = [];
    },
    filtrarfechafin: function filtrarfechafin() {
      console.log(this.fechafin);
    },
    filtrarfechainicio: function filtrarfechainicio() {
      console.log(this.fechainicio);
    },
    focusbusqueda: function focusbusqueda() {
      var vm = this;
      setTimeout(function () {
        vm.$refs.searchprodi.focus();
      }, 100);
    },

    generar: function generar() {
      var _this = this;

      var entregado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var idusuarios = '';
      this.usuario.forEach(llenarusuarios);
      function llenarusuarios(element) {
        idusuarios = idusuarios + '' + element['id'].toString() + ',';
      }
      if (this.nombre_tabulacion != null && (this.confirmacion == null || this.confirmacion === '')) {
        alert('ingrese la contraseña');
      }
      if (this.ruta !== '' | this.usuario !== [] && this.fechainicio && this.fechafin) {
        this.disable = 1;
        alert('generando reporte pdf, cierre esta ventana y  espere un momento');
        this.$http.get(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdfgeneration', { params: {
            ruta: this.ruta.nombre,
            usuario: idusuarios,
            extra: this.extra,
            comentario: this.comentario,
            fechaminima: this.fechainicio,
            fechamaxima: this.fechafin,
            serie: this.serie,
            inicio: this.inicio,
            confirmacion: this.confirmacion,
            nombre_tabulacion: this.nombre_tabulacion,
            horamaxima: this.horafin,
            horaminima: this.horainicio,
            entregado: entregado
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') },
          responseType: 'arraybuffer' }).then(function (response) {
          if (response.status === 200) {
            var blob = new Blob([response.body], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            window.open(link.href);
            _this.disable = 0;
          } else {
            alert('Este número de taulación ya existe por favor agregue extra');
            alert('Este número de taulación ya existe por favor agregue extra' + response.status);
            _this.disable = 0;
          }
        }, function (response2) {
          if (response2.status === 403) {
            alert('contraseña incorrecta');
          } else if (response2.status === 500) {
            alert('A ocurrido un error al generar la tabulación');
          } else {
            alert('Este número de taulación ya existe por favor agregue extra');
          }
        }, this.disable = 0);
      }
    },
    generartabulacion: function generartabulacion() {
      var _this2 = this;

      var entregado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var idusuarios = '';
      this.usuario.forEach(llenarusuarios);
      function llenarusuarios(element) {
        idusuarios = idusuarios + '' + element['id'].toString() + ',';
      }
      if (this.ruta !== '' | this.usuario !== [] && this.fechainicio && this.fechafin) {
        this.disable = 1;
        alert('generando reporte pdf, cierre esta ventana y  espere un momento');
        this.$http.get(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdftabulacion', { params: {
            ruta: this.ruta.nombre,
            usuario: idusuarios,
            extra: this.extra,
            comentario: this.comentario,
            fechaminima: this.fechainicio,
            fechamaxima: this.fechafin,
            serie: this.serie,
            inicio: this.inicio,
            confirmacion: this.confirmacion,
            horamaxima: this.horafin,
            horaminima: this.horainicio,
            entregado: entregado
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') },
          responseType: 'arraybuffer' }).then(function (response) {
          var blob = new Blob([response.body], { type: 'application/pdf' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href);
          _this2.disable = 0;
        });
      }
    },
    generarcomentarios: function generarcomentarios() {
      var _this3 = this;

      var entregado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var idusuarios = '';
      this.usuario.forEach(llenarusuarios);
      function llenarusuarios(element) {
        idusuarios = idusuarios + '' + element['id'].toString() + ',';
      }
      if (this.ruta !== '' | this.usuario !== [] && this.fechainicio && this.fechafin) {
        this.disable = 1;
        alert('generando reporte pdf, cierre esta ventana y  espere un momento');
        this.$http.get(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/pdfcomentarios', { params: {
            ruta: this.ruta.nombre,
            usuario: idusuarios,
            extra: this.extra,
            fechaminima: this.fechainicio,
            fechamaxima: this.fechafin,
            serie: this.serie,
            inicio: this.inicio,
            confirmacion: this.confirmacion,
            horamaxima: this.horafin,
            horaminima: this.horainicio,
            entregado: entregado
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') },
          responseType: 'arraybuffer' }).then(function (response) {
          var blob = new Blob([response.body], { type: 'application/ms-excel' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href);
          _this3.disable = 0;
        });
      }
    },
    obteneridsfactura: function obteneridsfactura() {
      var _this4 = this;

      var entregado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var idusuarios = '';
      this.usuario.forEach(llenarusuarios);
      function llenarusuarios(element) {
        idusuarios = idusuarios + '' + element['id'].toString() + ',';
      }
      if (this.ruta !== '' | this.usuario !== [] && this.fechainicio && this.fechafin) {
        this.disable = 1;
        alert('generando reporte pdf, cierre esta ventana y  espere un momento');
        this.$http.get(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/listadofactura', { params: {
            ruta: this.ruta.nombre,
            usuario: idusuarios,
            extra: this.extra,
            fechaminima: this.fechainicio,
            fechamaxima: this.fechafin,
            serie: this.serie,
            inicio: this.inicio,
            confirmacion: this.confirmacion,
            horamaxima: this.horafin,
            horaminima: this.horainicio,
            entregado: entregado
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
          _this4.$store.commit('setidsfactura', response.body);
          var ids = _this4.$store.getters.getidfactura;
          _this4.$store.dispatch('imprimirfacturaelectronica2', { factura: { id: ids.pop() } });
          _this4.$store.commit('setidsfactura', ids);
          _this4.disable = 0;
        });
      }
    },
    generarexcel: function generarexcel() {
      var idusuarios = '';
      this.usuario.forEach(llenarusuarios);
      function llenarusuarios(element) {
        idusuarios = idusuarios + '' + element['id'].toString() + ',';
      }
      if (this.ruta !== '' | this.usuario !== [] && this.fechainicio && this.fechafin) {
        alert('generando reporte de excel por favor cierre esta ventana y espere un momento');
        this.$http.get(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["a" /* baseurl */] + '/apicatalogos/xlsgeneration', { params: {
            ruta: this.ruta.nombre,
            extra: this.extra,
            fechaminima: this.fechainicio,
            fechamaxima: this.fechafin,
            serie: this.serie,
            inicio: this.inicio,
            confirmacion: this.confirmacion,
            horamaxima: this.horafin,
            horaminima: this.horainicio,
            usuario: idusuarios
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') },
          responseType: 'arraybuffer' }).then(function (response) {
          var blob = new Blob([response.body], { type: 'application/ms-excel' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href);
        });
      }
    }
  },
  computed: {
    rutas: function rutas() {
      return this.$store.getters.rutas;
    },
    usuarios: function usuarios() {
      return this.$store.getters.usuarios;
    },
    disabled: function disabled() {
      if (this.disable) {
        return true;
      }
      return false;
    },
    tipo: function tipo() {
      return this.$store.getters.gettipo;
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__ = __webpack_require__(31);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      auto_name: '',
      buscador: '',
      activo: '',
      caja: '',
      codigotabulacion: '',
      multitabulacion: false,
      dialogbusqueda: false,
      buscotabulacion: false,
      dialogcuadrar: false,
      dialognuevo: false,
      dialogrevision: false,
      native: false,
      codigo: '',
      nombreproducto: '',
      cantidad: 1,
      tbilletes: true,
      tmonedas: false,
      totros: false,
      tgastos: false,
      b200: null,
      codigotabulacion2: '',
      gastos: 0,
      gastos_factura: 0,
      b100: 0,
      b50: 0,
      b20: 0,
      b10: 0,
      b5: 0,
      b1: 0,
      m1: 0,
      m50: 0,
      m25: 0,
      m10: 0,
      m5: 0,
      boleta: 0,
      no_boleta: '',
      no_boleta2: '',
      no_boleta3: '',
      observaciones: '',
      cheque: 0,
      deuda: 0,
      revision: {
        tres_candados: false,
        llantas_con_aire: false,
        limpiez_cabina: false,
        limpieza_frurgon: false,
        troquet: false,
        en_buen_estado: false,
        lavado: false
      }
    };
  },

  methods: {
    buscar: function buscar() {
      if (this.multitabulacion) {
        this.$store.dispatch('actualizardevoluciones', { tabulacion: this.codigotabulacion,
          tabulacion2: this.codigotabulacion2 });
      } else {
        this.$store.dispatch('actualizardevoluciones', { tabulacion: this.codigotabulacion });
      }
    },
    editardevolucion: function editardevolucion(producto) {
      var r = confirm(' esta seguro que esta cuadrado ' + producto.producto);
      if (r === true) {
        this.$store.commit('eliminardevolucion', producto);
      }
    },
    guardardevolucion: function guardardevolucion() {
      this.dialogbusqueda = false;
      if (this.multitabulacion) {
        this.$store.dispatch('guardardevolucion', { 'codigo': this.codigo, 'productos': this.$store.getters.listadodevoluciones, 'tabulacion': this.codigotabulacion, 'tabulacion2': this.codigotabulacion2 });
      } else {
        this.$store.dispatch('guardardevolucion', { 'codigo': this.codigo, 'productos': this.$store.getters.listadodevoluciones, 'tabulacion': this.codigotabulacion });
      }
    },
    searchproductos: function searchproductos() {
      this.$store.dispatch('buscarproductos', { producto: this.nombreproducto, bodega: 1 });
    },
    searchproductodialog: function searchproductodialog(event) {
      if (event.barra) {
        this.$store.dispatch('buscarproducto', { producto: event.barra, bodega: 1 });
        this.$store.commit('actualizarproductos', []);
      } else {
        this.$store.dispatch('buscarproducto', { producto: event.codigo, bodega: 1 });
        this.$store.commit('actualizarproductos', []);
      }
      this.$refs.cantidad.focus();
    },

    guardaritemdevolucion: function guardaritemdevolucion() {
      this.$store.commit('agregardevolucion', { id: this.productoactual.id, producto: this.nombreproducto, total: 0, ingreso: this.cantidad, activo: false });
      this.dialognuevo = false;
      this.nombreproducto = '';
      this.cantidad = 1;
    },
    activarbilletes: function activarbilletes() {
      this.tbilletes = true;
      this.tmonedas = false;
      this.totros = false;
      this.tgastos = false;
    },
    activarmonedas: function activarmonedas() {
      this.tbilletes = false;
      this.tmonedas = true;
      this.totros = false;
      this.tgastos = false;
    },
    activarotros: function activarotros() {
      this.tbilletes = false;
      this.tmonedas = false;
      this.tgastos = false;
      this.totros = true;
    },
    activargastos: function activargastos() {
      this.tbilletes = false;
      this.tmonedas = false;
      this.tgastos = true;
      this.totros = false;
    },
    cuadrar: function cuadrar() {
      var _this = this;

      this.buscotabulacion = true;
      if (this.multitabulacion) {
        this.$http.get(__WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["y" /* cuadrarrepartourl */], { params: {
            tabulacion: this.codigotabulacion,
            tabulacion2: this.codigotabulacion2
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
          if (response.body.total) {
            _this.deuda = response.body.total;
            _this.limpiarcaja();
          } else {
            _this.caja = response.body;
            _this.deuda = response.body.total_reparto;
            _this.b200 = response.body.b200;
            _this.b100 = response.body.b100;
            _this.b50 = response.body.b50;
            _this.b20 = response.body.b20;
            _this.b10 = response.body.b10;
            _this.b5 = response.body.b5;
            _this.b1 = response.body.b1;
            _this.m1 = response.body.m1;
            _this.m50 = response.body.m50;
            _this.m25 = response.body.m25;
            _this.m10 = response.body.m10;
            _this.m5 = response.body.m5;
            _this.gastos = response.body.otros_gastos;
            _this.gastos_factura = response.body.gastos_con_factura;
            _this.boleta = response.body.boleta;
            _this.no_boleta = response.body.no_boleta;
            _this.no_boleta2 = response.body.no_boleta2;
            _this.no_boleta3 = response.body.no_boleta3;
            _this.observaciones = response.body.observaciones;
            _this.calificacion = response.body.calificacion;
            _this.cheque = response.body.cheque;
            _this.calificacion = response.body.calificacion;
          }
        });
      } else {
        this.$http.get(__WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["y" /* cuadrarrepartourl */], { params: {
            tabulacion: this.codigotabulacion
          },
          headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
          if (response.body.total) {
            _this.deuda = response.body.total;
            _this.limpiarcaja();
          } else {
            _this.caja = response.body;
            if (_this.caja.tabulacion2) {
              _this.codigotabulacion2 = _this.caja.tabulacion2;
              _this.multitabulacion = true;
            }
            console.log(response.body);
            _this.deuda = response.body.total_reparto;
            _this.b200 = response.body.b200;
            _this.b100 = response.body.b100;
            _this.b50 = response.body.b50;
            _this.b20 = response.body.b20;
            _this.b10 = response.body.b10;
            _this.b5 = response.body.b5;
            _this.b1 = response.body.b1;
            _this.m1 = response.body.m1;
            _this.m50 = response.body.m50;
            _this.m25 = response.body.m25;
            _this.m10 = response.body.m10;
            _this.m5 = response.body.m5;
            _this.gastos = response.body.otros_gastos;
            _this.gastos_factura = response.body.gastos_con_factura;
            _this.boleta = response.body.boleta;
            _this.no_boleta = response.body.no_boleta;
            _this.no_boleta2 = response.body.no_boleta2;
            _this.no_boleta3 = response.body.no_boleta3;
            _this.observaciones = response.body.observaciones;
            _this.calificacion = response.body.calificacion;
            _this.cheque = response.body.cheque;
            _this.inicializarRevision(response.body.revision_data);
          }
          if (response.body.total) {
            _this.inicializarRevision();
          }
        });
      }
    },
    guardarcuadrado: function guardarcuadrado() {
      var _this2 = this;

      var numerotabulacion2 = '0000';
      if (this.multitabulacion) {
        numerotabulacion2 = this.codigotabulacion2;
      } else {
        numerotabulacion2 = null;
      }
      var datos = { numero_tabulacion: this.codigotabulacion,
        numero_tabulacion2: numerotabulacion2,
        total: this.total,
        revision: this.revision,
        deuda: this.deuda,
        b200: this.b200 ? this.b200 : null,
        b100: this.b100 ? this.b100 : null,
        b50: this.b50 ? this.b50 : null,
        b20: this.b20 ? this.b20 : null,
        b10: this.b10 ? this.b10 : null,
        b5: this.b5 ? this.b5 : null,
        b1: this.b1 ? this.b1 : null,
        m50: this.m50 ? this.m50 : null,
        m25: this.m25 ? this.m25 : null,
        m10: this.m10 ? this.m10 : null,
        m5: this.m5 ? this.m5 : null,
        m1: this.m1 ? this.m1 : null,
        cheque: this.cheque ? this.cheque : null,
        boleta: this.boleta ? this.boleta : null,
        no_boleta: this.no_boleta ? this.no_boleta : null,
        no_boleta2: this.no_boleta2 ? this.no_boleta2 : null,
        no_boleta3: this.no_boleta3 ? this.no_boleta3 : null,
        observaciones: this.observaciones ? this.observaciones : null,
        calificacion: this.calificacion ? this.calificacion : null,
        otros_gastos: this.gastos ? this.gastos : null,
        gastos_factura: this.gastos_factura ? this.gastos_factura : null
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["y" /* cuadrarrepartourl */], datos, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  alert('cuadrado con existo');
                  _context.next = 3;
                  return _this2.registrarUbicacionCuadre();

                case 3:
                  _this2.limpiarcaja();
                  window.location.href = '/devoluciones';

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), function (response) {
        alert(response.bodyText);
      });
    },
    inicializarRevision: function inicializarRevision() {
      var revision = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.revision = revision || {
        tres_candados: false,
        llantas_con_aire: false,
        limpiez_cabina: false,
        limpieza_frurgon: false,
        troquet: false,
        en_buen_estado: false,
        lavado: false,
        comentario: ''
      };
    },
    updateTabulacion: function updateTabulacion() {
      var _this3 = this;

      var metodo = this.revision.id ? 'put' : 'post';
      var url = this.revision.id ? __WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["z" /* revisionurl */] + this.revision.id + '/' : __WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["z" /* revisionurl */];
      var datos = this.revision;
      if (!this.revision.id) {
        datos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.revision, { cuadre: this.caja.id });
      }
      this.$http[metodo](url, datos, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
        alert('Guardado Exitosamente');
        _this3.limpiarcaja();
        window.location.href = '/devoluciones';
      }, function (response) {
        console.log(response);
        alert(response.bodyText);
      });
    },
    modificarcuadrado: function modificarcuadrado() {
      var _this4 = this;

      var numerotabulacion2 = '0000';
      if (this.multitabulacion) {
        numerotabulacion2 = this.codigotabulacion2;
      } else {
        numerotabulacion2 = null;
      }
      var datos = { numero_tabulacion: this.codigotabulacion,
        numero_tabulacion2: numerotabulacion2,
        total: this.total,
        deuda: this.deuda,
        b200: this.b200 ? this.b200 : null,
        b100: this.b100 ? this.b100 : null,
        b50: this.b50 ? this.b50 : null,
        b20: this.b20 ? this.b20 : null,
        b10: this.b10 ? this.b10 : null,
        b5: this.b5 ? this.b5 : null,
        b1: this.b1 ? this.b1 : null,
        m50: this.m50 ? this.m50 : null,
        m25: this.m25 ? this.m25 : null,
        m10: this.m10 ? this.m10 : null,
        m5: this.m5 ? this.m5 : null,
        m1: this.m1 ? this.m1 : null,
        cheque: this.cheque ? this.cheque : null,
        boleta: this.boleta ? this.boleta : null,
        no_boleta: this.no_boleta ? this.no_boleta : null,
        no_boleta2: this.no_boleta2 ? this.no_boleta2 : null,
        no_boleta3: this.no_boleta3 ? this.no_boleta3 : null,
        observaciones: this.observaciones ? this.observaciones : null,
        calificacion: this.calificacion ? this.calificacion : null,
        otros_gastos: this.gastos ? this.gastos : null,
        gastos_factura: this.gastos_factura ? this.gastos_factura : null,
        total_reparto: this.deuda
      };
      this.$http.put(__WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["A" /* cuadrarcajareparto */] + this.caja.id + '/', datos, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  alert('cuadrado con existo');
                  _context2.next = 3;
                  return _this4.registrarUbicacionCuadre();

                case 3:
                  _this4.limpiarcaja();
                  window.location.href = '/devoluciones';

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this4);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }(), function (response) {
        alert(response.bodyText);
      });
    },
    registrarUbicacionCuadre: function registrarUbicacionCuadre() {
      var _this5 = this;

      if (!navigator.geolocation) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var tabulacion = _this5.codigotabulacion || 'sin tabulacion';
          _this5.$http.post(__WEBPACK_IMPORTED_MODULE_4__plugins_urlsbackend__["B" /* ubicacioncuadreurl */], {
            numero_tabulacion: tabulacion,
            ubicacion: position.coords.latitude + ',' + position.coords.longitude
          }, {
            headers: { 'Authorization': 'Token ' + localStorage.getItem('token') }
          }).then(resolve, resolve);
        }, function () {
          console.warn('No se pudo obtener la ubicación del cuadre de reparto.');
          resolve();
        });
      });
    },
    limpiarcaja: function limpiarcaja() {
      this.b200 = null;
      this.b100 = null;
      this.b50 = null;
      this.b20 = null;
      this.b10 = null;
      this.b5 = null;
      this.b1 = null;
      this.m1 = null;
      this.m50 = null;
      this.m25 = null;
      this.m10 = null;
      this.m5 = null;
      this.gastos = null;
      this.gastos_factura = null;
      this.boleta = null;
      this.cheque = null;
    }
  },
  computed: {
    productos: function productos() {
      return this.$store.getters.listadodevoluciones.productos;
    },
    productos2: function productos2() {
      return this.$store.getters.productos;
    },
    productoactual: function productoactual() {
      return this.$store.getters.producto;
    },
    total: function total() {
      return (parseInt(this.b1 ? this.b1 : 0) + (this.b5 ? this.b5 : 0) * 5 + (this.b10 ? this.b10 : 0) * 10 + (this.b20 ? this.b20 : 0) * 20 + (this.b50 ? this.b50 : 0) * 50 + (this.b100 ? this.b100 : 0) * 100 + (this.b200 ? this.b200 : 0) * 200 + parseInt(this.m1 ? this.m1 : 0) + (this.m50 ? this.m50 : 0) * 0.50 + (this.m25 ? this.m25 : 0) * 0.25 + (this.m10 ? this.m10 : 0) * 0.10 + (this.m5 ? this.m5 : 0) * 0.05 + parseFloat(this.cheque ? this.cheque : 0) + parseFloat(this.boleta ? this.boleta : 0) + parseFloat(this.gastos ? this.gastos : 0) + parseFloat(this.gastos_factura ? this.gastos_factura : 0)).toFixed(2);
    },
    faltante: function faltante() {
      return (this.deuda - this.total).toFixed(2);
    },
    cuadrado: function cuadrado() {
      if (this.faltante <= 0 && this.total >= 0 && this.buscotabulacion) {
        return true;
      }
    }
  },
  watch: {
    productoactual: function productoactual(e) {
      this.nombreproducto = e.producto;
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__ = __webpack_require__(31);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menu: false,
      menu2: false,
      fechainicio: '',
      fechafin: '',
      datos: {}
    };
  },

  methods: {
    mostrar: function mostrar() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__plugins_urlsbackend__["C" /* reporte */], { params: {
          fechaminima: this.fechainicio,
          fechamaxima: this.fechafin
        },
        headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } }).then(function (response) {
        _this.datos = response.body.results;
      });
    }
  },
  computed: {
    resultado: function resultado() {
      return this.datos;
    },
    total: function total() {
      var tot = 0;
      for (var result in this.datos) {
        tot = tot + parseFloat(this.datos[result].total);
      }
      var total = tot.toLocaleString('es-GT');
      return total;
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('requesttipoextracciones');
  },
  data: function data() {
    return {
      'cantidad': 0,
      'tipoextraccion': ''
    };
  },

  computed: {
    tipoextracciones: function tipoextracciones() {
      return this.$store.getters.gettipoextracciones;
    }
  },
  methods: {
    guardarextraccion: function guardarextraccion() {
      this.$store.dispatch('guardarextraccion', { tipo: this.tipoextraccion,
        cantidad: this.cantidad });
    }
  }
});

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 128,
	"./af.js": 128,
	"./ar": 135,
	"./ar-dz": 129,
	"./ar-dz.js": 129,
	"./ar-kw": 130,
	"./ar-kw.js": 130,
	"./ar-ly": 131,
	"./ar-ly.js": 131,
	"./ar-ma": 132,
	"./ar-ma.js": 132,
	"./ar-sa": 133,
	"./ar-sa.js": 133,
	"./ar-tn": 134,
	"./ar-tn.js": 134,
	"./ar.js": 135,
	"./az": 136,
	"./az.js": 136,
	"./be": 137,
	"./be.js": 137,
	"./bg": 138,
	"./bg.js": 138,
	"./bm": 139,
	"./bm.js": 139,
	"./bn": 140,
	"./bn.js": 140,
	"./bo": 141,
	"./bo.js": 141,
	"./br": 142,
	"./br.js": 142,
	"./bs": 143,
	"./bs.js": 143,
	"./ca": 144,
	"./ca.js": 144,
	"./cs": 145,
	"./cs.js": 145,
	"./cv": 146,
	"./cv.js": 146,
	"./cy": 147,
	"./cy.js": 147,
	"./da": 148,
	"./da.js": 148,
	"./de": 151,
	"./de-at": 149,
	"./de-at.js": 149,
	"./de-ch": 150,
	"./de-ch.js": 150,
	"./de.js": 151,
	"./dv": 152,
	"./dv.js": 152,
	"./el": 153,
	"./el.js": 153,
	"./en-au": 154,
	"./en-au.js": 154,
	"./en-ca": 155,
	"./en-ca.js": 155,
	"./en-gb": 156,
	"./en-gb.js": 156,
	"./en-ie": 157,
	"./en-ie.js": 157,
	"./en-il": 158,
	"./en-il.js": 158,
	"./en-nz": 159,
	"./en-nz.js": 159,
	"./eo": 160,
	"./eo.js": 160,
	"./es": 163,
	"./es-do": 161,
	"./es-do.js": 161,
	"./es-us": 162,
	"./es-us.js": 162,
	"./es.js": 163,
	"./et": 164,
	"./et.js": 164,
	"./eu": 165,
	"./eu.js": 165,
	"./fa": 166,
	"./fa.js": 166,
	"./fi": 167,
	"./fi.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 171,
	"./fr-ca": 169,
	"./fr-ca.js": 169,
	"./fr-ch": 170,
	"./fr-ch.js": 170,
	"./fr.js": 171,
	"./fy": 172,
	"./fy.js": 172,
	"./gd": 173,
	"./gd.js": 173,
	"./gl": 174,
	"./gl.js": 174,
	"./gom-latn": 175,
	"./gom-latn.js": 175,
	"./gu": 176,
	"./gu.js": 176,
	"./he": 177,
	"./he.js": 177,
	"./hi": 178,
	"./hi.js": 178,
	"./hr": 179,
	"./hr.js": 179,
	"./hu": 180,
	"./hu.js": 180,
	"./hy-am": 181,
	"./hy-am.js": 181,
	"./id": 182,
	"./id.js": 182,
	"./is": 183,
	"./is.js": 183,
	"./it": 184,
	"./it.js": 184,
	"./ja": 185,
	"./ja.js": 185,
	"./jv": 186,
	"./jv.js": 186,
	"./ka": 187,
	"./ka.js": 187,
	"./kk": 188,
	"./kk.js": 188,
	"./km": 189,
	"./km.js": 189,
	"./kn": 190,
	"./kn.js": 190,
	"./ko": 191,
	"./ko.js": 191,
	"./ky": 192,
	"./ky.js": 192,
	"./lb": 193,
	"./lb.js": 193,
	"./lo": 194,
	"./lo.js": 194,
	"./lt": 195,
	"./lt.js": 195,
	"./lv": 196,
	"./lv.js": 196,
	"./me": 197,
	"./me.js": 197,
	"./mi": 198,
	"./mi.js": 198,
	"./mk": 199,
	"./mk.js": 199,
	"./ml": 200,
	"./ml.js": 200,
	"./mn": 201,
	"./mn.js": 201,
	"./mr": 202,
	"./mr.js": 202,
	"./ms": 204,
	"./ms-my": 203,
	"./ms-my.js": 203,
	"./ms.js": 204,
	"./mt": 205,
	"./mt.js": 205,
	"./my": 206,
	"./my.js": 206,
	"./nb": 207,
	"./nb.js": 207,
	"./ne": 208,
	"./ne.js": 208,
	"./nl": 210,
	"./nl-be": 209,
	"./nl-be.js": 209,
	"./nl.js": 210,
	"./nn": 211,
	"./nn.js": 211,
	"./pa-in": 212,
	"./pa-in.js": 212,
	"./pl": 213,
	"./pl.js": 213,
	"./pt": 215,
	"./pt-br": 214,
	"./pt-br.js": 214,
	"./pt.js": 215,
	"./ro": 216,
	"./ro.js": 216,
	"./ru": 217,
	"./ru.js": 217,
	"./sd": 218,
	"./sd.js": 218,
	"./se": 219,
	"./se.js": 219,
	"./si": 220,
	"./si.js": 220,
	"./sk": 221,
	"./sk.js": 221,
	"./sl": 222,
	"./sl.js": 222,
	"./sq": 223,
	"./sq.js": 223,
	"./sr": 225,
	"./sr-cyrl": 224,
	"./sr-cyrl.js": 224,
	"./sr.js": 225,
	"./ss": 226,
	"./ss.js": 226,
	"./sv": 227,
	"./sv.js": 227,
	"./sw": 228,
	"./sw.js": 228,
	"./ta": 229,
	"./ta.js": 229,
	"./te": 230,
	"./te.js": 230,
	"./tet": 231,
	"./tet.js": 231,
	"./tg": 232,
	"./tg.js": 232,
	"./th": 233,
	"./th.js": 233,
	"./tl-ph": 234,
	"./tl-ph.js": 234,
	"./tlh": 235,
	"./tlh.js": 235,
	"./tr": 236,
	"./tr.js": 236,
	"./tzl": 237,
	"./tzl.js": 237,
	"./tzm": 239,
	"./tzm-latn": 238,
	"./tzm-latn.js": 238,
	"./tzm.js": 239,
	"./ug-cn": 240,
	"./ug-cn.js": 240,
	"./uk": 241,
	"./uk.js": 241,
	"./ur": 242,
	"./ur.js": 242,
	"./uz": 244,
	"./uz-latn": 243,
	"./uz-latn.js": 243,
	"./uz.js": 244,
	"./vi": 245,
	"./vi.js": 245,
	"./x-pseudo": 246,
	"./x-pseudo.js": 246,
	"./yo": 247,
	"./yo.js": 247,
	"./zh-cn": 248,
	"./zh-cn.js": 248,
	"./zh-hk": 249,
	"./zh-hk.js": 249,
	"./zh-tw": 250,
	"./zh-tw.js": 250
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  "data-v-1b73ee58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  "data-v-550536ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  "data-v-6dc70d91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Cotización")])]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Nombre",
      "label": "Nombre"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.cliente),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "cliente", $$v)
      },
      expression: "cliente.cliente"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('v-layout', {
    staticClass: "justify-space-around"
  }, [_c('v-flex', [_c('h4', {
    staticClass: "white--text"
  }, [_vm._v("Compras")])]), _vm._v(" "), _c('v-flex', [(_vm.edit) ? _c('v-btn', {
    staticClass: "yellow",
    attrs: {
      "fab": "",
      "dark": ""
    },
    on: {
      "click": _vm.cambiaredit
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-layout', {
    staticClass: "justify-space-around",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "name": "fecha_factura",
      "label": "Fecha Factura",
      "prepend-icon": "date_range",
      "value": _vm.compra.fecha_facturacion,
      "disabled": _vm.edit
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es"
    },
    model: {
      value: (_vm.compra.fecha_facturacion),
      callback: function($$v) {
        _vm.$set(_vm.compra, "fecha_facturacion", $$v)
      },
      expression: "compra.fecha_facturacion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "name": "fecha_ingreso",
      "label": "Fecha Ingreso",
      "prepend-icon": "date_range",
      "value": _vm.compra.fecha_ingreso,
      "disabled": _vm.edit
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es"
    },
    model: {
      value: (_vm.compra.fecha_ingreso),
      callback: function($$v) {
        _vm.$set(_vm.compra, "fecha_ingreso", $$v)
      },
      expression: "compra.fecha_ingreso"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "mr-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "name": _vm.documento,
      "label": "No.Documento",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.compra.numerodocumento),
      callback: function($$v) {
        _vm.$set(_vm.compra, "numerodocumento", $$v)
      },
      expression: "compra.numerodocumento"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "required": "",
      "label": "Serie",
      "name": "serie",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.compra.serie),
      callback: function($$v) {
        _vm.$set(_vm.compra, "serie", $$v)
      },
      expression: "compra.serie"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.edit,
      "name": "proveedores",
      "items": _vm.proveedores,
      "item-text": "nombre",
      "item-value": "id",
      "label": "Proveedor",
      "autocomplete": ""
    },
    model: {
      value: (_vm.compra.proveedor),
      callback: function($$v) {
        _vm.$set(_vm.compra, "proveedor", $$v)
      },
      expression: "compra.proveedor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cantidad",
      "label": "Cantidad",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.compra.cantidad),
      callback: function($$v) {
        _vm.$set(_vm.compra, "cantidad", $$v)
      },
      expression: "compra.cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cantidad2",
      "label": "total calculado",
      "disabled": true
    },
    model: {
      value: (_vm.compra.totalc),
      callback: function($$v) {
        _vm.$set(_vm.compra, "totalc", $$v)
      },
      expression: "compra.totalc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "xs9": "",
      "sm3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Pagada"
    },
    on: {
      "change": function($event) {
        return _vm.cambio(_vm.compra.pagada)
      }
    },
    model: {
      value: (_vm.compra.pagada),
      callback: function($$v) {
        _vm.$set(_vm.compra, "pagada", $$v)
      },
      expression: "compra.pagada"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Crédito"
    },
    on: {
      "change": function($event) {
        return _vm.cambio2(_vm.compra.credito)
      }
    },
    model: {
      value: (_vm.compra.credito),
      callback: function($$v) {
        _vm.$set(_vm.compra, "credito", $$v)
      },
      expression: "compra.credito"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-space-between "
  }, [(!_vm.compra.id) ? _c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.crearCompra(_vm.compra)
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.compra.id) ? _c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "dark": "",
      "disabled": _vm.edit
    },
    on: {
      "click": function($event) {
        return _vm.actualizarcompra(_vm.compra)
      }
    }
  }, [_vm._v("Modificar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 red",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.regresar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.compra.id) ? _c('v-btn', {
    staticClass: "success",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.actualizardialog(true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_shopping_cart")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return undefined
      }
    }]),
    model: {
      value: (_vm.dialogo),
      callback: function($$v) {
        _vm.dialogo = $$v
      },
      expression: "dialogo"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "indigo"
  }, [_c('v-flex', [_c('h4', {
    staticClass: "white--text"
  }, [_vm._v("Linea Compra")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "justify-space-between wrap"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": !_vm.edit,
      "name": "Producto",
      "search-input": _vm.sproducto,
      "items": _vm.productos,
      "item-text": "producto",
      "item-value": "id",
      "label": "Producto:",
      "autocomplete": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.sproducto = $event
      },
      "update:search-input": function($event) {
        _vm.sproducto = $event
      },
      "input": function($event) {
        return _vm.cambiarprecio(_vm.lineacompra.producto)
      }
    },
    model: {
      value: (_vm.lineacompra.producto),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "producto", $$v)
      },
      expression: "lineacompra.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cantidad",
      "label": "Cantidad"
    },
    model: {
      value: (_vm.lineacompra.cantidad),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "cantidad", $$v)
      },
      expression: "lineacompra.cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Precio",
      "label": "Precio",
      "hidden": ""
    },
    model: {
      value: (_vm.lineacompra.precio),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "precio", $$v)
      },
      expression: "lineacompra.precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Precio",
      "label": "Precio Anterior",
      "disabled": true,
      "hidden": ""
    },
    model: {
      value: (_vm.lineacompra.precio_compra),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "precio_compra", $$v)
      },
      expression: "lineacompra.precio_compra"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": !_vm.edit,
      "name": "Presentacion",
      "items": _vm.presentaciones,
      "item-text": "presentacion",
      "item-value": "id",
      "label": "Presentación:",
      "autocomplete": ""
    },
    model: {
      value: (_vm.lineacompra.presentacion),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "presentacion", $$v)
      },
      expression: "lineacompra.presentacion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-action', [_c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.crearLineaCompra(_vm.lineacompra)
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 red",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.actualizardialog(false)
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.compra.detallescompratemporal,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-btn', {
          staticClass: "red--text text--darken-2",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.eliminar(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.producto_name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.cantidad))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.subtotal))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.presentacion_producto))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Total Ventas")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Desde",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.mostrar
    }
  }, [_vm._v("\n                  Mostrar"), _c('v-icon', [_vm._v("find_in_page")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('b', [_vm._v("Lista")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Total:")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado), function(dato) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(dato.nombrelista))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(parseFloat(dato.total).toLocaleString('es-GT')))])])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [(!_vm.hascotizacion) ? _c('cliente-cotizacion') : (_vm.hascotizacion) ? _c('v-card', {
    staticClass: "factura",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('div', {
    staticClass: "encabezado",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "cliente"
    }
  }, [_vm._v(" Cliente: " + _vm._s(_vm.cliente.cliente))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__date"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Fecha: " + _vm._s(_vm.fecha))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 total",
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', {
    staticClass: "white--text"
  }, [_vm._v("Total: Q." + _vm._s(_vm.total))])]), _vm._v(" "), _c('h4', {
    staticClass: "warning--text existencia"
  }, [_vm._v(" Existencia: " + _vm._s(_vm.producto.existencia))]), _vm._v(" "), _c('v-flex', [(_vm.haslineas) ? _c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1) : _vm._e(), _vm._v(" "), (_vm.haslineas) ? _c('v-btn', {
    staticClass: "print yellow darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarcotizacion
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": "",
      "disabled": _vm.validatefactura
    },
    on: {
      "click": function($event) {
        return _vm.focusbusqueda()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "accent": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("email")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "buscador ma-0 pa-0",
    attrs: {
      "fluid": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    ref: "search",
    attrs: {
      "id": "search",
      "singleLine": "",
      "label": "cod.Producto",
      "disabled": _vm.validatefactura,
      "autofocus": "true"
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchproducto($event)
      }]
    },
    model: {
      value: (_vm.producto.barra),
      callback: function($$v) {
        _vm.$set(_vm.producto, "barra", $$v)
      },
      expression: "producto.barra"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "precio",
      "autofocus": "",
      "disabled": ""
    },
    model: {
      value: (_vm.precio),
      callback: function($$v) {
        _vm.precio = $$v
      },
      expression: "precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "producto",
      "disabled": ""
    },
    model: {
      value: (_vm.producto.producto),
      callback: function($$v) {
        _vm.$set(_vm.producto, "producto", $$v)
      },
      expression: "producto.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    ref: "cantidad",
    attrs: {
      "type": "number",
      "singleLine": "",
      "label": "cantidad"
    },
    on: {
      "change": function($event) {
        return _vm.checklista()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardarventa($event)
      }
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presentacion),
      expression: "presentacion"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.presentacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.presentaciones), function(press) {
    return _c('option', {
      domProps: {
        "value": press
      }
    }, [_vm._v("\n                " + _vm._s(press.presentacion) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select xs6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listado),
      expression: "listado"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.producto.listaprecios), function(lista) {
    return _c('option', {
      domProps: {
        "value": lista
      }
    }, [_vm._v("\n                " + _vm._s(lista.lista.nombre) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "justify-center",
    attrs: {
      "hidden-md-and-up": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarventa
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hascotizacion),
      expression: "hascotizacion"
    }],
    staticClass: "factura__detalle"
  }, [_c('v-flex', {
    staticClass: "tabla",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table text-md-center"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.headers), function(header) {
    return _c('th', [_vm._v(" " + _vm._s(header.text))])
  })], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.lineas), function(linea) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(linea)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.cantidad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.presentacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.producto_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.precio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(linea.precio * linea.cantidad, 'Q')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "factura__detalle__total"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], 2)])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Imprimir Cotización")])]), _vm._v(" "), _c('v-card-text', [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_error) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimircotizacion($event)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "enletras",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("TOTAL EN LETRAS: " + _vm._s(_vm.numerosaletras))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Facturar")])]), _vm._v(" "), _c('v-card-text', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "name": "Nit",
      "label": "Nit",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.nit),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nit", $$v)
      },
      expression: "cliente.nit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Nombre",
      "label": "Nombre"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.nombre),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nombre", $$v)
      },
      expression: "cliente.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Direccion",
      "label": "Dirección"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.direccion),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "direccion", $$v)
      },
      expression: "cliente.direccion"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Referencia",
      "label": "Referencia"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.referencia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "referencia", $$v)
      },
      expression: "cliente.referencia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Departamento",
      "label": "Departamento"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.departamento),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "departamento", $$v)
      },
      expression: "cliente.departamento"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Municipio",
      "label": "Municipio"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.municipio),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "municipio", $$v)
      },
      expression: "cliente.municipio"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "left",
      "label": "Es Ruta"
    },
    model: {
      value: (_vm.esruta),
      callback: function($$v) {
        _vm.esruta = $$v
      },
      expression: "esruta"
    }
  })], 1), _vm._v(" "), (_vm.esruta) ? _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.dias,
      "label": "Día",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.dia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "dia", $$v)
      },
      expression: "cliente.dia"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.semanas,
      "label": "Semana",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.semana),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "semana", $$v)
      },
      expression: "cliente.semana"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Orden",
      "label": "Orden"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.orden),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "orden", $$v)
      },
      expression: "cliente.orden"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-btn', {
    attrs: {
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.actualizarcliente()
      }
    }
  }, [_vm._v("Actualizar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "accent": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.regresar()
      }
    }
  }, [_vm._v("Regresar")])], 1), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "80vh"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 18,
      "map-type-id": "hybrid"
    },
    on: {
      "click": function($event) {
        return _vm.marcar($event)
      }
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true,
        "label": _vm.cliente.nombre
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [(_vm.hasfactura) ? _c('div') : (!_vm.hasfactura) ? _c('v-card', {
    staticClass: "factura",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('h4', {
    staticClass: "warning--text existencia"
  }, [_vm._v(" Existencia: " + _vm._s(_vm.producto.existencia))]), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": "",
      "disabled": _vm.validatefactura
    },
    on: {
      "click": function($event) {
        return _vm.focusbusqueda()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("search")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "buscador ma-0 pa-0",
    attrs: {
      "fluid": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "precio",
      "disabled": ""
    },
    model: {
      value: (_vm.precio),
      callback: function($$v) {
        _vm.precio = $$v
      },
      expression: "precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "producto",
      "disabled": ""
    },
    model: {
      value: (_vm.producto.producto),
      callback: function($$v) {
        _vm.$set(_vm.producto, "producto", $$v)
      },
      expression: "producto.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    ref: "cantidad",
    attrs: {
      "type": "number",
      "singleLine": "",
      "label": "cantidad",
      "min": "1"
    },
    on: {
      "change": function($event) {
        return _vm.checklista()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardarventa($event)
      }
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presentacion),
      expression: "presentacion"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.presentacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.presentaciones), function(press) {
    return _c('option', {
      domProps: {
        "value": press
      }
    }, [_vm._v("\n                " + _vm._s(press.presentacion) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select xs6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listado),
      expression: "listado"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.producto.listaprecios), function(lista) {
    return _c('option', {
      domProps: {
        "value": lista
      }
    }, [_vm._v("\n                " + _vm._s(lista.lista.nombre) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "justify-center",
    attrs: {
      "hidden-md-and-up": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarventa
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Datos Factura")])]), _vm._v(" "), _c('v-card-text', [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_error) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Efectivo",
      "autofocus": "true"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardardatosfactura($event)
      }
    },
    model: {
      value: (_vm.efectivo),
      callback: function($$v) {
        _vm.efectivo = $$v
      },
      expression: "efectivo"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "primary--text"
  }, [_vm._v("Cambio: Q." + _vm._s(_vm.cambio))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardardatosfactura($event)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Escribir Observación")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cambiarcomentario($event)
      }
    },
    model: {
      value: (_vm.factura.observaciones),
      callback: function($$v) {
        _vm.$set(_vm.factura, "observaciones", $$v)
      },
      expression: "factura.observaciones"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.cambiarcomentario
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.messagemotivo),
      callback: function($$v) {
        _vm.messagemotivo = $$v
      },
      expression: "messagemotivo"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo por el que no compro")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('label', {
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.factura.observacionesmotivo),
      expression: "factura.observacionesmotivo"
    }],
    attrs: {
      "id": "motivo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.factura, "observacionesmotivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.cambiarcomentariomotivo]
    }
  }, _vm._l((_vm.motivos), function(motivo) {
    return _c('option', {
      domProps: {
        "value": motivo
      }
    }, [_vm._v("\n                " + _vm._s(motivo) + "\n              ")])
  }), 0)])])], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.cambiarcomentariomotivo
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Vendedor: " + _vm._s(_vm.factura.usuario.username))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary justify-center"
  }, [_c('v-container', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fluid": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "center": "",
      "right": ""
    },
    on: {
      "click": _vm.redireccion
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "white--text text-xs-center"
  }, [_vm._v("Facturas")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Desde",
      "prepend-icon": "event",
      "data-vv-delay": "100",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechafin()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rutas,
      "itemText": "nombre",
      "label": "Rutas",
      "single-line": "",
      "bottom": "",
      "dark": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarruta($event)
      }
    },
    model: {
      value: (_vm.ruta),
      callback: function($$v) {
        _vm.ruta = $$v
      },
      expression: "ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.usuarios,
      "itemText": "username",
      "label": "Usuarios",
      "single-line": "",
      "bottom": "",
      "dark": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarusuario($event)
      }
    },
    model: {
      value: (_vm.usuario),
      callback: function($$v) {
        _vm.usuario = $$v
      },
      expression: "usuario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "buscar",
      "label": "Buscar"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarfactura($event)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Dirección")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.facturas.results), function(factura) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(factura)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarfactura(factura)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center",
      class: factura.serie_fel ? 'blue--text' : 'black--text'
    }, [_vm._v(_vm._s(factura.cliente_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center",
      class: factura.serie_fel ? 'blue--text' : 'black--text'
    }, [_vm._v(_vm._s(_vm._f("formatDate")(factura.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center",
      class: factura.serie_fel ? 'blue--text' : 'black--text'
    }, [_vm._v("Q. " + _vm._s(factura.total.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center",
      class: factura.serie_fel ? 'blue--text' : 'black--text'
    }, [_vm._v(_vm._s(factura.direccion_completa))])])
  }), 0)])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.facturas.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.facturas.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.facturas.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.facturas.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [( false) ? _c('cliente-factura') : (_vm.hasfactura) ? _c('v-card', {
    staticClass: "factura"
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('div', {
    staticClass: "encabezado",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "cliente"
    }
  }, [_vm._v(" Cliente Anular: " + _vm._s(_vm.cliente.nombre))])], 1), _vm._v(" "), (_vm.cliente.nit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "nit"
    }
  }, [_vm._v("Nit: " + _vm._s(_vm.cliente.nit))])], 1) : _vm._e(), _vm._v(" "), (!_vm.cliente.nit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "nit"
    }
  }, [_vm._v("Nit: " + _vm._s(_vm.cliente.codigo))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__direccion",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Direccion: " + _vm._s(_vm.cliente.direccion))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__date"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Fecha: " + _vm._s(_vm.fecha))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Hora: " + _vm._s(_vm.hora))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.factura.credito) ? _c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("CREDITO")]) : _vm._e(), _vm._v(" "), (!_vm.factura.credito) ? _c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("CONTADO")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 credito",
    attrs: {
      "sm5": "",
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Anular Factura",
      "dark": "",
      "disabled": _vm.factura.rechazado
    },
    on: {
      "change": _vm.anularfactura
    },
    model: {
      value: (_vm.factura.anulado),
      callback: function($$v) {
        _vm.$set(_vm.factura, "anulado", $$v)
      },
      expression: "factura.anulado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 total",
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', {
    staticClass: "white--text"
  }, [_vm._v("Total: Q." + _vm._s(_vm.total))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasfactura),
      expression: "hasfactura"
    }],
    staticClass: "factura__detalle"
  }, [_c('v-flex', {
    staticClass: "tabla",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table text-md-center"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.headers), function(header) {
    return _c('th', [_vm._v(" " + _vm._s(header.text))])
  })], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.lineas), function(linea) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": "",
        "disabled": _vm.grabando,
        "loading": _vm.grabando
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(linea)
        }
      }
    }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.cantidad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.presentacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.producto_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.precio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(linea.precio * linea.cantidad, 'Q')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "factura__detalle__total"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], 2)])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo de Anulación")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.actualizarnota($event)
      }
    },
    model: {
      value: (_vm.motivonota),
      callback: function($$v) {
        _vm.motivonota = $$v
      },
      expression: "motivonota"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.actualizarnota($event)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo de Anulación")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.anularfactura($event)
      }
    },
    model: {
      value: (_vm.factura.motivo_anulacion),
      callback: function($$v) {
        _vm.$set(_vm.factura, "motivo_anulacion", $$v)
      },
      expression: "factura.motivo_anulacion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false, _vm.factura.anulado = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.anularfactura
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.messagemotivo),
      callback: function($$v) {
        _vm.messagemotivo = $$v
      },
      expression: "messagemotivo"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo por el que no compro")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('label', {
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.factura.observacionesmotivo),
      expression: "factura.observacionesmotivo"
    }],
    attrs: {
      "id": "motivo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.factura, "observacionesmotivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.cambiarcomentariomotivo]
    }
  }, _vm._l((_vm.motivos), function(motivo) {
    return _c('option', {
      domProps: {
        "value": motivo
      }
    }, [_vm._v("\n                " + _vm._s(motivo) + "\n              ")])
  }), 0)])])], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.anularfactura
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "enletras",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("TOTAL EN LETRAS: " + _vm._s(_vm.numerosaletras))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Vendedor: " + _vm._s(_vm.factura.usuario.username))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary justify-center"
  }, [_c('v-container', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fluid": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "center": "",
      "right": ""
    },
    on: {
      "click": _vm.redireccion
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "white--text text-xs-center"
  }, [_vm._v("Compras")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Desde",
      "prepend-icon": "event",
      "data-vv-delay": "100",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechafin()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Proveedor")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Total")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getcompras.results), function(compra) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(compra)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarcompra(compra)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(compra.proveedor_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(compra.fecha_facturacion)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("Q. " + _vm._s(compra.cantidad))])])
  }), 0)])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.getcompras.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.getcompras.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.getcompras.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.getcompras.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "offset-md2": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-list-item-title', {
    staticClass: "headline mb-1"
  }, [_vm._v("Cuadre de Caja")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Total del Cheque"
    },
    model: {
      value: (_vm.vcheque),
      callback: function($$v) {
        _vm.vcheque = $$v
      },
      expression: "vcheque"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-100": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 200"
    },
    model: {
      value: (_vm.v200),
      callback: function($$v) {
        _vm.v200 = $$v
      },
      expression: "v200"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-100": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 100"
    },
    model: {
      value: (_vm.v100),
      callback: function($$v) {
        _vm.v100 = $$v
      },
      expression: "v100"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 50"
    },
    model: {
      value: (_vm.v50),
      callback: function($$v) {
        _vm.v50 = $$v
      },
      expression: "v50"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 20"
    },
    model: {
      value: (_vm.v20),
      callback: function($$v) {
        _vm.v20 = $$v
      },
      expression: "v20"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 10"
    },
    model: {
      value: (_vm.v10),
      callback: function($$v) {
        _vm.v10 = $$v
      },
      expression: "v10"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 5"
    },
    model: {
      value: (_vm.v5),
      callback: function($$v) {
        _vm.v5 = $$v
      },
      expression: "v5"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Billetes de 1"
    },
    model: {
      value: (_vm.v1),
      callback: function($$v) {
        _vm.v1 = $$v
      },
      expression: "v1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 1"
    },
    model: {
      value: (_vm.m1),
      callback: function($$v) {
        _vm.m1 = $$v
      },
      expression: "m1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.50"
    },
    model: {
      value: (_vm.v050),
      callback: function($$v) {
        _vm.v050 = $$v
      },
      expression: "v050"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.25"
    },
    model: {
      value: (_vm.v025),
      callback: function($$v) {
        _vm.v025 = $$v
      },
      expression: "v025"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.10"
    },
    model: {
      value: (_vm.v010),
      callback: function($$v) {
        _vm.v010 = $$v
      },
      expression: "v010"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Monedas de 0.05"
    },
    model: {
      value: (_vm.v005),
      callback: function($$v) {
        _vm.v005 = $$v
      },
      expression: "v005"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Recibo"
    },
    model: {
      value: (_vm.recibo),
      callback: function($$v) {
        _vm.recibo = $$v
      },
      expression: "recibo"
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "No. Boleta 1"
    },
    model: {
      value: (_vm.boleta_n1),
      callback: function($$v) {
        _vm.boleta_n1 = $$v
      },
      expression: "boleta_n1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Boleta 1"
    },
    model: {
      value: (_vm.boleta1),
      callback: function($$v) {
        _vm.boleta1 = $$v
      },
      expression: "boleta1"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.bancos,
      "itemText": "nombre",
      "label": "banco",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.banco),
      callback: function($$v) {
        _vm.banco = $$v
      },
      expression: "banco"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "No. Boleta 2"
    },
    model: {
      value: (_vm.boleta_n2),
      callback: function($$v) {
        _vm.boleta_n2 = $$v
      },
      expression: "boleta_n2"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Boleta 2"
    },
    model: {
      value: (_vm.boleta2),
      callback: function($$v) {
        _vm.boleta2 = $$v
      },
      expression: "boleta2"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.bancos,
      "itemText": "nombre",
      "label": "banco2",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.banco2),
      callback: function($$v) {
        _vm.banco2 = $$v
      },
      expression: "banco2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "No. Boleta 3"
    },
    model: {
      value: (_vm.boleta_n3),
      callback: function($$v) {
        _vm.boleta_n3 = $$v
      },
      expression: "boleta_n3"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Boleta 3"
    },
    model: {
      value: (_vm.boleta3),
      callback: function($$v) {
        _vm.boleta3 = $$v
      },
      expression: "boleta3"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.bancos,
      "itemText": "nombre",
      "label": "banco3",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.banco3),
      callback: function($$v) {
        _vm.banco3 = $$v
      },
      expression: "banco3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Suma Total",
      "disabled": ""
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Total a Entregar",
      "disabled": ""
    },
    model: {
      value: (_vm.caja.total),
      callback: function($$v) {
        _vm.$set(_vm.caja, "total", $$v)
      },
      expression: "caja.total"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Diferencia",
      "disabled": ""
    },
    model: {
      value: (_vm.diferencia),
      callback: function($$v) {
        _vm.diferencia = $$v
      },
      expression: "diferencia"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "blue--text text--darken-2",
    attrs: {
      "disabled": _vm.cuadrado
    },
    on: {
      "click": _vm.editarcaja
    }
  }, [_vm._v("\n                  Guardar\n      ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex')], 1)
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-card', {
    staticClass: "max-auto",
    attrs: {
      "min": ""
    }
  }, [_c('v-card-title', [_c('h4', [_vm._v("Agregar Extracción")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tipoextracciones,
      "item-text": "tipo",
      "item-value": "id",
      "label": "Tipo Extraccion"
    },
    model: {
      value: (_vm.tipoextraccion),
      callback: function($$v) {
        _vm.tipoextraccion = $$v
      },
      expression: "tipoextraccion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "ml-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cantidad"
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.guardarextraccion
    }
  }, [_vm._v("\n            Guardar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "offset-md2": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-list-item-title', {
    staticClass: "headline mb-1"
  }, [_vm._v(" Extracción de Dinero")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text text--darken-2 accent",
    attrs: {
      "icon": "",
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "center": "",
      "right": ""
    },
    on: {
      "click": _vm.redireccion
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.extracciones), function(extraccion) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminarextraccion(extraccion)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarfactura(extraccion)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(extraccion.tipo_nombre))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(extraccion.cantidad))])])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex')], 1)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Anular Facturas")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.buscar
    }
  }, [_vm._v("\n             Buscar")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(!_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n             Scanear")]) : _vm._e(), _vm._v(" "), (_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n             Cerrar")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.activo) ? _c('StreamBarcodeReader', {
    attrs: {
      "name": "codigo"
    },
    on: {
      "decode": _vm.onDecode,
      "loaded": _vm.onLoaded
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Total")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.facturas.results), function(factura) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarfactura(factura)
        }
      }
    }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(factura.cliente_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(factura.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("Q. " + _vm._s(factura.total.toFixed(2)))])])
  }), 0)])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.facturas.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.facturas.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.facturas.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.facturas.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scanner-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('video', {
    ref: "scanner",
    attrs: {
      "poster": "data:image/gif,AAAA"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-element"
  }), _vm._v(" "), _c('div', {
    staticClass: "laser"
  })])])
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Reporte devolución")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  }), _vm._v(" "), (_vm.multitabulacion) ? _c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion2),
      callback: function($$v) {
        _vm.codigotabulacion2 = $$v
      },
      expression: "codigotabulacion2"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "multiple",
      "dark": ""
    },
    model: {
      value: (_vm.multitabulacion),
      callback: function($$v) {
        _vm.multitabulacion = $$v
      },
      expression: "multitabulacion"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.buscar
    }
  }, [_vm._v("\n             Buscar")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n             Cerrar")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [(_vm.codigotabulacion) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialognuevo = true
      }
    }
  }, [_vm._v("\n             Nuevo")]) : _vm._e()], 1), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.productos), function(producto) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "green--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editardevolucion(producto)
        }
      }
    }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          producto.activo = !producto.activo
        }
      }
    }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(producto.producto))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(producto.total))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('v-flex', [(producto.activo) ? _c('v-text-field', {
      attrs: {
        "label": "ingreso",
        "type": "number"
      },
      model: {
        value: (producto.ingreso),
        callback: function($$v) {
          _vm.$set(producto, "ingreso", $$v)
        },
        expression: "producto.ingreso"
      }
    }) : _vm._e()], 1)], 1)])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-action', [_c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(_vm.productos) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_vm._v("\n             Completar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.getters.gettipo !== 'bodeguero'),
      expression: "this.$store.getters.gettipo !== 'bodeguero'"
    }],
    staticClass: "print green darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogcuadrar = true
      }
    }
  }, [_vm._v("\n             Cuadrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "print yellow darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogrevision = true, _vm.native = true
      }
    }
  }, [_vm._v("\n             Revision")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Ingrese código del cliente")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Codigo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.codigo),
      callback: function($$v) {
        _vm.codigo = $$v
      },
      expression: "codigo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardardevolucion(_vm.codigo)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogcuadrar),
      callback: function($$v) {
        _vm.dialogcuadrar = $$v
      },
      expression: "dialogcuadrar"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "totales"
  }, [_c('p', [_vm._v("Total A Entregar: " + _vm._s(_vm.deuda))]), _vm._v(" "), _c('p', [_vm._v("Entregado: " + _vm._s(_vm.total))]), _vm._v(" "), _c('p', [_vm._v("Falta: " + _vm._s(_vm.faltante))])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "tabulacion",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cuadrar($event)
      }
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  }), _vm._v(" "), (_vm.multitabulacion) ? _c('v-text-field', {
    attrs: {
      "label": "tabulacion2"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cuadrar($event)
      }
    },
    model: {
      value: (_vm.codigotabulacion2),
      callback: function($$v) {
        _vm.codigotabulacion2 = $$v
      },
      expression: "codigotabulacion2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cuadrar($event)
      }
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "multiple"
    },
    model: {
      value: (_vm.multitabulacion),
      callback: function($$v) {
        _vm.multitabulacion = $$v
      },
      expression: "multitabulacion"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_tabulacion"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.tbilletes
    },
    on: {
      "click": _vm.activarbilletes
    }
  }, [_c('span', [_vm._v("Billetes")])])]), _vm._v(" "), _c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.tmonedas
    },
    on: {
      "click": _vm.activarmonedas
    }
  }, [_c('span', [_vm._v("Monedas")])]), _vm._v(" "), _c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.totros
    },
    on: {
      "click": _vm.activarotros
    }
  }, [_c('span', [_vm._v("Otros")])]), _vm._v(" "), _c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.tgastos
    },
    on: {
      "click": _vm.activargastos
    }
  }, [_c('span', [_vm._v("Gastos")])])], 1), _vm._v(" "), (_vm.tbilletes) ? _c('div', {
    staticClass: "detallebilletes",
    class: {
      active: _vm.tbilletes
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Q. 200",
      "type": "number"
    },
    model: {
      value: (_vm.b200),
      callback: function($$v) {
        _vm.b200 = $$v
      },
      expression: "b200"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 100",
      "type": "number"
    },
    model: {
      value: (_vm.b100),
      callback: function($$v) {
        _vm.b100 = $$v
      },
      expression: "b100"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 50",
      "type": "number"
    },
    model: {
      value: (_vm.b50),
      callback: function($$v) {
        _vm.b50 = $$v
      },
      expression: "b50"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 20",
      "type": "number"
    },
    model: {
      value: (_vm.b20),
      callback: function($$v) {
        _vm.b20 = $$v
      },
      expression: "b20"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 10",
      "type": "number"
    },
    model: {
      value: (_vm.b10),
      callback: function($$v) {
        _vm.b10 = $$v
      },
      expression: "b10"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 5",
      "type": "number"
    },
    model: {
      value: (_vm.b5),
      callback: function($$v) {
        _vm.b5 = $$v
      },
      expression: "b5"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 1",
      "type": "number"
    },
    model: {
      value: (_vm.b1),
      callback: function($$v) {
        _vm.b1 = $$v
      },
      expression: "b1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tmonedas) ? _c('div', {
    staticClass: "detallemonedas",
    class: {
      active: _vm.tmonedas
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Q.1.00",
      "type": "number"
    },
    model: {
      value: (_vm.m1),
      callback: function($$v) {
        _vm.m1 = $$v
      },
      expression: "m1"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.50",
      "type": "number"
    },
    model: {
      value: (_vm.m50),
      callback: function($$v) {
        _vm.m50 = $$v
      },
      expression: "m50"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.25",
      "type": "number"
    },
    model: {
      value: (_vm.m25),
      callback: function($$v) {
        _vm.m25 = $$v
      },
      expression: "m25"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.10",
      "type": "number"
    },
    model: {
      value: (_vm.m10),
      callback: function($$v) {
        _vm.m10 = $$v
      },
      expression: "m10"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.5",
      "type": "number"
    },
    model: {
      value: (_vm.m5),
      callback: function($$v) {
        _vm.m5 = $$v
      },
      expression: "m5"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.totros) ? _c('div', {
    staticClass: "detalleotros",
    class: {
      active: _vm.totros
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cheque",
      "type": "number"
    },
    model: {
      value: (_vm.cheque),
      callback: function($$v) {
        _vm.cheque = $$v
      },
      expression: "cheque"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Depositos",
      "type": "number"
    },
    model: {
      value: (_vm.boleta),
      callback: function($$v) {
        _vm.boleta = $$v
      },
      expression: "boleta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "No boleta",
      "type": "number"
    },
    model: {
      value: (_vm.no_boleta),
      callback: function($$v) {
        _vm.no_boleta = $$v
      },
      expression: "no_boleta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "No boleta 2",
      "type": "number"
    },
    model: {
      value: (_vm.no_boleta2),
      callback: function($$v) {
        _vm.no_boleta2 = $$v
      },
      expression: "no_boleta2"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "No boleta 3",
      "type": "number"
    },
    model: {
      value: (_vm.no_boleta3),
      callback: function($$v) {
        _vm.no_boleta3 = $$v
      },
      expression: "no_boleta3"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "observaciones"
    },
    model: {
      value: (_vm.observaciones),
      callback: function($$v) {
        _vm.observaciones = $$v
      },
      expression: "observaciones"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Calificación Compañeros"
    },
    model: {
      value: (_vm.calificacion),
      callback: function($$v) {
        _vm.calificacion = $$v
      },
      expression: "calificacion"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tgastos) ? _c('div', {
    staticClass: "detallegastos",
    class: {
      active: _vm.tgastos
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "recibos",
      "type": "number"
    },
    model: {
      value: (_vm.gastos),
      callback: function($$v) {
        _vm.gastos = $$v
      },
      expression: "gastos"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "gastos con factura",
      "type": "number"
    },
    model: {
      value: (_vm.gastos_factura),
      callback: function($$v) {
        _vm.gastos_factura = $$v
      },
      expression: "gastos_factura"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogcuadrar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.cuadrado && !_vm.caja.id && _vm.buscotabulacion) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogcuadrar = false, _vm.dialogrevision = true
      }
    }
  }, [_vm._v("Aceptar")]) : _vm._e(), _vm._v(" "), (_vm.cuadrado && _vm.caja.id && _vm.buscotabulacion) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.modificarcuadrado(_vm.codigo)
      }
    }
  }, [_vm._v("Modificar")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialognuevo),
      callback: function($$v) {
        _vm.dialognuevo = $$v
      },
      expression: "dialognuevo"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos2), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n              " + _vm._s(product.producto) + "\n           ")])
  }), 0), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Cantidad:",
      "type": "number"
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialognuevo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardaritemdevolucion($event)
      }
    }
  }, [_vm._v("guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogrevision),
      callback: function($$v) {
        _vm.dialogrevision = $$v
      },
      expression: "dialogrevision"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "red",
    attrs: {
      "pt0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Revisión")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  }), _vm._v(" "), (_vm.multitabulacion) ? _c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion2),
      callback: function($$v) {
        _vm.codigotabulacion2 = $$v
      },
      expression: "codigotabulacion2"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.cuadrar
    }
  }, [_vm._v("\n                 Buscar")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n                 Cerrar")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "tres candados"
    },
    model: {
      value: (_vm.revision.tres_candados),
      callback: function($$v) {
        _vm.$set(_vm.revision, "tres_candados", $$v)
      },
      expression: "revision.tres_candados"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "llantas c/aire"
    },
    model: {
      value: (_vm.revision.llantas_con_aire),
      callback: function($$v) {
        _vm.$set(_vm.revision, "llantas_con_aire", $$v)
      },
      expression: "revision.llantas_con_aire"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "limpieza cabina"
    },
    model: {
      value: (_vm.revision.limpiez_cabina),
      callback: function($$v) {
        _vm.$set(_vm.revision, "limpiez_cabina", $$v)
      },
      expression: "revision.limpiez_cabina"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "limpieza frurgon"
    },
    model: {
      value: (_vm.revision.limpieza_frurgon),
      callback: function($$v) {
        _vm.$set(_vm.revision, "limpieza_frurgon", $$v)
      },
      expression: "revision.limpieza_frurgon"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "troquet"
    },
    model: {
      value: (_vm.revision.troquet),
      callback: function($$v) {
        _vm.$set(_vm.revision, "troquet", $$v)
      },
      expression: "revision.troquet"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "en buen estado"
    },
    model: {
      value: (_vm.revision.en_buen_estado),
      callback: function($$v) {
        _vm.$set(_vm.revision, "en_buen_estado", $$v)
      },
      expression: "revision.en_buen_estado"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "lavado"
    },
    model: {
      value: (_vm.revision.lavado),
      callback: function($$v) {
        _vm.$set(_vm.revision, "lavado", $$v)
      },
      expression: "revision.lavado"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "observaciones"
    },
    model: {
      value: (_vm.revision.comentario),
      callback: function($$v) {
        _vm.$set(_vm.revision, "comentario", $$v)
      },
      expression: "revision.comentario"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogrevision = false, _vm.dialogcuadrar = !_vm.native, _vm.native = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.cuadrado && !_vm.caja.id && _vm.buscotabulacion) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        !_vm.native ? _vm.guardarcuadrado(_vm.codigo) : _vm.updateTabulacion()
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.caja.id) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateTabulacion()
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [(!_vm.hasfactura) ? _c('cliente-factura') : (_vm.hasfactura) ? _c('v-card', {
    staticClass: "factura",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('div', {
    staticClass: "encabezado",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "cliente"
    }
  }, [_vm._v(" Cliente: " + _vm._s(_vm.cliente.nombre))])], 1), _vm._v(" "), (_vm.cliente.nit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "nit"
    }
  }, [_vm._v("Nit: " + _vm._s(_vm.cliente.nit))])], 1) : _vm._e(), _vm._v(" "), (!_vm.cliente.nit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "nit"
    }
  }, [_vm._v("Nit: " + _vm._s(_vm.cliente.codigo))])], 1) : _vm._e(), _vm._v(" "), (_vm.cliente.telefono && _vm.cliente.telefono.trim()) ? _c('v-flex', {
    staticClass: "ml-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "telefono"
    }
  }, [_vm._v("Teléfono: " + _vm._s(_vm.cliente.telefono))])], 1) : _vm._e(), _vm._v(" "), (!_vm.cliente.telefono || !_vm.cliente.telefono.trim()) ? _c('v-flex', {
    staticClass: "ml-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "telefono"
    }
  }, [_vm._v("Teléfono: No tiene")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "editar-cliente",
    attrs: {
      "icon": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogEditarCliente = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__direccion",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Direccion: " + _vm._s(_vm.cliente.direccion_completa))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__date"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Fecha: " + _vm._s(_vm.fecha))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Hora: " + _vm._s(_vm.hora))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.factura.credito) ? _c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("CREDITO")]) : _vm._e(), _vm._v(" "), (!_vm.factura.credito) ? _c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("CONTADO")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 credito",
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Al credito",
      "dark": ""
    },
    on: {
      "change": _vm.cambiarcredito
    },
    model: {
      value: (_vm.factura.credito),
      callback: function($$v) {
        _vm.$set(_vm.factura, "credito", $$v)
      },
      expression: "factura.credito"
    }
  })], 1), _vm._v(" "), (_vm.vender_bodega == true || _vm.tipo === 'admin') ? _c('v-flex', {
    staticClass: "pa-0 mr-2 credito",
    attrs: {
      "xs6": "",
      "md5": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Sacar de Bodega",
      "dark": ""
    },
    on: {
      "change": _vm.actualizarbodega
    },
    model: {
      value: (_vm.factura.bodega),
      callback: function($$v) {
        _vm.$set(_vm.factura, "bodega", $$v)
      },
      expression: "factura.bodega"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 credito",
    attrs: {
      "sm3": "",
      "xs6": ""
    }
  }, [(_vm.tipo === 'admin') ? _c('v-checkbox', {
    attrs: {
      "label": "Es envío",
      "dark": ""
    },
    on: {
      "change": _vm.cambiarenvio
    },
    model: {
      value: (_vm.factura.envio),
      callback: function($$v) {
        _vm.$set(_vm.factura, "envio", $$v)
      },
      expression: "factura.envio"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 total",
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', {
    staticClass: "white--text"
  }, [_vm._v("Total: Q." + _vm._s(_vm.total))])]), _vm._v(" "), _c('div', {
    staticClass: "existencia"
  }, [_c('h4', {
    staticClass: "warning--text"
  }, [_vm._v("Existencia: " + _vm._s(_vm.producto.existencia))]), _vm._v(" "), _c('h5', {
    staticClass: "warning--text existencia__vencimiento"
  }, [_vm._v("\n            Vence: " + _vm._s(_vm._f("formatFechaVencimiento")(_vm.producto.fecha_vencimiento)) + "\n          ")])]), _vm._v(" "), _c('v-flex', [(_vm.haslineas && this.$store.getters.gettipo === 'admin' || this.$store.getters.gettipo === 'secretaria' || _vm.usuario === '1' || _vm.usuario === 'L2') ? _c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1) : _vm._e(), _vm._v(" "), (_vm.haslineas) ? _c('v-btn', {
    staticClass: "print yellow darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarfactura
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "primary",
      "disabled": _vm.validatefactura
    },
    on: {
      "click": function($event) {
        return _vm.focusbusqueda()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "accent": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("email")])], 1), _vm._v(" "), (!_vm.haslineas) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "color": "primary",
      "small": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("live_help")])], 1) : _vm._e(), _vm._v(" "), (_vm.validatefactura) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "error": ""
    },
    on: {
      "click": _vm.nuevafactura
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-alert', {
    attrs: {
      "success": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_success) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "buscador ma-0 pa-0",
    attrs: {
      "fluid": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "input-group input-group--text-field input-group--single-line"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barra),
      expression: "barra"
    }],
    ref: "search",
    attrs: {
      "tabindex": "0",
      "label": "cod.Producto",
      "type": "text",
      "placeholder": "cod.",
      "disabled": _vm.validatefactura
    },
    domProps: {
      "value": (_vm.barra)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchproducto($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barra = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group__details"
  }, [_c('div', {
    staticClass: "input-group__messages"
  })])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "precio",
      "disabled": ""
    },
    model: {
      value: (_vm.precio),
      callback: function($$v) {
        _vm.precio = $$v
      },
      expression: "precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "producto",
      "disabled": ""
    },
    model: {
      value: (_vm.producto.producto),
      callback: function($$v) {
        _vm.$set(_vm.producto, "producto", $$v)
      },
      expression: "producto.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    ref: "cantidad",
    attrs: {
      "type": "number",
      "singleLine": "",
      "label": "cantidad",
      "min": "1"
    },
    on: {
      "change": function($event) {
        return _vm.checklista()
      },
      "keyup": [_vm.checklista, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardarventa($event)
      }]
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presentacion),
      expression: "presentacion"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.presentacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.presentaciones), function(press) {
    return _c('option', {
      domProps: {
        "value": press
      }
    }, [_vm._v("\n                " + _vm._s(press.presentacion) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select xs6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listado),
      expression: "listado"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.producto.listaprecios), function(lista) {
    return _c('option', {
      domProps: {
        "value": lista
      }
    }, [_vm._v("\n                " + _vm._s(lista.lista.nombre) + "\n              ")])
  }), 0)])]), _vm._v(" "), (!_vm.grabando) ? _c('v-flex', {
    staticClass: "justify-center",
    attrs: {
      "hidden-md-and-up": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarventa
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasfactura),
      expression: "hasfactura"
    }],
    staticClass: "factura__detalle"
  }, [_c('v-flex', {
    staticClass: "tabla",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table text-md-center"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.headers), function(header) {
    return _c('th', [_vm._v(" " + _vm._s(header.text))])
  })], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.lineas), function(linea) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": "",
        "disabled": _vm.eliminando
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(linea)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.cantidad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.presentacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.producto_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.precio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(linea.precio * linea.cantidad, 'Q')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "factura__detalle__total"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], 2)])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Datos Factura")])]), _vm._v(" "), _c('v-card-text', [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-alert', {
    attrs: {
      "success": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_success) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Total: Q." + _vm._s(_vm.total))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Efectivo",
      "autofocus": "true"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardardatosfactura($event)
      }
    },
    model: {
      value: (_vm.efectivo),
      callback: function($$v) {
        _vm.efectivo = $$v
      },
      expression: "efectivo"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "primary--text"
  }, [_vm._v("Cambio: Q." + _vm._s(_vm.cambio))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardardatosfactura($event)
      }
    }
  }, [_vm._v("Imprimir")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirelectronica($event)
      }
    }
  }, [_vm._v(" Electrónica")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Escribir Observación")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cambiarcomentario($event)
      }
    },
    model: {
      value: (_vm.factura.observaciones),
      callback: function($$v) {
        _vm.$set(_vm.factura, "observaciones", $$v)
      },
      expression: "factura.observaciones"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.cambiarcomentario
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.messagemotivo),
      callback: function($$v) {
        _vm.messagemotivo = $$v
      },
      expression: "messagemotivo"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo por el que no compro")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('label', {
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.factura.observacionesmotivo),
      expression: "factura.observacionesmotivo"
    }],
    attrs: {
      "id": "motivo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.factura, "observacionesmotivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.cambiarcomentariomotivo]
    }
  }, _vm._l((_vm.motivos), function(motivo) {
    return _c('option', {
      domProps: {
        "value": motivo
      }
    }, [_vm._v("\n                " + _vm._s(motivo) + "\n              ")])
  }), 0)])])], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.cambiarcomentariomotivo
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogEditarCliente),
      callback: function($$v) {
        _vm.dialogEditarCliente = $$v
      },
      expression: "dialogEditarCliente"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Editar Cliente")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Nombre:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.nombre),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nombre", $$v)
      },
      expression: "cliente.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nit:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.nit),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nit", $$v)
      },
      expression: "cliente.nit"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Teléfono:",
      "type": "tel",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.telefono),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "telefono", $$v)
      },
      expression: "cliente.telefono"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Correo:",
      "type": "email",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.correo),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "correo", $$v)
      },
      expression: "cliente.correo"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Dirección:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.direccion),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "direccion", $$v)
      },
      expression: "cliente.direccion"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Referencia:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.referencia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "referencia", $$v)
      },
      expression: "cliente.referencia"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogEditarCliente = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.guardarcliente
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogEditarCliente = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "enletras",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("TOTAL EN LETRAS: " + _vm._s(_vm.numerosaletras))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Vendedor: " + _vm._s(_vm.factura.usuario.username))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary justify-center"
  }, [_c('v-container', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fluid": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "center": "",
      "right": ""
    },
    on: {
      "click": _vm.redireccion
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "white--text text-xs-center"
  }, [_vm._v("Cotizaciones")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Desde",
      "prepend-icon": "event",
      "data-vv-delay": "100",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechafin()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "buscar",
      "label": "Buscar"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcotizacion($event)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Total")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cotizaciones.results), function(cotizacion) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(cotizacion)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarcotizacion(cotizacion)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(cotizacion.cliente))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(cotizacion.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("Q. " + _vm._s(cotizacion.total_cotizacion))])])
  }), 0)])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.cotizaciones.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.cotizaciones.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.cotizaciones.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.cotizaciones.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "offset-md4": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Login")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-5",
    attrs: {
      "label": "Usuario"
    },
    model: {
      value: (_vm.login.username),
      callback: function($$v) {
        _vm.$set(_vm.login, "username", $$v)
      },
      expression: "login.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-5",
    attrs: {
      "label": "contraseña",
      "type": "password",
      "rules": _vm.error_login
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loguear($event)
      }
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "dark": ""
    },
    on: {
      "click": _vm.loguear
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary justify-center"
  }, [_c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('h6', {
    staticClass: "white--text text-xs-center"
  }, [_vm._v("Clientes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dias,
      "dark": "",
      "label": "Día:",
      "itemText": "text",
      "itemValue": "value"
    },
    on: {
      "change": function($event) {
        return _vm.filtrardia($event)
      }
    },
    model: {
      value: (_vm.dia),
      callback: function($$v) {
        _vm.dia = $$v
      },
      expression: "dia"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.semanas,
      "dark": "",
      "label": "Semana:",
      "itemText": "text",
      "itemValue": "value"
    },
    on: {
      "change": function($event) {
        return _vm.filtrarsemana($event)
      }
    },
    model: {
      value: (_vm.semana),
      callback: function($$v) {
        _vm.semana = $$v
      },
      expression: "semana"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rutas,
      "itemText": "nombre",
      "label": "Rutas",
      "single-line": "",
      "bottom": "",
      "dark": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarruta($event)
      }
    },
    model: {
      value: (_vm.ruta),
      callback: function($$v) {
        _vm.ruta = $$v
      },
      expression: "ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "input-1",
      "prepend-icon": "search",
      "label-icon": "search"
    },
    on: {
      "keyup": _vm.buscar
    },
    model: {
      value: (_vm.busqueda),
      callback: function($$v) {
        _vm.busqueda = $$v
      },
      expression: "busqueda"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (!_vm.editarorden) ? _c('v-btn', {
    staticClass: "blue",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "center": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editarorden = !_vm.editarorden
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarorden) ? _c('v-btn', {
    staticClass: "red",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "center": ""
    },
    on: {
      "click": _vm.guardartodo
    },
    nativeOn: {
      "click": function($event) {
        _vm.editarorden = !_vm.editarorden
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editarorden),
      expression: "editarorden"
    }]
  }, [_vm._v("nuevo")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Direccion")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("ultima compra")]), _vm._v(" "), _c('th', [_vm._v("deuda")]), _vm._v(" "), _c('th', [_vm._v("Orden")]), _vm._v(" "), _c('th', [_vm._v("Ubicacion")])]), _vm._v(" "), _c('tbody', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.clientes.results), function(cliente) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "red--text text--darken-2 btn--small",
      attrs: {
        "icon": "",
        "pa-0": "",
        "ma-0": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(cliente)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "blue--text text--darken-2 ",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editar(cliente)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), (_vm.editarorden) ? _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_c('v-text-field', {
      attrs: {
        "label": "",
        "singleLine": ""
      },
      on: {
        "input": function($event) {
          return _vm.guardarorden($event, cliente)
        }
      },
      model: {
        value: (cliente.orden),
        callback: function($$v) {
          _vm.$set(cliente, "orden", $$v)
        },
        expression: "cliente.orden"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ",
      class: cliente.malcliente ? 'red--text' : cliente.zero_last3 === 3 ? 'orange--text' : 'black--text',
      on: {
        "click": function($event) {
          return _vm.crearfactura(cliente)
        }
      }
    }, [_vm._v(_vm._s(cliente.nombre))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ",
      class: cliente.malcliente ? 'red--text' : cliente.zero_last3 === 3 ? 'orange--text' : 'black--text'
    }, [_vm._v(_vm._s(cliente.direccion_completa))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(cliente.codigo))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(cliente.ultima))]), _vm._v(" "), (cliente.debe) ? _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0 red--text"
    }, [_vm._v(_vm._s(cliente.total))]) : _vm._e(), _vm._v(" "), (!cliente.debe) ? _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(cliente.total))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(cliente.orden))]), _vm._v(" "), (cliente.estado_ubiacion) ? _c('td', {
      staticClass: "text-xs-center text-xs-center pa-0 ma-0 blue--text",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.actualizarubicacion(cliente.id)
        }
      }
    }, [_c('v-icon', {
      staticClass: "blue--text",
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("place")])], 1) : _vm._e(), _vm._v(" "), (!cliente.estado_ubiacion) ? _c('td', {
      staticClass: "text-xs-center text-xs-center pa-0 ma-0 red--text",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.actualizarubicacion(cliente.id)
        }
      }
    }, [_c('v-icon', {
      staticClass: "red--text",
      attrs: {
        "color": "red"
      }
    }, [_vm._v("place")])], 1) : _vm._e()])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.clientes.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.clientes.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.clientes.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.clientes.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(" Cliente ")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Nombre:",
      "required": "",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.nombre),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nombre", $$v)
      },
      expression: "cliente.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nit:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.nit),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nit", $$v)
      },
      expression: "cliente.nit"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.listaDepartamentos,
      "label": "Departamento:*",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.departamento),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "departamento", $$v)
      },
      expression: "cliente.departamento"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.municipios,
      "label": "Municipio:*",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.municipio),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "municipio", $$v)
      },
      expression: "cliente.municipio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Avenida:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.avenida),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "avenida", $$v)
      },
      expression: "cliente.avenida"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Calle:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.calle),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "calle", $$v)
      },
      expression: "cliente.calle"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.zonas,
      "label": "Zona:",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.zona),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "zona", $$v)
      },
      expression: "cliente.zona"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Barrio o Aldea:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.barrio_aldea),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "barrio_aldea", $$v)
      },
      expression: "cliente.barrio_aldea"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Colonia o Caserío:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.colonia_caserio),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "colonia_caserio", $$v)
      },
      expression: "cliente.colonia_caserio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Direccion:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.direccion),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "direccion", $$v)
      },
      expression: "cliente.direccion"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Referencia:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.referencia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "referencia", $$v)
      },
      expression: "cliente.referencia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Correo:",
      "type": "email",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.correo),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "correo", $$v)
      },
      expression: "cliente.correo "
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Teléfono:",
      "type": "tel",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.telefono),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "telefono", $$v)
      },
      expression: "cliente.telefono"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Orden:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.orden),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "orden", $$v)
      },
      expression: "cliente.orden"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.dias,
      "label": "Día:",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.dia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "dia", $$v)
      },
      expression: "cliente.dia"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.semanas,
      "label": "Semana:",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.semana),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "semana", $$v)
      },
      expression: "cliente.semana"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar($event)
      }
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "",
      "disabled": !_vm.activadorcliente
    },
    on: {
      "click": _vm.editarcliente
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Reporte Ventas")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm1": "",
      "mr-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rutas,
      "itemText": "nombre",
      "value": _vm.ruta,
      "label": "Rutas",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarruta($event)
      },
      "update:value": function($event) {
        _vm.ruta = $event
      }
    },
    model: {
      value: (_vm.ruta),
      callback: function($$v) {
        _vm.ruta = $$v
      },
      expression: "ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mr-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.usuarios,
      "itemText": "username",
      "value": _vm.usuario,
      "label": "Usuario",
      "multiple": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarusuario($event)
      },
      "update:value": function($event) {
        _vm.usuario = $event
      }
    },
    model: {
      value: (_vm.usuario),
      callback: function($$v) {
        _vm.usuario = $$v
      },
      expression: "usuario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm1": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Desde",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "hora"
    },
    model: {
      value: (_vm.horainicio),
      callback: function($$v) {
        _vm.horainicio = $$v
      },
      expression: "horainicio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechafin()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "hora"
    },
    model: {
      value: (_vm.horafin),
      callback: function($$v) {
        _vm.horafin = $$v
      },
      expression: "horafin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm1": "",
      "ml-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Extra"
    },
    model: {
      value: (_vm.extra),
      callback: function($$v) {
        _vm.extra = $$v
      },
      expression: "extra"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "ml-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comentario"
    },
    model: {
      value: (_vm.comentario),
      callback: function($$v) {
        _vm.comentario = $$v
      },
      expression: "comentario"
    }
  })], 1), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.generar
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.generartabulacion
    }
  }, [_vm._v("\n                  Tabulación "), _c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.generarcomentarios
    }
  }, [_vm._v("\n                  Comentarios "), _c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.obteneridsfactura
    }
  }, [_vm._v("\n                  Factura Electrónica "), _c('v-icon', [_vm._v("save")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.generar('entregado')
      }
    }
  }, [_vm._v("\n                  No tocar"), _c('v-icon', [_vm._v("check")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.generarexcel
    }
  }, [_vm._v("\n                  excel"), _c('v-icon', [_vm._v("find_in_page")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tipo == 'admin' || _vm.tipo == 'secretaria' || _vm.tipo == 'vendedor') ? _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.focusbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_vm._v("Re Imprimir")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confirmación Administrador")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "contraseña",
      "type": "password",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.generar('entregado'), _vm.confirmacion, _vm.nombre_tabulacion
      }
    },
    model: {
      value: (_vm.confirmacion),
      callback: function($$v) {
        _vm.confirmacion = $$v
      },
      expression: "confirmacion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre de la tabulación",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.generar('entregado'), _vm.confirmacion, _vm.nombre_tabulacion
      }
    },
    model: {
      value: (_vm.nombre_tabulacion),
      callback: function($$v) {
        _vm.nombre_tabulacion = $$v
      },
      expression: "nombre_tabulacion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false, _vm.confirmacion = '', _vm.nombre_tabulacion = ''
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "example-2",
      "standalone": ""
    }
  }, [(_vm.islogin) ? _c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "mini-variant": _vm.mini,
      "light": "",
      "overflow": "",
      "absolute": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      },
      "update:mini-variant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/men/85.jpg"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Distribuidora Emanuel")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(_vm._s(_vm.usuario))])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "to": item.url
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "success": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Cerrar sesion")])], 1) : _vm._e(), _vm._v(" "), (_vm.islogin) ? _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/"
    }
  }, [_vm._v("Distribuidora Emanuel")])], 1), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(_vm._s(_vm.usuario))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'admin' | _vm.tipo === 'secretaria'),
      expression: "tipo === 'admin' | tipo === 'secretaria'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/factura"
    }
  }, [_vm._v("Factura")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/buscador"
    }
  }, [_vm._v("Buscador")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/clientes"
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/reportes"
    }
  }, [_vm._v("Reportes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometraje"
    }
  }, [_vm._v("Kilometraje")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometrajevendedor"
    }
  }, [_vm._v("Kilometraje Vendedor")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/anularfacturas"
    }
  }, [_vm._v("Anular Facturas")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/cotizacion"
    }
  }, [_vm._v("Cotización")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/compratemporal"
    }
  }, [_vm._v("Compra")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/devoluciones"
    }
  }, [_vm._v("Devoluciones")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'gerente' | _vm.tipo === 'bodeguero'),
      expression: "tipo === 'gerente' | tipo === 'bodeguero'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/factura"
    }
  }, [_vm._v("Factura")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/buscador"
    }
  }, [_vm._v("Buscador")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/compratemporal"
    }
  }, [_vm._v("Compra")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/devoluciones"
    }
  }, [_vm._v("Devoluciones")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'vendedor'),
      expression: "tipo === 'vendedor'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/factura"
    }
  }, [_vm._v("Factura")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/clientes"
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/reporteventas"
    }
  }, [_vm._v("Reportes de ventas")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/extraccion"
    }
  }, [_vm._v("Extraer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/cuadrar"
    }
  }, [_vm._v("Cuadrar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometrajevendedor"
    }
  }, [_vm._v("Kilometraje Vendedor")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'chofer'),
      expression: "tipo === 'chofer'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometraje"
    }
  }, [_vm._v("Kilometraje")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/anularfacturas"
    }
  }, [_vm._v("Anular Facturas")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/devoluciones"
    }
  }, [_vm._v("Devoluciones")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Cerrar sesion")])], 1) : _vm._e(), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Kilometraje")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n            +\n       ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Vehículo")]), _vm._v(" "), _c('th', [_vm._v("Kilometraje Inicial")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'admin'),
      expression: "tipo === 'admin'"
    }]
  }, [_vm._v("Kilometraje Final")]), _vm._v(" "), _c('th', [_vm._v("Total Facturas")]), _vm._v(" "), _c('th', [_vm._v("Comentario")])]), _vm._v(" "), _c('tbody', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.kilometraje.results), function(kilometraje) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "red--text text--darken-2 btn--small",
      attrs: {
        "icon": "",
        "pa-0": "",
        "ma-0": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(kilometraje)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "blue--text text--darken-2 ",
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(_vm._f("formatDate2")(kilometraje.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.auto_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.kilometraje_inicial))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tipo == 'admin'),
        expression: "tipo=='admin'"
      }],
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(kilometraje.kilometrage))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.total_facturas))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.comentario))])])
  }), 0)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(" Kilometraje ")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Kilometraje Inicial:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje_inicial),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje_inicial", $$v)
      },
      expression: "akilometraje.kilometraje_inicial"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Kilometraje:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje", $$v)
      },
      expression: "akilometraje.kilometraje"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Total Facturas:"
    },
    model: {
      value: (_vm.akilometraje.total_facturas),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "total_facturas", $$v)
      },
      expression: "akilometraje.total_facturas"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Comentario:"
    },
    model: {
      value: (_vm.akilometraje.comentario),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "comentario", $$v)
      },
      expression: "akilometraje.comentario"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.vehiculos,
      "itemText": "auto_name",
      "value": _vm.vehiculo,
      "label": "Vehiculo",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "update:value": function($event) {
        _vm.vehiculo = $event
      }
    },
    model: {
      value: (_vm.vehiculo),
      callback: function($$v) {
        _vm.vehiculo = $$v
      },
      expression: "vehiculo"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Fecha",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.akilometraje.fecha),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "fecha", $$v)
      },
      expression: "akilometraje.fecha"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.akilometraje.fecha),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "fecha", $$v)
      },
      expression: "akilometraje.fecha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cerrar
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.editarkilometraje
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*",
      "capture": "environment"
    },
    on: {
      "change": _vm.onChangeInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Kilometraje Vendedor")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n            +\n       ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Usuario")]), _vm._v(" "), _c('th', [_vm._v("día")]), _vm._v(" "), _c('th', [_vm._v("semana")]), _vm._v(" "), _c('th', [_vm._v("Kilometraje Inicial")]), _vm._v(" "), _c('th', [_vm._v("Kilometraje Final")])]), _vm._v(" "), _c('tbody', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.kilometraje.results), function(kilometraje) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "red--text text--darken-2 btn--small",
      attrs: {
        "icon": "",
        "pa-0": "",
        "ma-0": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(kilometraje)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "blue--text text--darken-2 ",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editar(kilometraje)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(_vm._f("formatDate2")(kilometraje.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.user_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.dia))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.semana))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(kilometraje.kilometraje_inicial))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(kilometraje.kilometraje_final))])])
  }), 0)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(" Kilometraje ")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Kilometraje Inicial:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje_inicial),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje_inicial", $$v)
      },
      expression: "akilometraje.kilometraje_inicial"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Kilometraje Final:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje_final),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje_final", $$v)
      },
      expression: "akilometraje.kilometraje_final"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "día:"
    },
    model: {
      value: (_vm.akilometraje.dia),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "dia", $$v)
      },
      expression: "akilometraje.dia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Semana:"
    },
    model: {
      value: (_vm.akilometraje.semana),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "semana", $$v)
      },
      expression: "akilometraje.semana"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cerrar
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.editarkilometraje
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[300]);


// WEBPACK FOOTER //
// static/js/app.5ac84c67836647ea8d56.js